
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1f28"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1f28"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3WzGF", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $2df2789bdf0d1887$export$ffb0004e005737fa; }, function (v) { return $2df2789bdf0d1887$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $2df2789bdf0d1887$export$34b9dba7ce09269b; }, function (v) { return $2df2789bdf0d1887$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $2df2789bdf0d1887$export$25062201e9e25d76; }, function (v) { return $2df2789bdf0d1887$export$25062201e9e25d76 = v; });
/** @license React v17.0.1
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2df2789bdf0d1887$export$ffb0004e005737fa;
var $2df2789bdf0d1887$export$34b9dba7ce09269b;
var $2df2789bdf0d1887$export$25062201e9e25d76;
"use strict";
parcelRequire("gj7pJ");

var $jSIPP = parcelRequire("jSIPP");
var $2df2789bdf0d1887$var$g = 60103;
$2df2789bdf0d1887$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $2df2789bdf0d1887$var$h = Symbol.for;
    $2df2789bdf0d1887$var$g = $2df2789bdf0d1887$var$h("react.element");
    $2df2789bdf0d1887$export$ffb0004e005737fa = $2df2789bdf0d1887$var$h("react.fragment");
}
var $2df2789bdf0d1887$var$m = $jSIPP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $2df2789bdf0d1887$var$n = Object.prototype.hasOwnProperty, $2df2789bdf0d1887$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2df2789bdf0d1887$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$2df2789bdf0d1887$var$n.call(a, b) && !$2df2789bdf0d1887$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $2df2789bdf0d1887$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $2df2789bdf0d1887$var$m.current
    };
}
$2df2789bdf0d1887$export$34b9dba7ce09269b = $2df2789bdf0d1887$var$q;
$2df2789bdf0d1887$export$25062201e9e25d76 = $2df2789bdf0d1887$var$q;

});
parcelRegister("gj7pJ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $bdf42bf94e34cdc0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $bdf42bf94e34cdc0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $bdf42bf94e34cdc0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $bdf42bf94e34cdc0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $bdf42bf94e34cdc0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $bdf42bf94e34cdc0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $bdf42bf94e34cdc0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($bdf42bf94e34cdc0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($bdf42bf94e34cdc0$var$getOwnPropertySymbols) {
            symbols = $bdf42bf94e34cdc0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($bdf42bf94e34cdc0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("jSIPP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bTxSL"));

});
parcelRegister("bTxSL", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8a8f1d0ee34c5898$export$ffb0004e005737fa; }, function (v) { return $8a8f1d0ee34c5898$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8a8f1d0ee34c5898$export$5f8d39834fd61797; }, function (v) { return $8a8f1d0ee34c5898$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $8a8f1d0ee34c5898$export$e2c29f18771995cb; }, function (v) { return $8a8f1d0ee34c5898$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $8a8f1d0ee34c5898$export$74bf444e3cd11ea5; }, function (v) { return $8a8f1d0ee34c5898$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $8a8f1d0ee34c5898$export$dca3b0875bd9a954; }, function (v) { return $8a8f1d0ee34c5898$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8a8f1d0ee34c5898$export$16fa2f45be04daa8; }, function (v) { return $8a8f1d0ee34c5898$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8a8f1d0ee34c5898$export$221d75b3f55bb0bd; }, function (v) { return $8a8f1d0ee34c5898$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8a8f1d0ee34c5898$export$ae55be85d98224ed; }, function (v) { return $8a8f1d0ee34c5898$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8a8f1d0ee34c5898$export$e530037191fcd5d7; }, function (v) { return $8a8f1d0ee34c5898$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8a8f1d0ee34c5898$export$fd42f52fd3ae1109; }, function (v) { return $8a8f1d0ee34c5898$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8a8f1d0ee34c5898$export$c8a8987d4410bf2d; }, function (v) { return $8a8f1d0ee34c5898$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $8a8f1d0ee34c5898$export$d38cd72104c1f0e9; }, function (v) { return $8a8f1d0ee34c5898$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $8a8f1d0ee34c5898$export$7d1e3a5e95ceca43; }, function (v) { return $8a8f1d0ee34c5898$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8a8f1d0ee34c5898$export$257a8862b851cb5b; }, function (v) { return $8a8f1d0ee34c5898$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8a8f1d0ee34c5898$export$a8257692ac88316c; }, function (v) { return $8a8f1d0ee34c5898$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8a8f1d0ee34c5898$export$488013bae63b21da; }, function (v) { return $8a8f1d0ee34c5898$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8a8f1d0ee34c5898$export$7c73462e0d25e514; }, function (v) { return $8a8f1d0ee34c5898$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8a8f1d0ee34c5898$export$35808ee640e87ca7; }, function (v) { return $8a8f1d0ee34c5898$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8a8f1d0ee34c5898$export$fae74005e78b1a27; }, function (v) { return $8a8f1d0ee34c5898$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8a8f1d0ee34c5898$export$dc8fbce3eb94dc1e; }, function (v) { return $8a8f1d0ee34c5898$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $8a8f1d0ee34c5898$export$6d9c69b0de29b591; }, function (v) { return $8a8f1d0ee34c5898$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8a8f1d0ee34c5898$export$d5a552a76deda3c2; }, function (v) { return $8a8f1d0ee34c5898$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8a8f1d0ee34c5898$export$e5c5a5f917a5871c; }, function (v) { return $8a8f1d0ee34c5898$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8a8f1d0ee34c5898$export$1538c33de8887b59; }, function (v) { return $8a8f1d0ee34c5898$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $8a8f1d0ee34c5898$export$13e3392192263954; }, function (v) { return $8a8f1d0ee34c5898$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8a8f1d0ee34c5898$export$b8f5890fc79d6aca; }, function (v) { return $8a8f1d0ee34c5898$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8a8f1d0ee34c5898$export$60241385465d0a34; }, function (v) { return $8a8f1d0ee34c5898$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $8a8f1d0ee34c5898$export$83d89fbfd8236492; }, function (v) { return $8a8f1d0ee34c5898$export$83d89fbfd8236492 = v; });
/** @license React v17.0.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8a8f1d0ee34c5898$export$ffb0004e005737fa;
var $8a8f1d0ee34c5898$export$5f8d39834fd61797;
var $8a8f1d0ee34c5898$export$e2c29f18771995cb;
var $8a8f1d0ee34c5898$export$74bf444e3cd11ea5;
var $8a8f1d0ee34c5898$export$dca3b0875bd9a954;
var $8a8f1d0ee34c5898$export$16fa2f45be04daa8;
var $8a8f1d0ee34c5898$export$221d75b3f55bb0bd;
var $8a8f1d0ee34c5898$export$ae55be85d98224ed;
var $8a8f1d0ee34c5898$export$e530037191fcd5d7;
var $8a8f1d0ee34c5898$export$fd42f52fd3ae1109;
var $8a8f1d0ee34c5898$export$c8a8987d4410bf2d;
var $8a8f1d0ee34c5898$export$d38cd72104c1f0e9;
var $8a8f1d0ee34c5898$export$7d1e3a5e95ceca43;
var $8a8f1d0ee34c5898$export$257a8862b851cb5b;
var $8a8f1d0ee34c5898$export$a8257692ac88316c;
var $8a8f1d0ee34c5898$export$488013bae63b21da;
var $8a8f1d0ee34c5898$export$7c73462e0d25e514;
var $8a8f1d0ee34c5898$export$35808ee640e87ca7;
var $8a8f1d0ee34c5898$export$fae74005e78b1a27;
var $8a8f1d0ee34c5898$export$dc8fbce3eb94dc1e;
var $8a8f1d0ee34c5898$export$6d9c69b0de29b591;
var $8a8f1d0ee34c5898$export$d5a552a76deda3c2;
var $8a8f1d0ee34c5898$export$e5c5a5f917a5871c;
var $8a8f1d0ee34c5898$export$1538c33de8887b59;
var $8a8f1d0ee34c5898$export$13e3392192263954;
var $8a8f1d0ee34c5898$export$b8f5890fc79d6aca;
var $8a8f1d0ee34c5898$export$60241385465d0a34;
var $8a8f1d0ee34c5898$export$83d89fbfd8236492;
"use strict";

var $gj7pJ = parcelRequire("gj7pJ");
var $8a8f1d0ee34c5898$var$n = 60103, $8a8f1d0ee34c5898$var$p = 60106;
$8a8f1d0ee34c5898$export$ffb0004e005737fa = 60107;
$8a8f1d0ee34c5898$export$5f8d39834fd61797 = 60108;
$8a8f1d0ee34c5898$export$e2c29f18771995cb = 60114;
var $8a8f1d0ee34c5898$var$q = 60109, $8a8f1d0ee34c5898$var$r = 60110, $8a8f1d0ee34c5898$var$t = 60112;
$8a8f1d0ee34c5898$export$74bf444e3cd11ea5 = 60113;
var $8a8f1d0ee34c5898$var$u = 60115, $8a8f1d0ee34c5898$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $8a8f1d0ee34c5898$var$w = Symbol.for;
    $8a8f1d0ee34c5898$var$n = $8a8f1d0ee34c5898$var$w("react.element");
    $8a8f1d0ee34c5898$var$p = $8a8f1d0ee34c5898$var$w("react.portal");
    $8a8f1d0ee34c5898$export$ffb0004e005737fa = $8a8f1d0ee34c5898$var$w("react.fragment");
    $8a8f1d0ee34c5898$export$5f8d39834fd61797 = $8a8f1d0ee34c5898$var$w("react.strict_mode");
    $8a8f1d0ee34c5898$export$e2c29f18771995cb = $8a8f1d0ee34c5898$var$w("react.profiler");
    $8a8f1d0ee34c5898$var$q = $8a8f1d0ee34c5898$var$w("react.provider");
    $8a8f1d0ee34c5898$var$r = $8a8f1d0ee34c5898$var$w("react.context");
    $8a8f1d0ee34c5898$var$t = $8a8f1d0ee34c5898$var$w("react.forward_ref");
    $8a8f1d0ee34c5898$export$74bf444e3cd11ea5 = $8a8f1d0ee34c5898$var$w("react.suspense");
    $8a8f1d0ee34c5898$var$u = $8a8f1d0ee34c5898$var$w("react.memo");
    $8a8f1d0ee34c5898$var$v = $8a8f1d0ee34c5898$var$w("react.lazy");
}
var $8a8f1d0ee34c5898$var$x = "function" === typeof Symbol && Symbol.iterator;
function $8a8f1d0ee34c5898$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8a8f1d0ee34c5898$var$x && a[$8a8f1d0ee34c5898$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $8a8f1d0ee34c5898$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8a8f1d0ee34c5898$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8a8f1d0ee34c5898$var$B = {};
function $8a8f1d0ee34c5898$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8a8f1d0ee34c5898$var$B;
    this.updater = c || $8a8f1d0ee34c5898$var$A;
}
$8a8f1d0ee34c5898$var$C.prototype.isReactComponent = {};
$8a8f1d0ee34c5898$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($8a8f1d0ee34c5898$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8a8f1d0ee34c5898$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8a8f1d0ee34c5898$var$D() {}
$8a8f1d0ee34c5898$var$D.prototype = $8a8f1d0ee34c5898$var$C.prototype;
function $8a8f1d0ee34c5898$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8a8f1d0ee34c5898$var$B;
    this.updater = c || $8a8f1d0ee34c5898$var$A;
}
var $8a8f1d0ee34c5898$var$F = $8a8f1d0ee34c5898$var$E.prototype = new $8a8f1d0ee34c5898$var$D;
$8a8f1d0ee34c5898$var$F.constructor = $8a8f1d0ee34c5898$var$E;
$gj7pJ($8a8f1d0ee34c5898$var$F, $8a8f1d0ee34c5898$var$C.prototype);
$8a8f1d0ee34c5898$var$F.isPureReactComponent = !0;
var $8a8f1d0ee34c5898$var$G = {
    current: null
}, $8a8f1d0ee34c5898$var$H = Object.prototype.hasOwnProperty, $8a8f1d0ee34c5898$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8a8f1d0ee34c5898$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$8a8f1d0ee34c5898$var$H.call(b, e) && !$8a8f1d0ee34c5898$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $8a8f1d0ee34c5898$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $8a8f1d0ee34c5898$var$G.current
    };
}
function $8a8f1d0ee34c5898$var$K(a, b) {
    return {
        $$typeof: $8a8f1d0ee34c5898$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8a8f1d0ee34c5898$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8a8f1d0ee34c5898$var$n;
}
function $8a8f1d0ee34c5898$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8a8f1d0ee34c5898$var$M = /\/+/g;
function $8a8f1d0ee34c5898$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8a8f1d0ee34c5898$var$escape("" + a.key) : b.toString(36);
}
function $8a8f1d0ee34c5898$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8a8f1d0ee34c5898$var$n:
                case $8a8f1d0ee34c5898$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $8a8f1d0ee34c5898$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($8a8f1d0ee34c5898$var$M, "$&/") + "/"), $8a8f1d0ee34c5898$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($8a8f1d0ee34c5898$var$L(d) && (d = $8a8f1d0ee34c5898$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($8a8f1d0ee34c5898$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $8a8f1d0ee34c5898$var$N(k, g);
        h += $8a8f1d0ee34c5898$var$O(k, b, c, f, d);
    }
    else if (f = $8a8f1d0ee34c5898$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $8a8f1d0ee34c5898$var$N(k, g++), h += $8a8f1d0ee34c5898$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($8a8f1d0ee34c5898$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $8a8f1d0ee34c5898$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $8a8f1d0ee34c5898$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $8a8f1d0ee34c5898$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $8a8f1d0ee34c5898$var$R = {
    current: null
};
function $8a8f1d0ee34c5898$var$S() {
    var a = $8a8f1d0ee34c5898$var$R.current;
    if (null === a) throw Error($8a8f1d0ee34c5898$var$z(321));
    return a;
}
var $8a8f1d0ee34c5898$var$T = {
    ReactCurrentDispatcher: $8a8f1d0ee34c5898$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $8a8f1d0ee34c5898$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $gj7pJ
};
$8a8f1d0ee34c5898$export$dca3b0875bd9a954 = {
    map: $8a8f1d0ee34c5898$var$P,
    forEach: function(a, b, c) {
        $8a8f1d0ee34c5898$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $8a8f1d0ee34c5898$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $8a8f1d0ee34c5898$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$8a8f1d0ee34c5898$var$L(a)) throw Error($8a8f1d0ee34c5898$var$z(143));
        return a;
    }
};
$8a8f1d0ee34c5898$export$16fa2f45be04daa8 = $8a8f1d0ee34c5898$var$C;
$8a8f1d0ee34c5898$export$221d75b3f55bb0bd = $8a8f1d0ee34c5898$var$E;
$8a8f1d0ee34c5898$export$ae55be85d98224ed = $8a8f1d0ee34c5898$var$T;
$8a8f1d0ee34c5898$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($8a8f1d0ee34c5898$var$z(267, a));
    var e = $gj7pJ({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $8a8f1d0ee34c5898$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$8a8f1d0ee34c5898$var$H.call(b, f) && !$8a8f1d0ee34c5898$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $8a8f1d0ee34c5898$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$8a8f1d0ee34c5898$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $8a8f1d0ee34c5898$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $8a8f1d0ee34c5898$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$8a8f1d0ee34c5898$export$c8a8987d4410bf2d = $8a8f1d0ee34c5898$var$J;
$8a8f1d0ee34c5898$export$d38cd72104c1f0e9 = function(a) {
    var b = $8a8f1d0ee34c5898$var$J.bind(null, a);
    b.type = a;
    return b;
};
$8a8f1d0ee34c5898$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8a8f1d0ee34c5898$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8a8f1d0ee34c5898$var$t,
        render: a
    };
};
$8a8f1d0ee34c5898$export$a8257692ac88316c = $8a8f1d0ee34c5898$var$L;
$8a8f1d0ee34c5898$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8a8f1d0ee34c5898$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $8a8f1d0ee34c5898$var$Q
    };
};
$8a8f1d0ee34c5898$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8a8f1d0ee34c5898$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8a8f1d0ee34c5898$export$35808ee640e87ca7 = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useCallback(a, b);
};
$8a8f1d0ee34c5898$export$fae74005e78b1a27 = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useContext(a, b);
};
$8a8f1d0ee34c5898$export$dc8fbce3eb94dc1e = function() {};
$8a8f1d0ee34c5898$export$6d9c69b0de29b591 = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useEffect(a, b);
};
$8a8f1d0ee34c5898$export$d5a552a76deda3c2 = function(a, b, c) {
    return $8a8f1d0ee34c5898$var$S().useImperativeHandle(a, b, c);
};
$8a8f1d0ee34c5898$export$e5c5a5f917a5871c = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useLayoutEffect(a, b);
};
$8a8f1d0ee34c5898$export$1538c33de8887b59 = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useMemo(a, b);
};
$8a8f1d0ee34c5898$export$13e3392192263954 = function(a, b, c) {
    return $8a8f1d0ee34c5898$var$S().useReducer(a, b, c);
};
$8a8f1d0ee34c5898$export$b8f5890fc79d6aca = function(a) {
    return $8a8f1d0ee34c5898$var$S().useRef(a);
};
$8a8f1d0ee34c5898$export$60241385465d0a34 = function(a) {
    return $8a8f1d0ee34c5898$var$S().useState(a);
};
$8a8f1d0ee34c5898$export$83d89fbfd8236492 = "17.0.1";

});



parcelRegister("6r4il", function(module, exports) {

$parcel$export(module.exports, "SourceMapGenerator", function () { return $4af8988e0761dad4$export$4d99f7c30e854ff; }, function (v) { return $4af8988e0761dad4$export$4d99f7c30e854ff = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $4af8988e0761dad4$export$4d99f7c30e854ff;

var $a7I49 = parcelRequire("a7I49");

var $1dJ4X = parcelRequire("1dJ4X");

var $hdukB = parcelRequire("hdukB");
var $4af8988e0761dad4$require$ArraySet = $hdukB.ArraySet;

var $8CuDH = parcelRequire("8CuDH");
var $4af8988e0761dad4$require$MappingList = $8CuDH.MappingList;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */ function $4af8988e0761dad4$var$SourceMapGenerator(aArgs) {
    if (!aArgs) aArgs = {};
    this._file = $1dJ4X.getArg(aArgs, "file", null);
    this._sourceRoot = $1dJ4X.getArg(aArgs, "sourceRoot", null);
    this._skipValidation = $1dJ4X.getArg(aArgs, "skipValidation", false);
    this._sources = new $4af8988e0761dad4$require$ArraySet();
    this._names = new $4af8988e0761dad4$require$ArraySet();
    this._mappings = new $4af8988e0761dad4$require$MappingList();
    this._sourcesContents = null;
}
$4af8988e0761dad4$var$SourceMapGenerator.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */ $4af8988e0761dad4$var$SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new $4af8988e0761dad4$var$SourceMapGenerator({
        file: aSourceMapConsumer.file,
        sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function(mapping) {
        var newMapping = {
            generated: {
                line: mapping.generatedLine,
                column: mapping.generatedColumn
            }
        };
        if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) newMapping.source = $1dJ4X.relative(sourceRoot, newMapping.source);
            newMapping.original = {
                line: mapping.originalLine,
                column: mapping.originalColumn
            };
            if (mapping.name != null) newMapping.name = mapping.name;
        }
        generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var sourceRelative = sourceFile;
        if (sourceRoot !== null) sourceRelative = $1dJ4X.relative(sourceRoot, sourceFile);
        if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) generator.setSourceContent(sourceFile, content);
    });
    return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */ $4af8988e0761dad4$var$SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
    var generated = $1dJ4X.getArg(aArgs, "generated");
    var original = $1dJ4X.getArg(aArgs, "original", null);
    var source = $1dJ4X.getArg(aArgs, "source", null);
    var name = $1dJ4X.getArg(aArgs, "name", null);
    if (!this._skipValidation) this._validateMapping(generated, original, source, name);
    if (source != null) {
        source = String(source);
        if (!this._sources.has(source)) this._sources.add(source);
    }
    if (name != null) {
        name = String(name);
        if (!this._names.has(name)) this._names.add(name);
    }
    this._mappings.add({
        generatedLine: generated.line,
        generatedColumn: generated.column,
        originalLine: original != null && original.line,
        originalColumn: original != null && original.column,
        source: source,
        name: name
    });
};
/**
 * Set the source content for a source file.
 */ $4af8988e0761dad4$var$SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) source = $1dJ4X.relative(this._sourceRoot, source);
    if (aSourceContent != null) {
        // Add the source content to the _sourcesContents map.
        // Create a new _sourcesContents map if the property is null.
        if (!this._sourcesContents) this._sourcesContents = Object.create(null);
        this._sourcesContents[$1dJ4X.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
        // Remove the source file from the _sourcesContents map.
        // If the _sourcesContents map is empty, set the property to null.
        delete this._sourcesContents[$1dJ4X.toSetString(source)];
        if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
    }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */ $4af8988e0761dad4$var$SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
        if (aSourceMapConsumer.file == null) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
        sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) sourceFile = $1dJ4X.relative(sourceRoot, sourceFile);
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new $4af8988e0761dad4$require$ArraySet();
    var newNames = new $4af8988e0761dad4$require$ArraySet();
    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function(mapping) {
        if (mapping.source === sourceFile && mapping.originalLine != null) {
            // Check if it can be mapped by the source map, then update the mapping.
            var original = aSourceMapConsumer.originalPositionFor({
                line: mapping.originalLine,
                column: mapping.originalColumn
            });
            if (original.source != null) {
                // Copy mapping
                mapping.source = original.source;
                if (aSourceMapPath != null) mapping.source = $1dJ4X.join(aSourceMapPath, mapping.source);
                if (sourceRoot != null) mapping.source = $1dJ4X.relative(sourceRoot, mapping.source);
                mapping.originalLine = original.line;
                mapping.originalColumn = original.column;
                if (original.name != null) mapping.name = original.name;
            }
        }
        var source = mapping.source;
        if (source != null && !newSources.has(source)) newSources.add(source);
        var name = mapping.name;
        if (name != null && !newNames.has(name)) newNames.add(name);
    }, this);
    this._sources = newSources;
    this._names = newNames;
    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aSourceMapPath != null) sourceFile = $1dJ4X.join(aSourceMapPath, sourceFile);
            if (sourceRoot != null) sourceFile = $1dJ4X.relative(sourceRoot, sourceFile);
            this.setSourceContent(sourceFile, content);
        }
    }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */ $4af8988e0761dad4$var$SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
    if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) // Case 1.
    return;
    else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) // Cases 2 and 3.
    return;
    else throw new Error("Invalid mapping: " + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
    }));
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */ $4af8988e0761dad4$var$SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = "";
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;
    var mappings = this._mappings.toArray();
    for(var i = 0, len = mappings.length; i < len; i++){
        mapping = mappings[i];
        next = "";
        if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while(mapping.generatedLine !== previousGeneratedLine){
                next += ";";
                previousGeneratedLine++;
            }
        } else if (i > 0) {
            if (!$1dJ4X.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) continue;
            next += ",";
        }
        next += $a7I49.encode(mapping.generatedColumn - previousGeneratedColumn);
        previousGeneratedColumn = mapping.generatedColumn;
        if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += $a7I49.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            // lines are stored 0-based in SourceMap spec version 3
            next += $a7I49.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += $a7I49.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
                nameIdx = this._names.indexOf(mapping.name);
                next += $a7I49.encode(nameIdx - previousName);
                previousName = nameIdx;
            }
        }
        result += next;
    }
    return result;
};
$4af8988e0761dad4$var$SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function(source) {
        if (!this._sourcesContents) return null;
        if (aSourceRoot != null) source = $1dJ4X.relative(aSourceRoot, source);
        var key = $1dJ4X.toSetString(source);
        return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
    }, this);
};
/**
 * Externalize the source map.
 */ $4af8988e0761dad4$var$SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
    var map = {
        version: this._version,
        sources: this._sources.toArray(),
        names: this._names.toArray(),
        mappings: this._serializeMappings()
    };
    if (this._file != null) map.file = this._file;
    if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
    if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    return map;
};
/**
 * Render the source map being generated to a string.
 */ $4af8988e0761dad4$var$SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
};
$4af8988e0761dad4$export$4d99f7c30e854ff = $4af8988e0761dad4$var$SourceMapGenerator;

});
parcelRegister("a7I49", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $75ecbd6c74293389$export$c564cdbbe6da493; }, function (v) { return $75ecbd6c74293389$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $75ecbd6c74293389$export$2f872c0f2117be69; }, function (v) { return $75ecbd6c74293389$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $75ecbd6c74293389$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $75ecbd6c74293389$export$2f872c0f2117be69;

var $591xR = parcelRequire("591xR");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $75ecbd6c74293389$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $75ecbd6c74293389$var$VLQ_BASE = 1 << $75ecbd6c74293389$var$VLQ_BASE_SHIFT;
// binary: 011111
var $75ecbd6c74293389$var$VLQ_BASE_MASK = $75ecbd6c74293389$var$VLQ_BASE - 1;
// binary: 100000
var $75ecbd6c74293389$var$VLQ_CONTINUATION_BIT = $75ecbd6c74293389$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $75ecbd6c74293389$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $75ecbd6c74293389$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$75ecbd6c74293389$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $75ecbd6c74293389$var$toVLQSigned(aValue);
    do {
        digit = vlq & $75ecbd6c74293389$var$VLQ_BASE_MASK;
        vlq >>>= $75ecbd6c74293389$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $75ecbd6c74293389$var$VLQ_CONTINUATION_BIT;
        encoded += $591xR.encode(digit);
    }while (vlq > 0);
    return encoded;
};
$75ecbd6c74293389$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $591xR.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $75ecbd6c74293389$var$VLQ_CONTINUATION_BIT);
        digit &= $75ecbd6c74293389$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $75ecbd6c74293389$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $75ecbd6c74293389$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

});
parcelRegister("591xR", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $3beefddb36e3adfe$export$c564cdbbe6da493; }, function (v) { return $3beefddb36e3adfe$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $3beefddb36e3adfe$export$2f872c0f2117be69; }, function (v) { return $3beefddb36e3adfe$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $3beefddb36e3adfe$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $3beefddb36e3adfe$export$2f872c0f2117be69;
var $3beefddb36e3adfe$var$intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
$3beefddb36e3adfe$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $3beefddb36e3adfe$var$intToCharMap.length) return $3beefddb36e3adfe$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$3beefddb36e3adfe$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

});


parcelRegister("1dJ4X", function(module, exports) {

$parcel$export(module.exports, "getArg", function () { return $0e39f9110c5974e1$export$6e45e70adce70bb2; }, function (v) { return $0e39f9110c5974e1$export$6e45e70adce70bb2 = v; });
$parcel$export(module.exports, "urlParse", function () { return $0e39f9110c5974e1$export$d6e833647f7f5f17; }, function (v) { return $0e39f9110c5974e1$export$d6e833647f7f5f17 = v; });
$parcel$export(module.exports, "isAbsolute", function () { return $0e39f9110c5974e1$export$e434c7255acda994; }, function (v) { return $0e39f9110c5974e1$export$e434c7255acda994 = v; });
$parcel$export(module.exports, "normalize", function () { return $0e39f9110c5974e1$export$a3295358bff77e; }, function (v) { return $0e39f9110c5974e1$export$a3295358bff77e = v; });
$parcel$export(module.exports, "join", function () { return $0e39f9110c5974e1$export$f7e2c8231c57a8bd; }, function (v) { return $0e39f9110c5974e1$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "relative", function () { return $0e39f9110c5974e1$export$f0e7d1106eeabbe6; }, function (v) { return $0e39f9110c5974e1$export$f0e7d1106eeabbe6 = v; });
$parcel$export(module.exports, "toSetString", function () { return $0e39f9110c5974e1$export$be0fa1163fa7a4c; }, function (v) { return $0e39f9110c5974e1$export$be0fa1163fa7a4c = v; });
$parcel$export(module.exports, "fromSetString", function () { return $0e39f9110c5974e1$export$1fc47c3d4c3302a1; }, function (v) { return $0e39f9110c5974e1$export$1fc47c3d4c3302a1 = v; });
$parcel$export(module.exports, "compareByOriginalPositions", function () { return $0e39f9110c5974e1$export$273077902de92ff2; }, function (v) { return $0e39f9110c5974e1$export$273077902de92ff2 = v; });
$parcel$export(module.exports, "compareByGeneratedPositionsDeflated", function () { return $0e39f9110c5974e1$export$b7acf533941302f6; }, function (v) { return $0e39f9110c5974e1$export$b7acf533941302f6 = v; });
$parcel$export(module.exports, "compareByGeneratedPositionsInflated", function () { return $0e39f9110c5974e1$export$f9c43907549d61f1; }, function (v) { return $0e39f9110c5974e1$export$f9c43907549d61f1 = v; });
$parcel$export(module.exports, "parseSourceMapInput", function () { return $0e39f9110c5974e1$export$b49e2de2ad542732; }, function (v) { return $0e39f9110c5974e1$export$b49e2de2ad542732 = v; });
$parcel$export(module.exports, "computeSourceURL", function () { return $0e39f9110c5974e1$export$659a1aa8f1cdc036; }, function (v) { return $0e39f9110c5974e1$export$659a1aa8f1cdc036 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $0e39f9110c5974e1$export$6e45e70adce70bb2;
var $0e39f9110c5974e1$export$d6e833647f7f5f17;
var $0e39f9110c5974e1$export$2ec9abc2d2cac192;
var $0e39f9110c5974e1$export$a3295358bff77e;
var $0e39f9110c5974e1$export$f7e2c8231c57a8bd;
var $0e39f9110c5974e1$export$e434c7255acda994;
var $0e39f9110c5974e1$export$f0e7d1106eeabbe6;
var $0e39f9110c5974e1$export$be0fa1163fa7a4c;
var $0e39f9110c5974e1$export$1fc47c3d4c3302a1;
var $0e39f9110c5974e1$export$273077902de92ff2;
var $0e39f9110c5974e1$export$b7acf533941302f6;
var $0e39f9110c5974e1$export$f9c43907549d61f1;
var $0e39f9110c5974e1$export$b49e2de2ad542732;
var $0e39f9110c5974e1$export$659a1aa8f1cdc036;
function $0e39f9110c5974e1$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$0e39f9110c5974e1$export$6e45e70adce70bb2 = $0e39f9110c5974e1$var$getArg;
var $0e39f9110c5974e1$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var $0e39f9110c5974e1$var$dataUrlRegexp = /^data:.+\,.+$/;
function $0e39f9110c5974e1$var$urlParse(aUrl) {
    var match = aUrl.match($0e39f9110c5974e1$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$0e39f9110c5974e1$export$d6e833647f7f5f17 = $0e39f9110c5974e1$var$urlParse;
function $0e39f9110c5974e1$var$urlGenerate(aParsedUrl) {
    var url = "";
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ":";
    url += "//";
    if (aParsedUrl.auth) url += aParsedUrl.auth + "@";
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$0e39f9110c5974e1$export$2ec9abc2d2cac192 = $0e39f9110c5974e1$var$urlGenerate;
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ function $0e39f9110c5974e1$var$normalize(aPath) {
    var path = aPath;
    var url = $0e39f9110c5974e1$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $0e39f9110c5974e1$export$e434c7255acda994(path);
    var parts = path.split(/\/+/);
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === ".") parts.splice(i, 1);
        else if (part === "..") up++;
        else if (up > 0) {
            if (part === "") {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join("/");
    if (path === "") path = isAbsolute ? "/" : ".";
    if (url) {
        url.path = path;
        return $0e39f9110c5974e1$var$urlGenerate(url);
    }
    return path;
}
$0e39f9110c5974e1$export$a3295358bff77e = $0e39f9110c5974e1$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $0e39f9110c5974e1$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $0e39f9110c5974e1$var$urlParse(aPath);
    var aRootUrl = $0e39f9110c5974e1$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || "/";
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $0e39f9110c5974e1$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($0e39f9110c5974e1$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $0e39f9110c5974e1$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === "/" ? aPath : $0e39f9110c5974e1$var$normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $0e39f9110c5974e1$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$0e39f9110c5974e1$export$f7e2c8231c57a8bd = $0e39f9110c5974e1$var$join;
$0e39f9110c5974e1$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === "/" || $0e39f9110c5974e1$var$urlRegexp.test(aPath);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $0e39f9110c5974e1$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, "");
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + "/") !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$0e39f9110c5974e1$export$f0e7d1106eeabbe6 = $0e39f9110c5974e1$var$relative;
var $0e39f9110c5974e1$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !("__proto__" in obj);
}();
function $0e39f9110c5974e1$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $0e39f9110c5974e1$var$toSetString(aStr) {
    if ($0e39f9110c5974e1$var$isProtoString(aStr)) return "$" + aStr;
    return aStr;
}
$0e39f9110c5974e1$export$be0fa1163fa7a4c = $0e39f9110c5974e1$var$supportsNullProto ? $0e39f9110c5974e1$var$identity : $0e39f9110c5974e1$var$toSetString;
function $0e39f9110c5974e1$var$fromSetString(aStr) {
    if ($0e39f9110c5974e1$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$0e39f9110c5974e1$export$1fc47c3d4c3302a1 = $0e39f9110c5974e1$var$supportsNullProto ? $0e39f9110c5974e1$var$identity : $0e39f9110c5974e1$var$fromSetString;
function $0e39f9110c5974e1$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $0e39f9110c5974e1$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = $0e39f9110c5974e1$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $0e39f9110c5974e1$var$strcmp(mappingA.name, mappingB.name);
}
$0e39f9110c5974e1$export$273077902de92ff2 = $0e39f9110c5974e1$var$compareByOriginalPositions;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $0e39f9110c5974e1$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $0e39f9110c5974e1$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $0e39f9110c5974e1$var$strcmp(mappingA.name, mappingB.name);
}
$0e39f9110c5974e1$export$b7acf533941302f6 = $0e39f9110c5974e1$var$compareByGeneratedPositionsDeflated;
function $0e39f9110c5974e1$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 === null) return 1; // aStr2 !== null
    if (aStr2 === null) return -1; // aStr1 !== null
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $0e39f9110c5974e1$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $0e39f9110c5974e1$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $0e39f9110c5974e1$var$strcmp(mappingA.name, mappingB.name);
}
$0e39f9110c5974e1$export$f9c43907549d61f1 = $0e39f9110c5974e1$var$compareByGeneratedPositionsInflated;
/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */ function $0e39f9110c5974e1$var$parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ""));
}
$0e39f9110c5974e1$export$b49e2de2ad542732 = $0e39f9110c5974e1$var$parseSourceMapInput;
/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */ function $0e39f9110c5974e1$var$computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || "";
    if (sourceRoot) {
        // This follows what Chrome does.
        if (sourceRoot[sourceRoot.length - 1] !== "/" && sourceURL[0] !== "/") sourceRoot += "/";
        // The spec says:
        //   Line 4: An optional source root, useful for relocating source
        //   files on a server or removing repeated values in the
        //   “sources” entry.  This value is prepended to the individual
        //   entries in the “source” field.
        sourceURL = sourceRoot + sourceURL;
    }
    // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).
    if (sourceMapURL) {
        var parsed = $0e39f9110c5974e1$var$urlParse(sourceMapURL);
        if (!parsed) throw new Error("sourceMapURL could not be parsed");
        if (parsed.path) {
            // Strip the last path component, but keep the "/".
            var index = parsed.path.lastIndexOf("/");
            if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
        }
        sourceURL = $0e39f9110c5974e1$var$join($0e39f9110c5974e1$var$urlGenerate(parsed), sourceURL);
    }
    return $0e39f9110c5974e1$var$normalize(sourceURL);
}
$0e39f9110c5974e1$export$659a1aa8f1cdc036 = $0e39f9110c5974e1$var$computeSourceURL;

});

parcelRegister("hdukB", function(module, exports) {

$parcel$export(module.exports, "ArraySet", function () { return $c88b2dbcd20497e6$export$605bbf5ea7b60ba3; }, function (v) { return $c88b2dbcd20497e6$export$605bbf5ea7b60ba3 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $c88b2dbcd20497e6$export$605bbf5ea7b60ba3;

var $1dJ4X = parcelRequire("1dJ4X");
var $c88b2dbcd20497e6$var$has = Object.prototype.hasOwnProperty;
var $c88b2dbcd20497e6$var$hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $c88b2dbcd20497e6$var$ArraySet() {
    this._array = [];
    this._set = $c88b2dbcd20497e6$var$hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $c88b2dbcd20497e6$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $c88b2dbcd20497e6$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $c88b2dbcd20497e6$var$ArraySet.prototype.size = function ArraySet_size() {
    return $c88b2dbcd20497e6$var$hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $c88b2dbcd20497e6$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $c88b2dbcd20497e6$var$hasNativeMap ? aStr : $1dJ4X.toSetString(aStr);
    var isDuplicate = $c88b2dbcd20497e6$var$hasNativeMap ? this.has(aStr) : $c88b2dbcd20497e6$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) {
        if ($c88b2dbcd20497e6$var$hasNativeMap) this._set.set(aStr, idx);
        else this._set[sStr] = idx;
    }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $c88b2dbcd20497e6$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    if ($c88b2dbcd20497e6$var$hasNativeMap) return this._set.has(aStr);
    else {
        var sStr = $1dJ4X.toSetString(aStr);
        return $c88b2dbcd20497e6$var$has.call(this._set, sStr);
    }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $c88b2dbcd20497e6$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    if ($c88b2dbcd20497e6$var$hasNativeMap) {
        var idx = this._set.get(aStr);
        if (idx >= 0) return idx;
    } else {
        var sStr = $1dJ4X.toSetString(aStr);
        if ($c88b2dbcd20497e6$var$has.call(this._set, sStr)) return this._set[sStr];
    }
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $c88b2dbcd20497e6$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error("No element indexed by " + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $c88b2dbcd20497e6$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$c88b2dbcd20497e6$export$605bbf5ea7b60ba3 = $c88b2dbcd20497e6$var$ArraySet;

});

parcelRegister("8CuDH", function(module, exports) {

$parcel$export(module.exports, "MappingList", function () { return $6469a3abc98f82eb$export$e82e0908843dd951; }, function (v) { return $6469a3abc98f82eb$export$e82e0908843dd951 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $6469a3abc98f82eb$export$e82e0908843dd951;

var $1dJ4X = parcelRequire("1dJ4X");
/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */ function $6469a3abc98f82eb$var$generatedPositionAfter(mappingA, mappingB) {
    // Optimized for most common case
    var lineA = mappingA.generatedLine;
    var lineB = mappingB.generatedLine;
    var columnA = mappingA.generatedColumn;
    var columnB = mappingB.generatedColumn;
    return lineB > lineA || lineB == lineA && columnB >= columnA || $1dJ4X.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */ function $6469a3abc98f82eb$var$MappingList() {
    this._array = [];
    this._sorted = true;
    // Serves as infimum
    this._last = {
        generatedLine: -1,
        generatedColumn: 0
    };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */ $6469a3abc98f82eb$var$MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */ $6469a3abc98f82eb$var$MappingList.prototype.add = function MappingList_add(aMapping) {
    if ($6469a3abc98f82eb$var$generatedPositionAfter(this._last, aMapping)) {
        this._last = aMapping;
        this._array.push(aMapping);
    } else {
        this._sorted = false;
        this._array.push(aMapping);
    }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */ $6469a3abc98f82eb$var$MappingList.prototype.toArray = function MappingList_toArray() {
    if (!this._sorted) {
        this._array.sort($1dJ4X.compareByGeneratedPositionsInflated);
        this._sorted = true;
    }
    return this._array;
};
$6469a3abc98f82eb$export$e82e0908843dd951 = $6469a3abc98f82eb$var$MappingList;

});


parcelRegister("edOZl", function(module, exports) {

$parcel$export(module.exports, "SourceMapConsumer", function () { return $a5a9d4cf2d0282f4$export$194e92554d04abdd; }, function (v) { return $a5a9d4cf2d0282f4$export$194e92554d04abdd = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $a5a9d4cf2d0282f4$export$194e92554d04abdd;
var $a5a9d4cf2d0282f4$export$bef6691594139a79;
var $a5a9d4cf2d0282f4$export$823525094e5b803c;

var $1dJ4X = parcelRequire("1dJ4X");

var $2BuUe = parcelRequire("2BuUe");

var $hdukB = parcelRequire("hdukB");
var $a5a9d4cf2d0282f4$require$ArraySet = $hdukB.ArraySet;

var $a7I49 = parcelRequire("a7I49");

var $hykOA = parcelRequire("hykOA");
var $a5a9d4cf2d0282f4$require$quickSort = $hykOA.quickSort;
function $a5a9d4cf2d0282f4$var$SourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $1dJ4X.parseSourceMapInput(aSourceMap);
    return sourceMap.sections != null ? new $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer(sourceMap, aSourceMapURL) : new $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}
$a5a9d4cf2d0282f4$var$SourceMapConsumer.fromSourceMap = function(aSourceMap, aSourceMapURL) {
    return $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype._version = 3;
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
$a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty($a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype, "_generatedMappings", {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__generatedMappings;
    }
});
$a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty($a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype, "_originalMappings", {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__originalMappings;
    }
});
$a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
};
$a5a9d4cf2d0282f4$var$SourceMapConsumer.GENERATED_ORDER = 1;
$a5a9d4cf2d0282f4$var$SourceMapConsumer.ORIGINAL_ORDER = 2;
$a5a9d4cf2d0282f4$var$SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
$a5a9d4cf2d0282f4$var$SourceMapConsumer.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */ $a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || $a5a9d4cf2d0282f4$var$SourceMapConsumer.GENERATED_ORDER;
    var mappings;
    switch(order){
        case $a5a9d4cf2d0282f4$var$SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
        case $a5a9d4cf2d0282f4$var$SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
        default:
            throw new Error("Unknown order of iteration.");
    }
    var sourceRoot = this.sourceRoot;
    mappings.map(function(mapping) {
        var source = mapping.source === null ? null : this._sources.at(mapping.source);
        source = $1dJ4X.computeSourceURL(sourceRoot, source, this._sourceMapURL);
        return {
            source: source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
        };
    }, this).forEach(aCallback, context);
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */ $a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = $1dJ4X.getArg(aArgs, "line");
    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
        source: $1dJ4X.getArg(aArgs, "source"),
        originalLine: line,
        originalColumn: $1dJ4X.getArg(aArgs, "column", 0)
    };
    needle.source = this._findSourceIndex(needle.source);
    if (needle.source < 0) return [];
    var mappings = [];
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $1dJ4X.compareByOriginalPositions, $2BuUe.LEAST_UPPER_BOUND);
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (aArgs.column === undefined) {
            var originalLine = mapping.originalLine;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we found. Since
            // mappings are sorted, this is guaranteed to find all mappings for
            // the line we found.
            while(mapping && mapping.originalLine === originalLine){
                mappings.push({
                    line: $1dJ4X.getArg(mapping, "generatedLine", null),
                    column: $1dJ4X.getArg(mapping, "generatedColumn", null),
                    lastColumn: $1dJ4X.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        } else {
            var originalColumn = mapping.originalColumn;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we were searching for.
            // Since mappings are sorted, this is guaranteed to find all mappings for
            // the line we are searching for.
            while(mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn){
                mappings.push({
                    line: $1dJ4X.getArg(mapping, "generatedLine", null),
                    column: $1dJ4X.getArg(mapping, "generatedColumn", null),
                    lastColumn: $1dJ4X.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        }
    }
    return mappings;
};
$a5a9d4cf2d0282f4$export$194e92554d04abdd = $a5a9d4cf2d0282f4$var$SourceMapConsumer;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */ function $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $1dJ4X.parseSourceMapInput(aSourceMap);
    var version = $1dJ4X.getArg(sourceMap, "version");
    var sources = $1dJ4X.getArg(sourceMap, "sources");
    // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
    // requires the array) to play nice here.
    var names = $1dJ4X.getArg(sourceMap, "names", []);
    var sourceRoot = $1dJ4X.getArg(sourceMap, "sourceRoot", null);
    var sourcesContent = $1dJ4X.getArg(sourceMap, "sourcesContent", null);
    var mappings = $1dJ4X.getArg(sourceMap, "mappings");
    var file = $1dJ4X.getArg(sourceMap, "file", null);
    // Once again, Sass deviates from the spec and supplies the version as a
    // string rather than a number, so we use loose equality checking here.
    if (version != this._version) throw new Error("Unsupported version: " + version);
    if (sourceRoot) sourceRoot = $1dJ4X.normalize(sourceRoot);
    sources = sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map($1dJ4X.normalize)// Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function(source) {
        return sourceRoot && $1dJ4X.isAbsolute(sourceRoot) && $1dJ4X.isAbsolute(source) ? $1dJ4X.relative(sourceRoot, source) : source;
    });
    // Pass `true` below to allow duplicate names and sources. While source maps
    // are intended to be compressed and deduplicated, the TypeScript compiler
    // sometimes generates source maps with duplicates in them. See Github issue
    // #72 and bugzil.la/889492.
    this._names = $a5a9d4cf2d0282f4$require$ArraySet.fromArray(names.map(String), true);
    this._sources = $a5a9d4cf2d0282f4$require$ArraySet.fromArray(sources, true);
    this._absoluteSources = this._sources.toArray().map(function(s) {
        return $1dJ4X.computeSourceURL(sourceRoot, s, aSourceMapURL);
    });
    this.sourceRoot = sourceRoot;
    this.sourcesContent = sourcesContent;
    this._mappings = mappings;
    this._sourceMapURL = aSourceMapURL;
    this.file = file;
}
$a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype = Object.create($a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype);
$a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype.consumer = $a5a9d4cf2d0282f4$var$SourceMapConsumer;
/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = $1dJ4X.relative(this.sourceRoot, relativeSource);
    if (this._sources.has(relativeSource)) return this._sources.indexOf(relativeSource);
    // Maybe aSource is an absolute URL as returned by |sources|.  In
    // this case we can't simply undo the transform.
    var i;
    for(i = 0; i < this._absoluteSources.length; ++i){
        if (this._absoluteSources[i] == aSource) return i;
    }
    return -1;
};
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
    var smc = Object.create($a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype);
    var names = smc._names = $a5a9d4cf2d0282f4$require$ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = $a5a9d4cf2d0282f4$require$ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
    smc.file = aSourceMap._file;
    smc._sourceMapURL = aSourceMapURL;
    smc._absoluteSources = smc._sources.toArray().map(function(s) {
        return $1dJ4X.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
    });
    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.
    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];
    for(var i = 0, length = generatedMappings.length; i < length; i++){
        var srcMapping = generatedMappings[i];
        var destMapping = new $a5a9d4cf2d0282f4$var$Mapping;
        destMapping.generatedLine = srcMapping.generatedLine;
        destMapping.generatedColumn = srcMapping.generatedColumn;
        if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
            destOriginalMappings.push(destMapping);
        }
        destGeneratedMappings.push(destMapping);
    }
    $a5a9d4cf2d0282f4$require$quickSort(smc.__originalMappings, $1dJ4X.compareByOriginalPositions);
    return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype, "sources", {
    get: function() {
        return this._absoluteSources.slice();
    }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */ function $a5a9d4cf2d0282f4$var$Mapping() {
    this.generatedLine = 0;
    this.generatedColumn = 0;
    this.source = null;
    this.originalLine = null;
    this.originalColumn = null;
    this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;
    while(index < length){
        if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
        } else if (aStr.charAt(index) === ",") index++;
        else {
            mapping = new $a5a9d4cf2d0282f4$var$Mapping();
            mapping.generatedLine = generatedLine;
            // Because each offset is encoded relative to the previous one,
            // many segments often have the same encoding. We can exploit this
            // fact by caching the parsed variable length fields of each segment,
            // allowing us to avoid a second parse if we encounter the same
            // segment again.
            for(end = index; end < length; end++){
                if (this._charIsMappingSeparator(aStr, end)) break;
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) index += str.length;
            else {
                segment = [];
                while(index < end){
                    $a7I49.decode(aStr, index, temp);
                    value = temp.value;
                    index = temp.rest;
                    segment.push(value);
                }
                if (segment.length === 2) throw new Error("Found a source, but no line and column");
                if (segment.length === 3) throw new Error("Found a source and line, but no column");
                cachedSegments[str] = segment;
            }
            // Generated column.
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
                // Original source.
                mapping.source = previousSource + segment[1];
                previousSource += segment[1];
                // Original line.
                mapping.originalLine = previousOriginalLine + segment[2];
                previousOriginalLine = mapping.originalLine;
                // Lines are stored 0-based
                mapping.originalLine += 1;
                // Original column.
                mapping.originalColumn = previousOriginalColumn + segment[3];
                previousOriginalColumn = mapping.originalColumn;
                if (segment.length > 4) {
                    // Original name.
                    mapping.name = previousName + segment[4];
                    previousName += segment[4];
                }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") originalMappings.push(mapping);
        }
    }
    $a5a9d4cf2d0282f4$require$quickSort(generatedMappings, $1dJ4X.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;
    $a5a9d4cf2d0282f4$require$quickSort(originalMappings, $1dJ4X.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.
    if (aNeedle[aLineName] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
    if (aNeedle[aColumnName] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
    return $2BuUe.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
    for(var index = 0; index < this._generatedMappings.length; ++index){
        var mapping = this._generatedMappings[index];
        // Mappings do not contain a field for the last generated columnt. We
        // can come up with an optimistic estimate, however, by assuming that
        // mappings are contiguous (i.e. given two consecutive mappings, the
        // first mapping ends where the second one starts).
        if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
                mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
                continue;
            }
        }
        // The last mapping for each line spans the entire line.
        mapping.lastGeneratedColumn = Infinity;
    }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $1dJ4X.getArg(aArgs, "line"),
        generatedColumn: $1dJ4X.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", $1dJ4X.compareByGeneratedPositionsDeflated, $1dJ4X.getArg(aArgs, "bias", $a5a9d4cf2d0282f4$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._generatedMappings[index];
        if (mapping.generatedLine === needle.generatedLine) {
            var source = $1dJ4X.getArg(mapping, "source", null);
            if (source !== null) {
                source = this._sources.at(source);
                source = $1dJ4X.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
            }
            var name = $1dJ4X.getArg(mapping, "name", null);
            if (name !== null) name = this._names.at(name);
            return {
                source: source,
                line: $1dJ4X.getArg(mapping, "originalLine", null),
                column: $1dJ4X.getArg(mapping, "originalColumn", null),
                name: name
            };
        }
    }
    return {
        source: null,
        line: null,
        column: null,
        name: null
    };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) return false;
    return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
        return sc == null;
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) return null;
    var index = this._findSourceIndex(aSource);
    if (index >= 0) return this.sourcesContent[index];
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = $1dJ4X.relative(this.sourceRoot, relativeSource);
    var url;
    if (this.sourceRoot != null && (url = $1dJ4X.urlParse(this.sourceRoot))) {
        // XXX: file:// URIs and absolute paths lead to unexpected behavior for
        // many users. We can help them out when they expect file:// URIs to
        // behave like it would if they were running a local HTTP server. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
        var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
        if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
        if ((!url.path || url.path == "/") && this._sources.has("/" + relativeSource)) return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
    }
    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) return null;
    else throw new Error('"' + relativeSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = $1dJ4X.getArg(aArgs, "source");
    source = this._findSourceIndex(source);
    if (source < 0) return {
        line: null,
        column: null,
        lastColumn: null
    };
    var needle = {
        source: source,
        originalLine: $1dJ4X.getArg(aArgs, "line"),
        originalColumn: $1dJ4X.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $1dJ4X.compareByOriginalPositions, $1dJ4X.getArg(aArgs, "bias", $a5a9d4cf2d0282f4$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (mapping.source === needle.source) return {
            line: $1dJ4X.getArg(mapping, "generatedLine", null),
            column: $1dJ4X.getArg(mapping, "generatedColumn", null),
            lastColumn: $1dJ4X.getArg(mapping, "lastGeneratedColumn", null)
        };
    }
    return {
        line: null,
        column: null,
        lastColumn: null
    };
};
$a5a9d4cf2d0282f4$export$bef6691594139a79 = $a5a9d4cf2d0282f4$var$BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */ function $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $1dJ4X.parseSourceMapInput(aSourceMap);
    var version = $1dJ4X.getArg(sourceMap, "version");
    var sections = $1dJ4X.getArg(sourceMap, "sections");
    if (version != this._version) throw new Error("Unsupported version: " + version);
    this._sources = new $a5a9d4cf2d0282f4$require$ArraySet();
    this._names = new $a5a9d4cf2d0282f4$require$ArraySet();
    var lastOffset = {
        line: -1,
        column: 0
    };
    this._sections = sections.map(function(s) {
        if (s.url) // The url field will require support for asynchronicity.
        // See https://github.com/mozilla/source-map/issues/16
        throw new Error("Support for url field in sections not implemented.");
        var offset = $1dJ4X.getArg(s, "offset");
        var offsetLine = $1dJ4X.getArg(offset, "line");
        var offsetColumn = $1dJ4X.getArg(offset, "column");
        if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error("Section offsets must be ordered and non-overlapping.");
        lastOffset = offset;
        return {
            generatedOffset: {
                // The offset fields are 0-based, but we use 1-based indices when
                // encoding/decoding from VLQ.
                generatedLine: offsetLine + 1,
                generatedColumn: offsetColumn + 1
            },
            consumer: new $a5a9d4cf2d0282f4$var$SourceMapConsumer($1dJ4X.getArg(s, "map"), aSourceMapURL)
        };
    });
}
$a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype = Object.create($a5a9d4cf2d0282f4$var$SourceMapConsumer.prototype);
$a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype.constructor = $a5a9d4cf2d0282f4$var$SourceMapConsumer;
/**
 * The version of the source mapping spec that we are consuming.
 */ $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype, "sources", {
    get: function() {
        var sources = [];
        for(var i = 0; i < this._sections.length; i++)for(var j = 0; j < this._sections[i].consumer.sources.length; j++)sources.push(this._sections[i].consumer.sources[j]);
        return sources;
    }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $1dJ4X.getArg(aArgs, "line"),
        generatedColumn: $1dJ4X.getArg(aArgs, "column")
    };
    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = $2BuUe.search(needle, this._sections, function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) return cmp;
        return needle.generatedColumn - section.generatedOffset.generatedColumn;
    });
    var section = this._sections[sectionIndex];
    if (!section) return {
        source: null,
        line: null,
        column: null,
        name: null
    };
    return section.consumer.originalPositionFor({
        line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
        column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        bias: aArgs.bias
    });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function(s) {
        return s.consumer.hasContentsOfAllSources();
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var content = section.consumer.sourceContentFor(aSource, true);
        if (content) return content;
    }
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        // Only consider this section if the requested source is in the list of
        // sources of the consumer.
        if (section.consumer._findSourceIndex($1dJ4X.getArg(aArgs, "source")) === -1) continue;
        var generatedPosition = section.consumer.generatedPositionFor(aArgs);
        if (generatedPosition) {
            var ret = {
                line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
                column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
        }
    }
    return {
        line: null,
        column: null
    };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var sectionMappings = section.consumer._generatedMappings;
        for(var j = 0; j < sectionMappings.length; j++){
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            source = $1dJ4X.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = null;
            if (mapping.name) {
                name = section.consumer._names.at(mapping.name);
                this._names.add(name);
                name = this._names.indexOf(name);
            }
            // The mappings coming from the consumer for the section have
            // generated positions relative to the start of the section, so we
            // need to offset them to be relative to the start of the concatenated
            // generated file.
            var adjustedMapping = {
                source: source,
                generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
                generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
                originalLine: mapping.originalLine,
                originalColumn: mapping.originalColumn,
                name: name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") this.__originalMappings.push(adjustedMapping);
        }
    }
    $a5a9d4cf2d0282f4$require$quickSort(this.__generatedMappings, $1dJ4X.compareByGeneratedPositionsDeflated);
    $a5a9d4cf2d0282f4$require$quickSort(this.__originalMappings, $1dJ4X.compareByOriginalPositions);
};
$a5a9d4cf2d0282f4$export$823525094e5b803c = $a5a9d4cf2d0282f4$var$IndexedSourceMapConsumer;

});
parcelRegister("2BuUe", function(module, exports) {

$parcel$export(module.exports, "GREATEST_LOWER_BOUND", function () { return $1e5702c759e49700$export$4ecd616dce182dff; }, function (v) { return $1e5702c759e49700$export$4ecd616dce182dff = v; });
$parcel$export(module.exports, "LEAST_UPPER_BOUND", function () { return $1e5702c759e49700$export$b99fbecff261243; }, function (v) { return $1e5702c759e49700$export$b99fbecff261243 = v; });
$parcel$export(module.exports, "search", function () { return $1e5702c759e49700$export$d76128d007d19019; }, function (v) { return $1e5702c759e49700$export$d76128d007d19019 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $1e5702c759e49700$export$4ecd616dce182dff;
var $1e5702c759e49700$export$b99fbecff261243;
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */ var $1e5702c759e49700$export$d76128d007d19019;
$1e5702c759e49700$export$4ecd616dce182dff = 1;
$1e5702c759e49700$export$b99fbecff261243 = 2;
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */ function $1e5702c759e49700$var$recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);
    if (cmp === 0) // Found the element we are looking for.
    return mid;
    else if (cmp > 0) {
        // Our needle is greater than aHaystack[mid].
        if (aHigh - mid > 1) // The element is in the upper half.
        return $1e5702c759e49700$var$recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
        // The exact needle element was not found in this haystack. Determine if
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $1e5702c759e49700$export$b99fbecff261243) return aHigh < aHaystack.length ? aHigh : -1;
        else return mid;
    } else {
        // Our needle is less than aHaystack[mid].
        if (mid - aLow > 1) // The element is in the lower half.
        return $1e5702c759e49700$var$recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $1e5702c759e49700$export$b99fbecff261243) return mid;
        else return aLow < 0 ? -1 : aLow;
    }
}
$1e5702c759e49700$export$d76128d007d19019 = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) return -1;
    var index = $1e5702c759e49700$var$recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || $1e5702c759e49700$export$4ecd616dce182dff);
    if (index < 0) return -1;
    // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.
    while(index - 1 >= 0){
        if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
        --index;
    }
    return index;
};

});

parcelRegister("hykOA", function(module, exports) {

$parcel$export(module.exports, "quickSort", function () { return $cc75c210de0d0d22$export$866270269b9544a5; }, function (v) { return $cc75c210de0d0d22$export$866270269b9544a5 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ // It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */ /**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */ var $cc75c210de0d0d22$export$866270269b9544a5;
function $cc75c210de0d0d22$var$swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */ function $cc75c210de0d0d22$var$randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */ function $cc75c210de0d0d22$var$doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
        // (1) Partitioning.
        //
        // The partitioning chooses a pivot between `p` and `r` and moves all
        // elements that are less than or equal to the pivot to the before it, and
        // all the elements that are greater than it after it. The effect is that
        // once partition is done, the pivot is in the exact place it will be when
        // the array is put in sorted order, and it will not need to be moved
        // again. This runs in O(n) time.
        // Always choose a random pivot so that an input array which is reverse
        // sorted does not cause O(n^2) running time.
        var pivotIndex = $cc75c210de0d0d22$var$randomIntInRange(p, r);
        var i = p - 1;
        $cc75c210de0d0d22$var$swap(ary, pivotIndex, r);
        var pivot = ary[r];
        // Immediately after `j` is incremented in this loop, the following hold
        // true:
        //
        //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
        //
        //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
        for(var j = p; j < r; j++)if (comparator(ary[j], pivot) <= 0) {
            i += 1;
            $cc75c210de0d0d22$var$swap(ary, i, j);
        }
        $cc75c210de0d0d22$var$swap(ary, i + 1, j);
        var q = i + 1;
        // (2) Recurse on each half.
        $cc75c210de0d0d22$var$doQuickSort(ary, comparator, p, q - 1);
        $cc75c210de0d0d22$var$doQuickSort(ary, comparator, q + 1, r);
    }
}
$cc75c210de0d0d22$export$866270269b9544a5 = function(ary, comparator) {
    $cc75c210de0d0d22$var$doQuickSort(ary, comparator, 0, ary.length - 1);
};

});


parcelRegister("aPQuV", function(module, exports) {

$parcel$export(module.exports, "SourceNode", function () { return $7e3763caf8ef32fd$export$7e987e8f375d24c2; }, function (v) { return $7e3763caf8ef32fd$export$7e987e8f375d24c2 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $7e3763caf8ef32fd$export$7e987e8f375d24c2;

var $6r4il = parcelRequire("6r4il");
var $7e3763caf8ef32fd$require$SourceMapGenerator = $6r4il.SourceMapGenerator;

var $1dJ4X = parcelRequire("1dJ4X");
// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var $7e3763caf8ef32fd$var$REGEX_NEWLINE = /(\r?\n)/;
// Newline character code for charCodeAt() comparisons
var $7e3763caf8ef32fd$var$NEWLINE_CODE = 10;
// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var $7e3763caf8ef32fd$var$isSourceNode = "$$$isSourceNode$$$";
/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */ function $7e3763caf8ef32fd$var$SourceNode(aLine, aColumn, aSource, aChunks, aName) {
    this.children = [];
    this.sourceContents = {};
    this.line = aLine == null ? null : aLine;
    this.column = aColumn == null ? null : aColumn;
    this.source = aSource == null ? null : aSource;
    this.name = aName == null ? null : aName;
    this[$7e3763caf8ef32fd$var$isSourceNode] = true;
    if (aChunks != null) this.add(aChunks);
}
/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */ $7e3763caf8ef32fd$var$SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new $7e3763caf8ef32fd$var$SourceNode();
    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split($7e3763caf8ef32fd$var$REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
        var lineContents = getNextLine();
        // The last line of a file might not have a newline.
        var newLine = getNextLine() || "";
        return lineContents + newLine;
        function getNextLine() {
            return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : undefined;
        }
    };
    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;
    aSourceMapConsumer.eachMapping(function(mapping) {
        if (lastMapping !== null) {
            // We add the code from "lastMapping" to "mapping":
            // First check if there is a new line in between.
            if (lastGeneratedLine < mapping.generatedLine) {
                // Associate first line with "lastMapping"
                addMappingWithCode(lastMapping, shiftNextLine());
                lastGeneratedLine++;
                lastGeneratedColumn = 0;
            // The remaining code is added without mapping
            } else {
                // There is no new line in between.
                // Associate the code between "lastGeneratedColumn" and
                // "mapping.generatedColumn" with "lastMapping"
                var nextLine = remainingLines[remainingLinesIndex] || "";
                var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
                remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
                lastGeneratedColumn = mapping.generatedColumn;
                addMappingWithCode(lastMapping, code);
                // No more remaining code, continue
                lastMapping = mapping;
                return;
            }
        }
        // We add the generated code until the first mapping
        // to the SourceNode without any mapping.
        // Each line is added as separate string.
        while(lastGeneratedLine < mapping.generatedLine){
            node.add(shiftNextLine());
            lastGeneratedLine++;
        }
        if (lastGeneratedColumn < mapping.generatedColumn) {
            var nextLine = remainingLines[remainingLinesIndex] || "";
            node.add(nextLine.substr(0, mapping.generatedColumn));
            remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
            lastGeneratedColumn = mapping.generatedColumn;
        }
        lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
        if (lastMapping) // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
        // and add the remaining lines without any mapping
        node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }
    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aRelativePath != null) sourceFile = $1dJ4X.join(aRelativePath, sourceFile);
            node.setSourceContent(sourceFile, content);
        }
    });
    return node;
    function addMappingWithCode(mapping, code) {
        if (mapping === null || mapping.source === undefined) node.add(code);
        else {
            var source = aRelativePath ? $1dJ4X.join(aRelativePath, mapping.source) : mapping.source;
            node.add(new $7e3763caf8ef32fd$var$SourceNode(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
        }
    }
};
/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.add = function SourceNode_add(aChunk) {
    if (Array.isArray(aChunk)) aChunk.forEach(function(chunk) {
        this.add(chunk);
    }, this);
    else if (aChunk[$7e3763caf8ef32fd$var$isSourceNode] || typeof aChunk === "string") {
        if (aChunk) this.children.push(aChunk);
    } else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
    if (Array.isArray(aChunk)) for(var i = aChunk.length - 1; i >= 0; i--)this.prepend(aChunk[i]);
    else if (aChunk[$7e3763caf8ef32fd$var$isSourceNode] || typeof aChunk === "string") this.children.unshift(aChunk);
    else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.walk = function SourceNode_walk(aFn) {
    var chunk;
    for(var i = 0, len = this.children.length; i < len; i++){
        chunk = this.children[i];
        if (chunk[$7e3763caf8ef32fd$var$isSourceNode]) chunk.walk(aFn);
        else if (chunk !== "") aFn(chunk, {
            source: this.source,
            line: this.line,
            column: this.column,
            name: this.name
        });
    }
};
/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.join = function SourceNode_join(aSep) {
    var newChildren;
    var i;
    var len = this.children.length;
    if (len > 0) {
        newChildren = [];
        for(i = 0; i < len - 1; i++){
            newChildren.push(this.children[i]);
            newChildren.push(aSep);
        }
        newChildren.push(this.children[i]);
        this.children = newChildren;
    }
    return this;
};
/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
    var lastChild = this.children[this.children.length - 1];
    if (lastChild[$7e3763caf8ef32fd$var$isSourceNode]) lastChild.replaceRight(aPattern, aReplacement);
    else if (typeof lastChild === "string") this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
    else this.children.push("".replace(aPattern, aReplacement));
    return this;
};
/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[$1dJ4X.toSetString(aSourceFile)] = aSourceContent;
};
/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
    for(var i = 0, len = this.children.length; i < len; i++)if (this.children[i][$7e3763caf8ef32fd$var$isSourceNode]) this.children[i].walkSourceContents(aFn);
    var sources = Object.keys(this.sourceContents);
    for(var i = 0, len = sources.length; i < len; i++)aFn($1dJ4X.fromSetString(sources[i]), this.sourceContents[sources[i]]);
};
/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.toString = function SourceNode_toString() {
    var str = "";
    this.walk(function(chunk) {
        str += chunk;
    });
    return str;
};
/**
 * Returns the string representation of this source node along with a source
 * map.
 */ $7e3763caf8ef32fd$var$SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
    var generated = {
        code: "",
        line: 1,
        column: 0
    };
    var map = new $7e3763caf8ef32fd$require$SourceMapGenerator(aArgs);
    var sourceMappingActive = false;
    var lastOriginalSource = null;
    var lastOriginalLine = null;
    var lastOriginalColumn = null;
    var lastOriginalName = null;
    this.walk(function(chunk, original) {
        generated.code += chunk;
        if (original.source !== null && original.line !== null && original.column !== null) {
            if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
            lastOriginalSource = original.source;
            lastOriginalLine = original.line;
            lastOriginalColumn = original.column;
            lastOriginalName = original.name;
            sourceMappingActive = true;
        } else if (sourceMappingActive) {
            map.addMapping({
                generated: {
                    line: generated.line,
                    column: generated.column
                }
            });
            lastOriginalSource = null;
            sourceMappingActive = false;
        }
        for(var idx = 0, length = chunk.length; idx < length; idx++)if (chunk.charCodeAt(idx) === $7e3763caf8ef32fd$var$NEWLINE_CODE) {
            generated.line++;
            generated.column = 0;
            // Mappings end at eol
            if (idx + 1 === length) {
                lastOriginalSource = null;
                sourceMappingActive = false;
            } else if (sourceMappingActive) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
        } else generated.column++;
    });
    this.walkSourceContents(function(sourceFile, sourceContent) {
        map.setSourceContent(sourceFile, sourceContent);
    });
    return {
        code: generated.code,
        map: map
    };
};
$7e3763caf8ef32fd$export$7e987e8f375d24c2 = $7e3763caf8ef32fd$var$SourceNode;

});

parcelRegister("7K7Bf", function(module, exports) {
"use strict";

});

parcelRegister("4Pw02", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iQDV7 = parcelRequire("iQDV7");
"use strict";
function $3844bf4a179cd7dd$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3844bf4a179cd7dd$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3844bf4a179cd7dd$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3844bf4a179cd7dd$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $iQDV7.cwd();
                path = cwd;
            }
            $3844bf4a179cd7dd$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3844bf4a179cd7dd$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3844bf4a179cd7dd$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3844bf4a179cd7dd$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3844bf4a179cd7dd$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3844bf4a179cd7dd$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3844bf4a179cd7dd$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3844bf4a179cd7dd$var$assertPath(from);
        $3844bf4a179cd7dd$var$assertPath(to);
        if (from === to) return "";
        from = $3844bf4a179cd7dd$var$posix.resolve(from);
        to = $3844bf4a179cd7dd$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3844bf4a179cd7dd$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3844bf4a179cd7dd$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3844bf4a179cd7dd$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3844bf4a179cd7dd$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3844bf4a179cd7dd$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3844bf4a179cd7dd$var$posix.posix = $3844bf4a179cd7dd$var$posix;
module.exports = $3844bf4a179cd7dd$var$posix;

});
parcelRegister("iQDV7", function(module, exports) {
// shim for using process in browser
var $db8c0ca9451f494f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $db8c0ca9451f494f$var$cachedSetTimeout;
var $db8c0ca9451f494f$var$cachedClearTimeout;
function $db8c0ca9451f494f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $db8c0ca9451f494f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $db8c0ca9451f494f$var$cachedSetTimeout = setTimeout;
        else $db8c0ca9451f494f$var$cachedSetTimeout = $db8c0ca9451f494f$var$defaultSetTimout;
    } catch (e) {
        $db8c0ca9451f494f$var$cachedSetTimeout = $db8c0ca9451f494f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $db8c0ca9451f494f$var$cachedClearTimeout = clearTimeout;
        else $db8c0ca9451f494f$var$cachedClearTimeout = $db8c0ca9451f494f$var$defaultClearTimeout;
    } catch (e) {
        $db8c0ca9451f494f$var$cachedClearTimeout = $db8c0ca9451f494f$var$defaultClearTimeout;
    }
})();
function $db8c0ca9451f494f$var$runTimeout(fun) {
    if ($db8c0ca9451f494f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($db8c0ca9451f494f$var$cachedSetTimeout === $db8c0ca9451f494f$var$defaultSetTimout || !$db8c0ca9451f494f$var$cachedSetTimeout) && setTimeout) {
        $db8c0ca9451f494f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $db8c0ca9451f494f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $db8c0ca9451f494f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $db8c0ca9451f494f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $db8c0ca9451f494f$var$runClearTimeout(marker) {
    if ($db8c0ca9451f494f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($db8c0ca9451f494f$var$cachedClearTimeout === $db8c0ca9451f494f$var$defaultClearTimeout || !$db8c0ca9451f494f$var$cachedClearTimeout) && clearTimeout) {
        $db8c0ca9451f494f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $db8c0ca9451f494f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $db8c0ca9451f494f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $db8c0ca9451f494f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $db8c0ca9451f494f$var$queue = [];
var $db8c0ca9451f494f$var$draining = false;
var $db8c0ca9451f494f$var$currentQueue;
var $db8c0ca9451f494f$var$queueIndex = -1;
function $db8c0ca9451f494f$var$cleanUpNextTick() {
    if (!$db8c0ca9451f494f$var$draining || !$db8c0ca9451f494f$var$currentQueue) return;
    $db8c0ca9451f494f$var$draining = false;
    if ($db8c0ca9451f494f$var$currentQueue.length) $db8c0ca9451f494f$var$queue = $db8c0ca9451f494f$var$currentQueue.concat($db8c0ca9451f494f$var$queue);
    else $db8c0ca9451f494f$var$queueIndex = -1;
    if ($db8c0ca9451f494f$var$queue.length) $db8c0ca9451f494f$var$drainQueue();
}
function $db8c0ca9451f494f$var$drainQueue() {
    if ($db8c0ca9451f494f$var$draining) return;
    var timeout = $db8c0ca9451f494f$var$runTimeout($db8c0ca9451f494f$var$cleanUpNextTick);
    $db8c0ca9451f494f$var$draining = true;
    var len = $db8c0ca9451f494f$var$queue.length;
    while(len){
        $db8c0ca9451f494f$var$currentQueue = $db8c0ca9451f494f$var$queue;
        $db8c0ca9451f494f$var$queue = [];
        while(++$db8c0ca9451f494f$var$queueIndex < len)if ($db8c0ca9451f494f$var$currentQueue) $db8c0ca9451f494f$var$currentQueue[$db8c0ca9451f494f$var$queueIndex].run();
        $db8c0ca9451f494f$var$queueIndex = -1;
        len = $db8c0ca9451f494f$var$queue.length;
    }
    $db8c0ca9451f494f$var$currentQueue = null;
    $db8c0ca9451f494f$var$draining = false;
    $db8c0ca9451f494f$var$runClearTimeout(timeout);
}
$db8c0ca9451f494f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $db8c0ca9451f494f$var$queue.push(new $db8c0ca9451f494f$var$Item(fun, args));
    if ($db8c0ca9451f494f$var$queue.length === 1 && !$db8c0ca9451f494f$var$draining) $db8c0ca9451f494f$var$runTimeout($db8c0ca9451f494f$var$drainQueue);
};
// v8 likes predictible objects
function $db8c0ca9451f494f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$db8c0ca9451f494f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$db8c0ca9451f494f$var$process.title = "browser";
$db8c0ca9451f494f$var$process.browser = true;
$db8c0ca9451f494f$var$process.env = {};
$db8c0ca9451f494f$var$process.argv = [];
$db8c0ca9451f494f$var$process.version = ""; // empty string to avoid regexp issues
$db8c0ca9451f494f$var$process.versions = {};
function $db8c0ca9451f494f$var$noop() {}
$db8c0ca9451f494f$var$process.on = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.addListener = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.once = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.off = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.removeListener = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.removeAllListeners = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.emit = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.prependListener = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.prependOnceListener = $db8c0ca9451f494f$var$noop;
$db8c0ca9451f494f$var$process.listeners = function(name) {
    return [];
};
$db8c0ca9451f494f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$db8c0ca9451f494f$var$process.cwd = function() {
    return "/";
};
$db8c0ca9451f494f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$db8c0ca9451f494f$var$process.umask = function() {
    return 0;
};

});


parcelRegister("ezvW0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iQDV7 = parcelRequire("iQDV7");
var $a9bd1b22b4966e14$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $a9bd1b22b4966e14$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$a9bd1b22b4966e14$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($a9bd1b22b4966e14$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($a9bd1b22b4966e14$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($a9bd1b22b4966e14$var$isNull(x) || !$a9bd1b22b4966e14$var$isObject(x)) str += " " + x;
    else str += " " + $a9bd1b22b4966e14$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $iQDV7 !== "undefined" && $iQDV7.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $iQDV7 === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($iQDV7.throwDeprecation) throw new Error(msg);
            else if ($iQDV7.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $a9bd1b22b4966e14$var$debugs = {};
var $a9bd1b22b4966e14$var$debugEnvRegex = /^$/;
var $a9bd1b22b4966e14$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$a9bd1b22b4966e14$var$debugs[set]) {
        if ($a9bd1b22b4966e14$var$debugEnvRegex.test(set)) {
            var pid = $iQDV7.pid;
            $a9bd1b22b4966e14$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $a9bd1b22b4966e14$var$debugs[set] = function() {};
    }
    return $a9bd1b22b4966e14$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $a9bd1b22b4966e14$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $a9bd1b22b4966e14$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($a9bd1b22b4966e14$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($a9bd1b22b4966e14$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($a9bd1b22b4966e14$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($a9bd1b22b4966e14$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($a9bd1b22b4966e14$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $a9bd1b22b4966e14$var$stylizeWithColor;
    return $a9bd1b22b4966e14$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $a9bd1b22b4966e14$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$a9bd1b22b4966e14$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$a9bd1b22b4966e14$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $a9bd1b22b4966e14$var$stylizeWithColor(str, styleType) {
    var style = $a9bd1b22b4966e14$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $a9bd1b22b4966e14$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $a9bd1b22b4966e14$var$inspect.colors[style][1] + "m";
    else return str;
}
function $a9bd1b22b4966e14$var$stylizeNoColor(str, styleType) {
    return str;
}
function $a9bd1b22b4966e14$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $a9bd1b22b4966e14$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $a9bd1b22b4966e14$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$a9bd1b22b4966e14$var$isString(ret)) ret = $a9bd1b22b4966e14$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $a9bd1b22b4966e14$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $a9bd1b22b4966e14$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($a9bd1b22b4966e14$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $a9bd1b22b4966e14$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($a9bd1b22b4966e14$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($a9bd1b22b4966e14$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($a9bd1b22b4966e14$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($a9bd1b22b4966e14$var$isError(value)) return $a9bd1b22b4966e14$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($a9bd1b22b4966e14$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($a9bd1b22b4966e14$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($a9bd1b22b4966e14$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($a9bd1b22b4966e14$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($a9bd1b22b4966e14$var$isError(value)) base = " " + $a9bd1b22b4966e14$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($a9bd1b22b4966e14$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $a9bd1b22b4966e14$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $a9bd1b22b4966e14$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $a9bd1b22b4966e14$var$reduceToSingleString(output, base, braces);
}
function $a9bd1b22b4966e14$var$formatPrimitive(ctx, value) {
    if ($a9bd1b22b4966e14$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($a9bd1b22b4966e14$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($a9bd1b22b4966e14$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($a9bd1b22b4966e14$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($a9bd1b22b4966e14$var$isNull(value)) return ctx.stylize("null", "null");
}
function $a9bd1b22b4966e14$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $a9bd1b22b4966e14$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($a9bd1b22b4966e14$var$hasOwnProperty(value, String(i))) output.push($a9bd1b22b4966e14$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($a9bd1b22b4966e14$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $a9bd1b22b4966e14$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$a9bd1b22b4966e14$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($a9bd1b22b4966e14$var$isNull(recurseTimes)) str = $a9bd1b22b4966e14$var$formatValue(ctx, desc.value, null);
            else str = $a9bd1b22b4966e14$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($a9bd1b22b4966e14$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $a9bd1b22b4966e14$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("iCzo6"));
function $a9bd1b22b4966e14$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $a9bd1b22b4966e14$var$isArray;
function $a9bd1b22b4966e14$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $a9bd1b22b4966e14$var$isBoolean;
function $a9bd1b22b4966e14$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $a9bd1b22b4966e14$var$isNull;
function $a9bd1b22b4966e14$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $a9bd1b22b4966e14$var$isNullOrUndefined;
function $a9bd1b22b4966e14$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $a9bd1b22b4966e14$var$isNumber;
function $a9bd1b22b4966e14$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $a9bd1b22b4966e14$var$isString;
function $a9bd1b22b4966e14$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $a9bd1b22b4966e14$var$isSymbol;
function $a9bd1b22b4966e14$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $a9bd1b22b4966e14$var$isUndefined;
function $a9bd1b22b4966e14$var$isRegExp(re) {
    return $a9bd1b22b4966e14$var$isObject(re) && $a9bd1b22b4966e14$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $a9bd1b22b4966e14$var$isRegExp;
module.exports.types.isRegExp = $a9bd1b22b4966e14$var$isRegExp;
function $a9bd1b22b4966e14$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $a9bd1b22b4966e14$var$isObject;
function $a9bd1b22b4966e14$var$isDate(d) {
    return $a9bd1b22b4966e14$var$isObject(d) && $a9bd1b22b4966e14$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $a9bd1b22b4966e14$var$isDate;
module.exports.types.isDate = $a9bd1b22b4966e14$var$isDate;
function $a9bd1b22b4966e14$var$isError(e) {
    return $a9bd1b22b4966e14$var$isObject(e) && ($a9bd1b22b4966e14$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $a9bd1b22b4966e14$var$isError;
module.exports.types.isNativeError = $a9bd1b22b4966e14$var$isError;
function $a9bd1b22b4966e14$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $a9bd1b22b4966e14$var$isFunction;
function $a9bd1b22b4966e14$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $a9bd1b22b4966e14$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("eQZjb"));
function $a9bd1b22b4966e14$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $a9bd1b22b4966e14$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $a9bd1b22b4966e14$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $a9bd1b22b4966e14$var$timestamp() {
    var d = new Date();
    var time = [
        $a9bd1b22b4966e14$var$pad(d.getHours()),
        $a9bd1b22b4966e14$var$pad(d.getMinutes()),
        $a9bd1b22b4966e14$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $a9bd1b22b4966e14$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $a9bd1b22b4966e14$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("9AI3t"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$a9bd1b22b4966e14$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $a9bd1b22b4966e14$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $a9bd1b22b4966e14$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($a9bd1b22b4966e14$var$kCustomPromisifiedSymbol && original[$a9bd1b22b4966e14$var$kCustomPromisifiedSymbol]) {
        var fn = original[$a9bd1b22b4966e14$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $a9bd1b22b4966e14$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($a9bd1b22b4966e14$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $a9bd1b22b4966e14$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $a9bd1b22b4966e14$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $a9bd1b22b4966e14$var$kCustomPromisifiedSymbol;
function $a9bd1b22b4966e14$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $a9bd1b22b4966e14$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $iQDV7.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $iQDV7.nextTick($a9bd1b22b4966e14$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $a9bd1b22b4966e14$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $a9bd1b22b4966e14$var$callbackify;

});
parcelRegister("iCzo6", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $j1gF0 = parcelRequire("j1gF0");

var $dyaWI = parcelRequire("dyaWI");

var $hnCdG = parcelRequire("hnCdG");

var $apCnB = parcelRequire("apCnB");
function $d8e739e1061b24ca$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $d8e739e1061b24ca$var$BigIntSupported = typeof BigInt !== "undefined";
var $d8e739e1061b24ca$var$SymbolSupported = typeof Symbol !== "undefined";
var $d8e739e1061b24ca$var$ObjectToString = $d8e739e1061b24ca$var$uncurryThis(Object.prototype.toString);
var $d8e739e1061b24ca$var$numberValue = $d8e739e1061b24ca$var$uncurryThis(Number.prototype.valueOf);
var $d8e739e1061b24ca$var$stringValue = $d8e739e1061b24ca$var$uncurryThis(String.prototype.valueOf);
var $d8e739e1061b24ca$var$booleanValue = $d8e739e1061b24ca$var$uncurryThis(Boolean.prototype.valueOf);
if ($d8e739e1061b24ca$var$BigIntSupported) var $d8e739e1061b24ca$var$bigIntValue = $d8e739e1061b24ca$var$uncurryThis(BigInt.prototype.valueOf);
if ($d8e739e1061b24ca$var$SymbolSupported) var $d8e739e1061b24ca$var$symbolValue = $d8e739e1061b24ca$var$uncurryThis(Symbol.prototype.valueOf);
function $d8e739e1061b24ca$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $j1gF0;
module.exports.isGeneratorFunction = $dyaWI;
module.exports.isTypedArray = $apCnB;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $d8e739e1061b24ca$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $d8e739e1061b24ca$var$isPromise;
function $d8e739e1061b24ca$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $apCnB(value) || $d8e739e1061b24ca$var$isDataView(value);
}
module.exports.isArrayBufferView = $d8e739e1061b24ca$var$isArrayBufferView;
function $d8e739e1061b24ca$var$isUint8Array(value) {
    return $hnCdG(value) === "Uint8Array";
}
module.exports.isUint8Array = $d8e739e1061b24ca$var$isUint8Array;
function $d8e739e1061b24ca$var$isUint8ClampedArray(value) {
    return $hnCdG(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $d8e739e1061b24ca$var$isUint8ClampedArray;
function $d8e739e1061b24ca$var$isUint16Array(value) {
    return $hnCdG(value) === "Uint16Array";
}
module.exports.isUint16Array = $d8e739e1061b24ca$var$isUint16Array;
function $d8e739e1061b24ca$var$isUint32Array(value) {
    return $hnCdG(value) === "Uint32Array";
}
module.exports.isUint32Array = $d8e739e1061b24ca$var$isUint32Array;
function $d8e739e1061b24ca$var$isInt8Array(value) {
    return $hnCdG(value) === "Int8Array";
}
module.exports.isInt8Array = $d8e739e1061b24ca$var$isInt8Array;
function $d8e739e1061b24ca$var$isInt16Array(value) {
    return $hnCdG(value) === "Int16Array";
}
module.exports.isInt16Array = $d8e739e1061b24ca$var$isInt16Array;
function $d8e739e1061b24ca$var$isInt32Array(value) {
    return $hnCdG(value) === "Int32Array";
}
module.exports.isInt32Array = $d8e739e1061b24ca$var$isInt32Array;
function $d8e739e1061b24ca$var$isFloat32Array(value) {
    return $hnCdG(value) === "Float32Array";
}
module.exports.isFloat32Array = $d8e739e1061b24ca$var$isFloat32Array;
function $d8e739e1061b24ca$var$isFloat64Array(value) {
    return $hnCdG(value) === "Float64Array";
}
module.exports.isFloat64Array = $d8e739e1061b24ca$var$isFloat64Array;
function $d8e739e1061b24ca$var$isBigInt64Array(value) {
    return $hnCdG(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $d8e739e1061b24ca$var$isBigInt64Array;
function $d8e739e1061b24ca$var$isBigUint64Array(value) {
    return $hnCdG(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $d8e739e1061b24ca$var$isBigUint64Array;
function $d8e739e1061b24ca$var$isMapToString(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object Map]";
}
$d8e739e1061b24ca$var$isMapToString.working = typeof Map !== "undefined" && $d8e739e1061b24ca$var$isMapToString(new Map());
function $d8e739e1061b24ca$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $d8e739e1061b24ca$var$isMapToString.working ? $d8e739e1061b24ca$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $d8e739e1061b24ca$var$isMap;
function $d8e739e1061b24ca$var$isSetToString(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object Set]";
}
$d8e739e1061b24ca$var$isSetToString.working = typeof Set !== "undefined" && $d8e739e1061b24ca$var$isSetToString(new Set());
function $d8e739e1061b24ca$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $d8e739e1061b24ca$var$isSetToString.working ? $d8e739e1061b24ca$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $d8e739e1061b24ca$var$isSet;
function $d8e739e1061b24ca$var$isWeakMapToString(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object WeakMap]";
}
$d8e739e1061b24ca$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $d8e739e1061b24ca$var$isWeakMapToString(new WeakMap());
function $d8e739e1061b24ca$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $d8e739e1061b24ca$var$isWeakMapToString.working ? $d8e739e1061b24ca$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $d8e739e1061b24ca$var$isWeakMap;
function $d8e739e1061b24ca$var$isWeakSetToString(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object WeakSet]";
}
$d8e739e1061b24ca$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $d8e739e1061b24ca$var$isWeakSetToString(new WeakSet());
function $d8e739e1061b24ca$var$isWeakSet(value) {
    return $d8e739e1061b24ca$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $d8e739e1061b24ca$var$isWeakSet;
function $d8e739e1061b24ca$var$isArrayBufferToString(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$d8e739e1061b24ca$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $d8e739e1061b24ca$var$isArrayBufferToString(new ArrayBuffer());
function $d8e739e1061b24ca$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $d8e739e1061b24ca$var$isArrayBufferToString.working ? $d8e739e1061b24ca$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $d8e739e1061b24ca$var$isArrayBuffer;
function $d8e739e1061b24ca$var$isDataViewToString(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object DataView]";
}
$d8e739e1061b24ca$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $d8e739e1061b24ca$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $d8e739e1061b24ca$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $d8e739e1061b24ca$var$isDataViewToString.working ? $d8e739e1061b24ca$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $d8e739e1061b24ca$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $d8e739e1061b24ca$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $d8e739e1061b24ca$var$isSharedArrayBufferToString(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $d8e739e1061b24ca$var$isSharedArrayBuffer(value) {
    if (typeof $d8e739e1061b24ca$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $d8e739e1061b24ca$var$isSharedArrayBufferToString.working === "undefined") $d8e739e1061b24ca$var$isSharedArrayBufferToString.working = $d8e739e1061b24ca$var$isSharedArrayBufferToString(new $d8e739e1061b24ca$var$SharedArrayBufferCopy());
    return $d8e739e1061b24ca$var$isSharedArrayBufferToString.working ? $d8e739e1061b24ca$var$isSharedArrayBufferToString(value) : value instanceof $d8e739e1061b24ca$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $d8e739e1061b24ca$var$isSharedArrayBuffer;
function $d8e739e1061b24ca$var$isAsyncFunction(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $d8e739e1061b24ca$var$isAsyncFunction;
function $d8e739e1061b24ca$var$isMapIterator(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $d8e739e1061b24ca$var$isMapIterator;
function $d8e739e1061b24ca$var$isSetIterator(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $d8e739e1061b24ca$var$isSetIterator;
function $d8e739e1061b24ca$var$isGeneratorObject(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $d8e739e1061b24ca$var$isGeneratorObject;
function $d8e739e1061b24ca$var$isWebAssemblyCompiledModule(value) {
    return $d8e739e1061b24ca$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $d8e739e1061b24ca$var$isWebAssemblyCompiledModule;
function $d8e739e1061b24ca$var$isNumberObject(value) {
    return $d8e739e1061b24ca$var$checkBoxedPrimitive(value, $d8e739e1061b24ca$var$numberValue);
}
module.exports.isNumberObject = $d8e739e1061b24ca$var$isNumberObject;
function $d8e739e1061b24ca$var$isStringObject(value) {
    return $d8e739e1061b24ca$var$checkBoxedPrimitive(value, $d8e739e1061b24ca$var$stringValue);
}
module.exports.isStringObject = $d8e739e1061b24ca$var$isStringObject;
function $d8e739e1061b24ca$var$isBooleanObject(value) {
    return $d8e739e1061b24ca$var$checkBoxedPrimitive(value, $d8e739e1061b24ca$var$booleanValue);
}
module.exports.isBooleanObject = $d8e739e1061b24ca$var$isBooleanObject;
function $d8e739e1061b24ca$var$isBigIntObject(value) {
    return $d8e739e1061b24ca$var$BigIntSupported && $d8e739e1061b24ca$var$checkBoxedPrimitive(value, $d8e739e1061b24ca$var$bigIntValue);
}
module.exports.isBigIntObject = $d8e739e1061b24ca$var$isBigIntObject;
function $d8e739e1061b24ca$var$isSymbolObject(value) {
    return $d8e739e1061b24ca$var$SymbolSupported && $d8e739e1061b24ca$var$checkBoxedPrimitive(value, $d8e739e1061b24ca$var$symbolValue);
}
module.exports.isSymbolObject = $d8e739e1061b24ca$var$isSymbolObject;
function $d8e739e1061b24ca$var$isBoxedPrimitive(value) {
    return $d8e739e1061b24ca$var$isNumberObject(value) || $d8e739e1061b24ca$var$isStringObject(value) || $d8e739e1061b24ca$var$isBooleanObject(value) || $d8e739e1061b24ca$var$isBigIntObject(value) || $d8e739e1061b24ca$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $d8e739e1061b24ca$var$isBoxedPrimitive;
function $d8e739e1061b24ca$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($d8e739e1061b24ca$var$isArrayBuffer(value) || $d8e739e1061b24ca$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $d8e739e1061b24ca$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("j1gF0", function(module, exports) {
"use strict";
var $dd8b08ba2b6d2a11$var$hasToStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
var $dd8b08ba2b6d2a11$var$toStr = Object.prototype.toString;
var $dd8b08ba2b6d2a11$var$isStandardArguments = function isArguments(value) {
    if ($dd8b08ba2b6d2a11$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $dd8b08ba2b6d2a11$var$toStr.call(value) === "[object Arguments]";
};
var $dd8b08ba2b6d2a11$var$isLegacyArguments = function isArguments(value) {
    if ($dd8b08ba2b6d2a11$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $dd8b08ba2b6d2a11$var$toStr.call(value) !== "[object Array]" && $dd8b08ba2b6d2a11$var$toStr.call(value.callee) === "[object Function]";
};
var $dd8b08ba2b6d2a11$var$supportsStandardArguments = function() {
    return $dd8b08ba2b6d2a11$var$isStandardArguments(arguments);
}();
$dd8b08ba2b6d2a11$var$isStandardArguments.isLegacyArguments = $dd8b08ba2b6d2a11$var$isLegacyArguments; // for tests
module.exports = $dd8b08ba2b6d2a11$var$supportsStandardArguments ? $dd8b08ba2b6d2a11$var$isStandardArguments : $dd8b08ba2b6d2a11$var$isLegacyArguments;

});

parcelRegister("dyaWI", function(module, exports) {
"use strict";
var $9dd6f0f901f0cd70$var$toStr = Object.prototype.toString;
var $9dd6f0f901f0cd70$var$fnToStr = Function.prototype.toString;
var $9dd6f0f901f0cd70$var$isFnRegex = /^\s*(?:function)?\*/;

var $9dd6f0f901f0cd70$var$hasToStringTag = (parcelRequire("7WJPP"))();
var $9dd6f0f901f0cd70$var$getProto = Object.getPrototypeOf;
var $9dd6f0f901f0cd70$var$getGeneratorFunc = function() {
    if (!$9dd6f0f901f0cd70$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $9dd6f0f901f0cd70$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($9dd6f0f901f0cd70$var$isFnRegex.test($9dd6f0f901f0cd70$var$fnToStr.call(fn))) return true;
    if (!$9dd6f0f901f0cd70$var$hasToStringTag) {
        var str = $9dd6f0f901f0cd70$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$9dd6f0f901f0cd70$var$getProto) return false;
    if (typeof $9dd6f0f901f0cd70$var$GeneratorFunction === "undefined") {
        var generatorFunc = $9dd6f0f901f0cd70$var$getGeneratorFunc();
        $9dd6f0f901f0cd70$var$GeneratorFunction = generatorFunc ? $9dd6f0f901f0cd70$var$getProto(generatorFunc) : false;
    }
    return $9dd6f0f901f0cd70$var$getProto(fn) === $9dd6f0f901f0cd70$var$GeneratorFunction;
};

});
parcelRegister("7WJPP", function(module, exports) {
"use strict";

var $9WrZJ = parcelRequire("9WrZJ");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $9WrZJ() && !!Symbol.toStringTag;
};

});
parcelRegister("9WrZJ", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});



parcelRegister("hnCdG", function(module, exports) {
"use strict";

var $7ix1D = parcelRequire("7ix1D");

var $brHgt = parcelRequire("brHgt");

var $2DDXs = parcelRequire("2DDXs");
var $ca723b4e76146e41$var$$toString = $2DDXs("Object.prototype.toString");

var $ca723b4e76146e41$var$hasSymbols = (parcelRequire("3MbC0"))();
var $ca723b4e76146e41$var$hasToStringTag = $ca723b4e76146e41$var$hasSymbols && typeof Symbol.toStringTag === "symbol";
var $ca723b4e76146e41$var$typedArrays = $brHgt();
var $ca723b4e76146e41$var$$slice = $2DDXs("String.prototype.slice");
var $ca723b4e76146e41$var$toStrTags = {};

var $hQxzz = parcelRequire("hQxzz");
var $ca723b4e76146e41$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($ca723b4e76146e41$var$hasToStringTag && $hQxzz && $ca723b4e76146e41$var$getPrototypeOf) $7ix1D($ca723b4e76146e41$var$typedArrays, function(typedArray) {
    if (typeof $parcel$global[typedArray] === "function") {
        var arr = new $parcel$global[typedArray]();
        if (!(Symbol.toStringTag in arr)) throw new EvalError("this engine has support for Symbol.toStringTag, but " + typedArray + " does not have the property! Please report this.");
        var proto = $ca723b4e76146e41$var$getPrototypeOf(arr);
        var descriptor = $hQxzz(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $ca723b4e76146e41$var$getPrototypeOf(proto);
            descriptor = $hQxzz(superProto, Symbol.toStringTag);
        }
        $ca723b4e76146e41$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $ca723b4e76146e41$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $7ix1D($ca723b4e76146e41$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $apCnB = parcelRequire("apCnB");
module.exports = function whichTypedArray(value) {
    if (!$apCnB(value)) return false;
    if (!$ca723b4e76146e41$var$hasToStringTag) return $ca723b4e76146e41$var$$slice($ca723b4e76146e41$var$$toString(value), 8, -1);
    return $ca723b4e76146e41$var$tryTypedArrays(value);
};

});
parcelRegister("7ix1D", function(module, exports) {
var $5503d4f87411a8ef$var$hasOwn = Object.prototype.hasOwnProperty;
var $5503d4f87411a8ef$var$toString = Object.prototype.toString;
module.exports = function forEach(obj, fn, ctx) {
    if ($5503d4f87411a8ef$var$toString.call(fn) !== "[object Function]") throw new TypeError("iterator must be a function");
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if ($5503d4f87411a8ef$var$hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};

});

parcelRegister("brHgt", function(module, exports) {
"use strict";

var $8xN3Q = parcelRequire("8xN3Q");
module.exports = function availableTypedArrays() {
    return $8xN3Q([
        "BigInt64Array",
        "BigUint64Array",
        "Float32Array",
        "Float64Array",
        "Int16Array",
        "Int32Array",
        "Int8Array",
        "Uint16Array",
        "Uint32Array",
        "Uint8Array",
        "Uint8ClampedArray"
    ], function(typedArray) {
        return typeof $parcel$global[typedArray] === "function";
    });
};

});
parcelRegister("8xN3Q", function(module, exports) {
/**
 * Array#filter.
 *
 * @param {Array} arr
 * @param {Function} fn
 * @param {Object=} self
 * @return {Array}
 * @throw TypeError
 */ module.exports = function(arr, fn, self) {
    if (arr.filter) return arr.filter(fn, self);
    if (void 0 === arr || null === arr) throw new TypeError;
    if ("function" != typeof fn) throw new TypeError;
    var ret = [];
    for(var i = 0; i < arr.length; i++){
        if (!$6387764e22eb9f2a$var$hasOwn.call(arr, i)) continue;
        var val = arr[i];
        if (fn.call(self, val, i, arr)) ret.push(val);
    }
    return ret;
};
var $6387764e22eb9f2a$var$hasOwn = Object.prototype.hasOwnProperty;

});


parcelRegister("2DDXs", function(module, exports) {
"use strict";

var $jskgm = parcelRequire("jskgm");

var $2N8yi = parcelRequire("2N8yi");
var $1ebe381d3475b0f2$var$$indexOf = $2N8yi($jskgm("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $jskgm(name, !!allowMissing);
    if (typeof intrinsic === "function" && $1ebe381d3475b0f2$var$$indexOf(name, ".prototype.")) return $2N8yi(intrinsic);
    return intrinsic;
};

});
parcelRegister("jskgm", function(module, exports) {
"use strict";
/* globals
	Atomics,
	SharedArrayBuffer,
*/ var $e2a059a3cc42618a$var$undefined1;
var $e2a059a3cc42618a$var$$TypeError = TypeError;
var $e2a059a3cc42618a$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($e2a059a3cc42618a$var$$gOPD) try {
    $e2a059a3cc42618a$var$$gOPD({}, "");
} catch (e) {
    $e2a059a3cc42618a$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $e2a059a3cc42618a$var$throwTypeError = function() {
    throw new $e2a059a3cc42618a$var$$TypeError();
};
var $e2a059a3cc42618a$var$ThrowTypeError = $e2a059a3cc42618a$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $e2a059a3cc42618a$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $e2a059a3cc42618a$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $e2a059a3cc42618a$var$throwTypeError;
        }
    }
}() : $e2a059a3cc42618a$var$throwTypeError;

var $e2a059a3cc42618a$var$hasSymbols = (parcelRequire("3MbC0"))();
var $e2a059a3cc42618a$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $e2a059a3cc42618a$var$generator; // = function * () {};
var $e2a059a3cc42618a$var$generatorFunction = $e2a059a3cc42618a$var$generator ? $e2a059a3cc42618a$var$getProto($e2a059a3cc42618a$var$generator) : undefined;
var $e2a059a3cc42618a$var$asyncFn; // async function() {};
var $e2a059a3cc42618a$var$asyncFunction = $e2a059a3cc42618a$var$asyncFn ? $e2a059a3cc42618a$var$asyncFn.constructor : undefined;
var $e2a059a3cc42618a$var$asyncGen; // async function * () {};
var $e2a059a3cc42618a$var$asyncGenFunction = $e2a059a3cc42618a$var$asyncGen ? $e2a059a3cc42618a$var$getProto($e2a059a3cc42618a$var$asyncGen) : undefined;
var $e2a059a3cc42618a$var$asyncGenIterator = $e2a059a3cc42618a$var$asyncGen ? $e2a059a3cc42618a$var$asyncGen() : undefined;
var $e2a059a3cc42618a$var$TypedArray = typeof Uint8Array === "undefined" ? undefined : $e2a059a3cc42618a$var$getProto(Uint8Array);
var $e2a059a3cc42618a$var$INTRINSICS = {
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayBufferPrototype%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer.prototype,
    "%ArrayIteratorPrototype%": $e2a059a3cc42618a$var$hasSymbols ? $e2a059a3cc42618a$var$getProto([][Symbol.iterator]()) : undefined,
    "%ArrayPrototype%": Array.prototype,
    "%ArrayProto_entries%": Array.prototype.entries,
    "%ArrayProto_forEach%": Array.prototype.forEach,
    "%ArrayProto_keys%": Array.prototype.keys,
    "%ArrayProto_values%": Array.prototype.values,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $e2a059a3cc42618a$var$asyncFunction,
    "%AsyncFunctionPrototype%": $e2a059a3cc42618a$var$asyncFunction ? $e2a059a3cc42618a$var$asyncFunction.prototype : undefined,
    "%AsyncGenerator%": $e2a059a3cc42618a$var$asyncGen ? $e2a059a3cc42618a$var$getProto($e2a059a3cc42618a$var$asyncGenIterator) : undefined,
    "%AsyncGeneratorFunction%": $e2a059a3cc42618a$var$asyncGenFunction,
    "%AsyncGeneratorPrototype%": $e2a059a3cc42618a$var$asyncGenFunction ? $e2a059a3cc42618a$var$asyncGenFunction.prototype : undefined,
    "%AsyncIteratorPrototype%": $e2a059a3cc42618a$var$asyncGenIterator && $e2a059a3cc42618a$var$hasSymbols && Symbol.asyncIterator ? $e2a059a3cc42618a$var$asyncGenIterator[Symbol.asyncIterator]() : undefined,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%Boolean%": Boolean,
    "%BooleanPrototype%": Boolean.prototype,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%DataViewPrototype%": typeof DataView === "undefined" ? undefined : DataView.prototype,
    "%Date%": Date,
    "%DatePrototype%": Date.prototype,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%ErrorPrototype%": Error.prototype,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%EvalErrorPrototype%": EvalError.prototype,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float32ArrayPrototype%": typeof Float32Array === "undefined" ? undefined : Float32Array.prototype,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%Float64ArrayPrototype%": typeof Float64Array === "undefined" ? undefined : Float64Array.prototype,
    "%Function%": Function,
    "%FunctionPrototype%": Function.prototype,
    "%Generator%": $e2a059a3cc42618a$var$generator ? $e2a059a3cc42618a$var$getProto($e2a059a3cc42618a$var$generator()) : undefined,
    "%GeneratorFunction%": $e2a059a3cc42618a$var$generatorFunction,
    "%GeneratorPrototype%": $e2a059a3cc42618a$var$generatorFunction ? $e2a059a3cc42618a$var$generatorFunction.prototype : undefined,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int8ArrayPrototype%": typeof Int8Array === "undefined" ? undefined : Int8Array.prototype,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int16ArrayPrototype%": typeof Int16Array === "undefined" ? undefined : Int8Array.prototype,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%Int32ArrayPrototype%": typeof Int32Array === "undefined" ? undefined : Int32Array.prototype,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $e2a059a3cc42618a$var$hasSymbols ? $e2a059a3cc42618a$var$getProto($e2a059a3cc42618a$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%JSONParse%": typeof JSON === "object" ? JSON.parse : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$e2a059a3cc42618a$var$hasSymbols ? undefined : $e2a059a3cc42618a$var$getProto(new Map()[Symbol.iterator]()),
    "%MapPrototype%": typeof Map === "undefined" ? undefined : Map.prototype,
    "%Math%": Math,
    "%Number%": Number,
    "%NumberPrototype%": Number.prototype,
    "%Object%": Object,
    "%ObjectPrototype%": Object.prototype,
    "%ObjProto_toString%": Object.prototype.toString,
    "%ObjProto_valueOf%": Object.prototype.valueOf,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%PromisePrototype%": typeof Promise === "undefined" ? undefined : Promise.prototype,
    "%PromiseProto_then%": typeof Promise === "undefined" ? undefined : Promise.prototype.then,
    "%Promise_all%": typeof Promise === "undefined" ? undefined : Promise.all,
    "%Promise_reject%": typeof Promise === "undefined" ? undefined : Promise.reject,
    "%Promise_resolve%": typeof Promise === "undefined" ? undefined : Promise.resolve,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%RangeErrorPrototype%": RangeError.prototype,
    "%ReferenceError%": ReferenceError,
    "%ReferenceErrorPrototype%": ReferenceError.prototype,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%RegExpPrototype%": RegExp.prototype,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$e2a059a3cc42618a$var$hasSymbols ? undefined : $e2a059a3cc42618a$var$getProto(new Set()[Symbol.iterator]()),
    "%SetPrototype%": typeof Set === "undefined" ? undefined : Set.prototype,
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%SharedArrayBufferPrototype%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer.prototype,
    "%String%": String,
    "%StringIteratorPrototype%": $e2a059a3cc42618a$var$hasSymbols ? $e2a059a3cc42618a$var$getProto(""[Symbol.iterator]()) : undefined,
    "%StringPrototype%": String.prototype,
    "%Symbol%": $e2a059a3cc42618a$var$hasSymbols ? Symbol : undefined,
    "%SymbolPrototype%": $e2a059a3cc42618a$var$hasSymbols ? Symbol.prototype : undefined,
    "%SyntaxError%": SyntaxError,
    "%SyntaxErrorPrototype%": SyntaxError.prototype,
    "%ThrowTypeError%": $e2a059a3cc42618a$var$ThrowTypeError,
    "%TypedArray%": $e2a059a3cc42618a$var$TypedArray,
    "%TypedArrayPrototype%": $e2a059a3cc42618a$var$TypedArray ? $e2a059a3cc42618a$var$TypedArray.prototype : undefined,
    "%TypeError%": $e2a059a3cc42618a$var$$TypeError,
    "%TypeErrorPrototype%": $e2a059a3cc42618a$var$$TypeError.prototype,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ArrayPrototype%": typeof Uint8Array === "undefined" ? undefined : Uint8Array.prototype,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint8ClampedArrayPrototype%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray.prototype,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint16ArrayPrototype%": typeof Uint16Array === "undefined" ? undefined : Uint16Array.prototype,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%Uint32ArrayPrototype%": typeof Uint32Array === "undefined" ? undefined : Uint32Array.prototype,
    "%URIError%": URIError,
    "%URIErrorPrototype%": URIError.prototype,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakMapPrototype%": typeof WeakMap === "undefined" ? undefined : WeakMap.prototype,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet,
    "%WeakSetPrototype%": typeof WeakSet === "undefined" ? undefined : WeakSet.prototype
};

var $dcAqh = parcelRequire("dcAqh");
var $e2a059a3cc42618a$var$$replace = $dcAqh.call(Function.call, String.prototype.replace);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $e2a059a3cc42618a$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $e2a059a3cc42618a$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $e2a059a3cc42618a$var$stringToPath = function stringToPath(string) {
    var result = [];
    $e2a059a3cc42618a$var$$replace(string, $e2a059a3cc42618a$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $e2a059a3cc42618a$var$$replace(subString, $e2a059a3cc42618a$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $e2a059a3cc42618a$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    if (!(name in $e2a059a3cc42618a$var$INTRINSICS)) throw new SyntaxError("intrinsic " + name + " does not exist!");
    // istanbul ignore if // hopefully this is impossible to test :-)
    if (typeof $e2a059a3cc42618a$var$INTRINSICS[name] === "undefined" && !allowMissing) throw new $e2a059a3cc42618a$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
    return $e2a059a3cc42618a$var$INTRINSICS[name];
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new TypeError('"allowMissing" argument must be a boolean');
    var parts = $e2a059a3cc42618a$var$stringToPath(name);
    var value = $e2a059a3cc42618a$var$getBaseIntrinsic("%" + (parts.length > 0 ? parts[0] : "") + "%", allowMissing);
    for(var i = 1; i < parts.length; i += 1)if (value != null) {
        if ($e2a059a3cc42618a$var$$gOPD && i + 1 >= parts.length) {
            var desc = $e2a059a3cc42618a$var$$gOPD(value, parts[i]);
            if (!allowMissing && !(parts[i] in value)) throw new $e2a059a3cc42618a$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
            // By convention, when a data property is converted to an accessor
            // property to emulate a data property that does not suffer from
            // the override mistake, that accessor's getter is marked with
            // an `originalValue` property. Here, when we detect this, we
            // uphold the illusion by pretending to see that original data
            // property, i.e., returning the value rather than the getter
            // itself.
            value = desc && "get" in desc && !("originalValue" in desc.get) ? desc.get : value[parts[i]];
        } else value = value[parts[i]];
    }
    return value;
};

});
parcelRegister("3MbC0", function(module, exports) {
"use strict";
var $2bfedcada10f3218$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $9WrZJ = parcelRequire("9WrZJ");
module.exports = function hasNativeSymbols() {
    if (typeof $2bfedcada10f3218$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $2bfedcada10f3218$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $9WrZJ();
};

});

parcelRegister("dcAqh", function(module, exports) {
"use strict";

var $dy6Jb = parcelRequire("dy6Jb");
module.exports = Function.prototype.bind || $dy6Jb;

});
parcelRegister("dy6Jb", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $9dd3ab54d1343fbe$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $9dd3ab54d1343fbe$var$slice = Array.prototype.slice;
var $9dd3ab54d1343fbe$var$toStr = Object.prototype.toString;
var $9dd3ab54d1343fbe$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $9dd3ab54d1343fbe$var$toStr.call(target) !== $9dd3ab54d1343fbe$var$funcType) throw new TypeError($9dd3ab54d1343fbe$var$ERROR_MESSAGE + target);
    var args = $9dd3ab54d1343fbe$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($9dd3ab54d1343fbe$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($9dd3ab54d1343fbe$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});



parcelRegister("2N8yi", function(module, exports) {
"use strict";

var $dcAqh = parcelRequire("dcAqh");

var $jskgm = parcelRequire("jskgm");
var $2086caa47ab16519$var$$apply = $jskgm("%Function.prototype.apply%");
var $2086caa47ab16519$var$$call = $jskgm("%Function.prototype.call%");
var $2086caa47ab16519$var$$reflectApply = $jskgm("%Reflect.apply%", true) || $dcAqh.call($2086caa47ab16519$var$$call, $2086caa47ab16519$var$$apply);
var $2086caa47ab16519$var$$defineProperty = $jskgm("%Object.defineProperty%", true);
if ($2086caa47ab16519$var$$defineProperty) try {
    $2086caa47ab16519$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $2086caa47ab16519$var$$defineProperty = null;
}
module.exports = function callBind() {
    return $2086caa47ab16519$var$$reflectApply($dcAqh, $2086caa47ab16519$var$$call, arguments);
};
var $2086caa47ab16519$var$applyBind = function applyBind() {
    return $2086caa47ab16519$var$$reflectApply($dcAqh, $2086caa47ab16519$var$$apply, arguments);
};
if ($2086caa47ab16519$var$$defineProperty) $2086caa47ab16519$var$$defineProperty(module.exports, "apply", {
    value: $2086caa47ab16519$var$applyBind
});
else module.exports.apply = $2086caa47ab16519$var$applyBind;

});


parcelRegister("hQxzz", function(module, exports) {
"use strict";

var $jskgm = parcelRequire("jskgm");
var $cfe155d1866464d6$var$$gOPD = $jskgm("%Object.getOwnPropertyDescriptor%");
if ($cfe155d1866464d6$var$$gOPD) try {
    $cfe155d1866464d6$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $cfe155d1866464d6$var$$gOPD = null;
}
module.exports = $cfe155d1866464d6$var$$gOPD;

});

parcelRegister("apCnB", function(module, exports) {
"use strict";

var $7ix1D = parcelRequire("7ix1D");

var $brHgt = parcelRequire("brHgt");

var $2DDXs = parcelRequire("2DDXs");
var $794a029444d2b793$var$$toString = $2DDXs("Object.prototype.toString");

var $794a029444d2b793$var$hasSymbols = (parcelRequire("3MbC0"))();
var $794a029444d2b793$var$hasToStringTag = $794a029444d2b793$var$hasSymbols && typeof Symbol.toStringTag === "symbol";
var $794a029444d2b793$var$typedArrays = $brHgt();
var $794a029444d2b793$var$$indexOf = $2DDXs("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $794a029444d2b793$var$$slice = $2DDXs("String.prototype.slice");
var $794a029444d2b793$var$toStrTags = {};

var $hQxzz = parcelRequire("hQxzz");
var $794a029444d2b793$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($794a029444d2b793$var$hasToStringTag && $hQxzz && $794a029444d2b793$var$getPrototypeOf) $7ix1D($794a029444d2b793$var$typedArrays, function(typedArray) {
    var arr = new $parcel$global[typedArray]();
    if (!(Symbol.toStringTag in arr)) throw new EvalError("this engine has support for Symbol.toStringTag, but " + typedArray + " does not have the property! Please report this.");
    var proto = $794a029444d2b793$var$getPrototypeOf(arr);
    var descriptor = $hQxzz(proto, Symbol.toStringTag);
    if (!descriptor) {
        var superProto = $794a029444d2b793$var$getPrototypeOf(proto);
        descriptor = $hQxzz(superProto, Symbol.toStringTag);
    }
    $794a029444d2b793$var$toStrTags[typedArray] = descriptor.get;
});
var $794a029444d2b793$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $7ix1D($794a029444d2b793$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$794a029444d2b793$var$hasToStringTag) {
        var tag = $794a029444d2b793$var$$slice($794a029444d2b793$var$$toString(value), 8, -1);
        return $794a029444d2b793$var$$indexOf($794a029444d2b793$var$typedArrays, tag) > -1;
    }
    if (!$hQxzz) return false;
    return $794a029444d2b793$var$tryTypedArrays(value);
};

});



parcelRegister("eQZjb", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("9AI3t", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("6iqOz", function(module, exports) {
/** @license React v17.0.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $jSIPP = parcelRequire("jSIPP");

var $gj7pJ = parcelRequire("gj7pJ");

var $dX4Zi = parcelRequire("dX4Zi");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$jSIPP) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $jSIPP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $gj7pJ({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $jSIPP.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $gj7pJ({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $gj7pJ({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $gj7pJ({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $dX4Zi.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $dX4Zi.unstable_scheduleCallback($dX4Zi.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $dX4Zi.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $dX4Zi.unstable_UserBlockingPriority, ed = $dX4Zi.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $gj7pJ(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $gj7pJ({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $gj7pJ({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $gj7pJ({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $gj7pJ({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $gj7pJ({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $gj7pJ({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $gj7pJ({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $gj7pJ({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $gj7pJ({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $gj7pJ({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $gj7pJ({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $gj7pJ({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $gj7pJ({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $dX4Zi.unstable_runWithPriority, Of = $dX4Zi.unstable_scheduleCallback, Pf = $dX4Zi.unstable_cancelCallback, Qf = $dX4Zi.unstable_shouldYield, Rf = $dX4Zi.unstable_requestPaint, Sf = $dX4Zi.unstable_now, Tf = $dX4Zi.unstable_getCurrentPriorityLevel, Uf = $dX4Zi.unstable_ImmediatePriority, Vf = $dX4Zi.unstable_UserBlockingPriority, Wf = $dX4Zi.unstable_NormalPriority, Xf = $dX4Zi.unstable_LowPriority, Yf = $dX4Zi.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $gj7pJ({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $gj7pJ({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $jSIPP.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $gj7pJ({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $gj7pJ({}, e, {
                    value: void 0
                });
                d = $gj7pJ({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $gj7pJ({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.1",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.1";

});
parcelRegister("dX4Zi", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dIuBR"));

});
parcelRegister("dIuBR", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9fc720dcb1fe1e65$export$c4744153514ff05d; }, function (v) { return $9fc720dcb1fe1e65$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9fc720dcb1fe1e65$export$b5836b71941fa3ed; }, function (v) { return $9fc720dcb1fe1e65$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9fc720dcb1fe1e65$export$d66a1c1c77bd778b; }, function (v) { return $9fc720dcb1fe1e65$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9fc720dcb1fe1e65$export$3e506c1ccc9cc1a7; }, function (v) { return $9fc720dcb1fe1e65$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9fc720dcb1fe1e65$export$e26fe2ed2fa76875; }, function (v) { return $9fc720dcb1fe1e65$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9fc720dcb1fe1e65$export$502329bbf4b505b1; }, function (v) { return $9fc720dcb1fe1e65$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9fc720dcb1fe1e65$export$6e3807111c4874c4; }, function (v) { return $9fc720dcb1fe1e65$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9fc720dcb1fe1e65$export$c27134553091fb3a; }, function (v) { return $9fc720dcb1fe1e65$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9fc720dcb1fe1e65$export$33ee1acdc04fd2a2; }, function (v) { return $9fc720dcb1fe1e65$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9fc720dcb1fe1e65$export$b00a404bbd5edef2; }, function (v) { return $9fc720dcb1fe1e65$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9fc720dcb1fe1e65$export$8352ce38b91d0c62; }, function (v) { return $9fc720dcb1fe1e65$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9fc720dcb1fe1e65$export$d3dfb8e4810cb555; }, function (v) { return $9fc720dcb1fe1e65$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9fc720dcb1fe1e65$export$839f9183b0465a69; }, function (v) { return $9fc720dcb1fe1e65$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9fc720dcb1fe1e65$export$72fdf0e06517287b; }, function (v) { return $9fc720dcb1fe1e65$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9fc720dcb1fe1e65$export$4b844e58a3e414b4; }, function (v) { return $9fc720dcb1fe1e65$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9fc720dcb1fe1e65$export$816d2913ae6b83b1; }, function (v) { return $9fc720dcb1fe1e65$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9fc720dcb1fe1e65$export$61bcfe829111a1d0; }, function (v) { return $9fc720dcb1fe1e65$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9fc720dcb1fe1e65$export$7ee8c9beb337bc3f; }, function (v) { return $9fc720dcb1fe1e65$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9fc720dcb1fe1e65$export$cf845f2c119da08a; }, function (v) { return $9fc720dcb1fe1e65$export$cf845f2c119da08a = v; });
/** @license React v0.20.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9fc720dcb1fe1e65$export$c4744153514ff05d;
var $9fc720dcb1fe1e65$export$b5836b71941fa3ed;
var $9fc720dcb1fe1e65$export$d66a1c1c77bd778b;
var $9fc720dcb1fe1e65$export$3e506c1ccc9cc1a7;
var $9fc720dcb1fe1e65$export$e26fe2ed2fa76875;
var $9fc720dcb1fe1e65$export$502329bbf4b505b1;
var $9fc720dcb1fe1e65$export$6e3807111c4874c4;
var $9fc720dcb1fe1e65$export$c27134553091fb3a;
var $9fc720dcb1fe1e65$export$33ee1acdc04fd2a2;
var $9fc720dcb1fe1e65$export$b00a404bbd5edef2;
var $9fc720dcb1fe1e65$export$8352ce38b91d0c62;
var $9fc720dcb1fe1e65$export$d3dfb8e4810cb555;
var $9fc720dcb1fe1e65$export$839f9183b0465a69;
var $9fc720dcb1fe1e65$export$72fdf0e06517287b;
var $9fc720dcb1fe1e65$export$4b844e58a3e414b4;
var $9fc720dcb1fe1e65$export$816d2913ae6b83b1;
var $9fc720dcb1fe1e65$export$61bcfe829111a1d0;
var $9fc720dcb1fe1e65$export$7ee8c9beb337bc3f;
var $9fc720dcb1fe1e65$export$cf845f2c119da08a;
"use strict";
var $9fc720dcb1fe1e65$var$f, $9fc720dcb1fe1e65$var$g, $9fc720dcb1fe1e65$var$h, $9fc720dcb1fe1e65$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9fc720dcb1fe1e65$var$l = performance;
    $9fc720dcb1fe1e65$export$c4744153514ff05d = function() {
        return $9fc720dcb1fe1e65$var$l.now();
    };
} else {
    var $9fc720dcb1fe1e65$var$p = Date, $9fc720dcb1fe1e65$var$q = $9fc720dcb1fe1e65$var$p.now();
    $9fc720dcb1fe1e65$export$c4744153514ff05d = function() {
        return $9fc720dcb1fe1e65$var$p.now() - $9fc720dcb1fe1e65$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $9fc720dcb1fe1e65$var$t = null, $9fc720dcb1fe1e65$var$u = null, $9fc720dcb1fe1e65$var$w = function() {
        if (null !== $9fc720dcb1fe1e65$var$t) try {
            var a = $9fc720dcb1fe1e65$export$c4744153514ff05d();
            $9fc720dcb1fe1e65$var$t(!0, a);
            $9fc720dcb1fe1e65$var$t = null;
        } catch (b) {
            throw setTimeout($9fc720dcb1fe1e65$var$w, 0), b;
        }
    };
    $9fc720dcb1fe1e65$var$f = function(a) {
        null !== $9fc720dcb1fe1e65$var$t ? setTimeout($9fc720dcb1fe1e65$var$f, 0, a) : ($9fc720dcb1fe1e65$var$t = a, setTimeout($9fc720dcb1fe1e65$var$w, 0));
    };
    $9fc720dcb1fe1e65$var$g = function(a, b) {
        $9fc720dcb1fe1e65$var$u = setTimeout(a, b);
    };
    $9fc720dcb1fe1e65$var$h = function() {
        clearTimeout($9fc720dcb1fe1e65$var$u);
    };
    $9fc720dcb1fe1e65$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $9fc720dcb1fe1e65$var$k = $9fc720dcb1fe1e65$export$d66a1c1c77bd778b = function() {};
} else {
    var $9fc720dcb1fe1e65$var$x = window.setTimeout, $9fc720dcb1fe1e65$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $9fc720dcb1fe1e65$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $9fc720dcb1fe1e65$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $9fc720dcb1fe1e65$var$A = !1, $9fc720dcb1fe1e65$var$B = null, $9fc720dcb1fe1e65$var$C = -1, $9fc720dcb1fe1e65$var$D = 5, $9fc720dcb1fe1e65$var$E = 0;
    $9fc720dcb1fe1e65$export$b5836b71941fa3ed = function() {
        return $9fc720dcb1fe1e65$export$c4744153514ff05d() >= $9fc720dcb1fe1e65$var$E;
    };
    $9fc720dcb1fe1e65$var$k = function() {};
    $9fc720dcb1fe1e65$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9fc720dcb1fe1e65$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $9fc720dcb1fe1e65$var$F = new MessageChannel, $9fc720dcb1fe1e65$var$G = $9fc720dcb1fe1e65$var$F.port2;
    $9fc720dcb1fe1e65$var$F.port1.onmessage = function() {
        if (null !== $9fc720dcb1fe1e65$var$B) {
            var a = $9fc720dcb1fe1e65$export$c4744153514ff05d();
            $9fc720dcb1fe1e65$var$E = a + $9fc720dcb1fe1e65$var$D;
            try {
                $9fc720dcb1fe1e65$var$B(!0, a) ? $9fc720dcb1fe1e65$var$G.postMessage(null) : ($9fc720dcb1fe1e65$var$A = !1, $9fc720dcb1fe1e65$var$B = null);
            } catch (b) {
                throw $9fc720dcb1fe1e65$var$G.postMessage(null), b;
            }
        } else $9fc720dcb1fe1e65$var$A = !1;
    };
    $9fc720dcb1fe1e65$var$f = function(a) {
        $9fc720dcb1fe1e65$var$B = a;
        $9fc720dcb1fe1e65$var$A || ($9fc720dcb1fe1e65$var$A = !0, $9fc720dcb1fe1e65$var$G.postMessage(null));
    };
    $9fc720dcb1fe1e65$var$g = function(a, b) {
        $9fc720dcb1fe1e65$var$C = $9fc720dcb1fe1e65$var$x(function() {
            a($9fc720dcb1fe1e65$export$c4744153514ff05d());
        }, b);
    };
    $9fc720dcb1fe1e65$var$h = function() {
        $9fc720dcb1fe1e65$var$y($9fc720dcb1fe1e65$var$C);
        $9fc720dcb1fe1e65$var$C = -1;
    };
}
function $9fc720dcb1fe1e65$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $9fc720dcb1fe1e65$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9fc720dcb1fe1e65$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $9fc720dcb1fe1e65$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $9fc720dcb1fe1e65$var$I(n, c)) void 0 !== r && 0 > $9fc720dcb1fe1e65$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $9fc720dcb1fe1e65$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $9fc720dcb1fe1e65$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $9fc720dcb1fe1e65$var$L = [], $9fc720dcb1fe1e65$var$M = [], $9fc720dcb1fe1e65$var$N = 1, $9fc720dcb1fe1e65$var$O = null, $9fc720dcb1fe1e65$var$P = 3, $9fc720dcb1fe1e65$var$Q = !1, $9fc720dcb1fe1e65$var$R = !1, $9fc720dcb1fe1e65$var$S = !1;
function $9fc720dcb1fe1e65$var$T(a) {
    for(var b = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M); null !== b;){
        if (null === b.callback) $9fc720dcb1fe1e65$var$K($9fc720dcb1fe1e65$var$M);
        else if (b.startTime <= a) $9fc720dcb1fe1e65$var$K($9fc720dcb1fe1e65$var$M), b.sortIndex = b.expirationTime, $9fc720dcb1fe1e65$var$H($9fc720dcb1fe1e65$var$L, b);
        else break;
        b = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M);
    }
}
function $9fc720dcb1fe1e65$var$U(a) {
    $9fc720dcb1fe1e65$var$S = !1;
    $9fc720dcb1fe1e65$var$T(a);
    if (!$9fc720dcb1fe1e65$var$R) {
        if (null !== $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L)) $9fc720dcb1fe1e65$var$R = !0, $9fc720dcb1fe1e65$var$f($9fc720dcb1fe1e65$var$V);
        else {
            var b = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M);
            null !== b && $9fc720dcb1fe1e65$var$g($9fc720dcb1fe1e65$var$U, b.startTime - a);
        }
    }
}
function $9fc720dcb1fe1e65$var$V(a, b) {
    $9fc720dcb1fe1e65$var$R = !1;
    $9fc720dcb1fe1e65$var$S && ($9fc720dcb1fe1e65$var$S = !1, $9fc720dcb1fe1e65$var$h());
    $9fc720dcb1fe1e65$var$Q = !0;
    var c = $9fc720dcb1fe1e65$var$P;
    try {
        $9fc720dcb1fe1e65$var$T(b);
        for($9fc720dcb1fe1e65$var$O = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L); null !== $9fc720dcb1fe1e65$var$O && (!($9fc720dcb1fe1e65$var$O.expirationTime > b) || a && !$9fc720dcb1fe1e65$export$b5836b71941fa3ed());){
            var d = $9fc720dcb1fe1e65$var$O.callback;
            if ("function" === typeof d) {
                $9fc720dcb1fe1e65$var$O.callback = null;
                $9fc720dcb1fe1e65$var$P = $9fc720dcb1fe1e65$var$O.priorityLevel;
                var e = d($9fc720dcb1fe1e65$var$O.expirationTime <= b);
                b = $9fc720dcb1fe1e65$export$c4744153514ff05d();
                "function" === typeof e ? $9fc720dcb1fe1e65$var$O.callback = e : $9fc720dcb1fe1e65$var$O === $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L) && $9fc720dcb1fe1e65$var$K($9fc720dcb1fe1e65$var$L);
                $9fc720dcb1fe1e65$var$T(b);
            } else $9fc720dcb1fe1e65$var$K($9fc720dcb1fe1e65$var$L);
            $9fc720dcb1fe1e65$var$O = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L);
        }
        if (null !== $9fc720dcb1fe1e65$var$O) var m = !0;
        else {
            var n = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M);
            null !== n && $9fc720dcb1fe1e65$var$g($9fc720dcb1fe1e65$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $9fc720dcb1fe1e65$var$O = null, $9fc720dcb1fe1e65$var$P = c, $9fc720dcb1fe1e65$var$Q = !1;
    }
}
var $9fc720dcb1fe1e65$var$W = $9fc720dcb1fe1e65$var$k;
$9fc720dcb1fe1e65$export$3e506c1ccc9cc1a7 = 5;
$9fc720dcb1fe1e65$export$e26fe2ed2fa76875 = 1;
$9fc720dcb1fe1e65$export$502329bbf4b505b1 = 4;
$9fc720dcb1fe1e65$export$6e3807111c4874c4 = 3;
$9fc720dcb1fe1e65$export$c27134553091fb3a = null;
$9fc720dcb1fe1e65$export$33ee1acdc04fd2a2 = 2;
$9fc720dcb1fe1e65$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9fc720dcb1fe1e65$export$8352ce38b91d0c62 = function() {
    $9fc720dcb1fe1e65$var$R || $9fc720dcb1fe1e65$var$Q || ($9fc720dcb1fe1e65$var$R = !0, $9fc720dcb1fe1e65$var$f($9fc720dcb1fe1e65$var$V));
};
$9fc720dcb1fe1e65$export$d3dfb8e4810cb555 = function() {
    return $9fc720dcb1fe1e65$var$P;
};
$9fc720dcb1fe1e65$export$839f9183b0465a69 = function() {
    return $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L);
};
$9fc720dcb1fe1e65$export$72fdf0e06517287b = function(a) {
    switch($9fc720dcb1fe1e65$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9fc720dcb1fe1e65$var$P;
    }
    var c = $9fc720dcb1fe1e65$var$P;
    $9fc720dcb1fe1e65$var$P = b;
    try {
        return a();
    } finally{
        $9fc720dcb1fe1e65$var$P = c;
    }
};
$9fc720dcb1fe1e65$export$4b844e58a3e414b4 = function() {};
$9fc720dcb1fe1e65$export$816d2913ae6b83b1 = $9fc720dcb1fe1e65$var$W;
$9fc720dcb1fe1e65$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9fc720dcb1fe1e65$var$P;
    $9fc720dcb1fe1e65$var$P = a;
    try {
        return b();
    } finally{
        $9fc720dcb1fe1e65$var$P = c;
    }
};
$9fc720dcb1fe1e65$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9fc720dcb1fe1e65$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9fc720dcb1fe1e65$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9fc720dcb1fe1e65$var$H($9fc720dcb1fe1e65$var$M, a), null === $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L) && a === $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M) && ($9fc720dcb1fe1e65$var$S ? $9fc720dcb1fe1e65$var$h() : $9fc720dcb1fe1e65$var$S = !0, $9fc720dcb1fe1e65$var$g($9fc720dcb1fe1e65$var$U, c - d))) : (a.sortIndex = e, $9fc720dcb1fe1e65$var$H($9fc720dcb1fe1e65$var$L, a), $9fc720dcb1fe1e65$var$R || $9fc720dcb1fe1e65$var$Q || ($9fc720dcb1fe1e65$var$R = !0, $9fc720dcb1fe1e65$var$f($9fc720dcb1fe1e65$var$V)));
    return a;
};
$9fc720dcb1fe1e65$export$cf845f2c119da08a = function(a) {
    var b = $9fc720dcb1fe1e65$var$P;
    return function() {
        var c = $9fc720dcb1fe1e65$var$P;
        $9fc720dcb1fe1e65$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9fc720dcb1fe1e65$var$P = c;
        }
    };
};

});



parcelRegister("iOWL4", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DiffEditor", {
    enumerable: true,
    get: function get() {
        return $db3a79a79fe4af9e$var$_DiffEditor.default;
    }
});
Object.defineProperty(module.exports, "ControlledEditor", {
    enumerable: true,
    get: function get() {
        return $db3a79a79fe4af9e$var$_ControlledEditor.default;
    }
});
Object.defineProperty(module.exports, "monaco", {
    enumerable: true,
    get: function get() {
        return $g6ngp.monaco;
    }
});
module.exports.default = void 0;

var $db3a79a79fe4af9e$var$_Editor = $1rPoN((parcelRequire("6EnQP")));

var $db3a79a79fe4af9e$var$_DiffEditor = $1rPoN((parcelRequire("hrLEX")));

var $db3a79a79fe4af9e$var$_ControlledEditor = $1rPoN((parcelRequire("29IjN")));

var $g6ngp = parcelRequire("g6ngp");
var $db3a79a79fe4af9e$var$_default = $db3a79a79fe4af9e$var$_Editor.default;
module.exports.default = $db3a79a79fe4af9e$var$_default;

});
parcelRegister("1rPoN", function(module, exports) {
function $10e02ecf9090bc17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $10e02ecf9090bc17$var$_interopRequireDefault;

});

parcelRegister("6EnQP", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jSIPP = parcelRequire("jSIPP");

var $4d78fad80f5c9654$var$_Editor = $1rPoN((parcelRequire("fwcRv")));
var $4d78fad80f5c9654$var$_default = /*#__PURE__*/ (0, $jSIPP.memo)($4d78fad80f5c9654$var$_Editor.default);
module.exports.default = $4d78fad80f5c9654$var$_default;

});
parcelRegister("fwcRv", function(module, exports) {
"use strict";

var $daKb1 = parcelRequire("daKb1");

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4c3d249ea9fa68f$var$_objectSpread2 = $1rPoN((parcelRequire("llXtj")));

var $b4c3d249ea9fa68f$var$_slicedToArray2 = $1rPoN((parcelRequire("bT9X2")));

var $b4c3d249ea9fa68f$var$_react = $daKb1((parcelRequire("jSIPP")));

var $b4c3d249ea9fa68f$var$_propTypes = $1rPoN((parcelRequire("26IBV")));

var $b4c3d249ea9fa68f$var$_MonacoContainer = $1rPoN((parcelRequire("dYlT9")));

var $g6ngp = parcelRequire("g6ngp");

var $hxOUl = parcelRequire("hxOUl");

var $b4c3d249ea9fa68f$var$_themes = $1rPoN((parcelRequire("8WPfY")));
var $b4c3d249ea9fa68f$var$Editor = function Editor(_ref) {
    var value = _ref.value, language = _ref.language, editorDidMount = _ref.editorDidMount, theme = _ref.theme, line = _ref.line, width = _ref.width, height = _ref.height, loading = _ref.loading, options = _ref.options, overrideServices = _ref.overrideServices, _isControlledMode = _ref._isControlledMode, className = _ref.className, wrapperClassName = _ref.wrapperClassName;
    var _useState = (0, $b4c3d249ea9fa68f$var$_react.useState)(false), _useState2 = (0, $b4c3d249ea9fa68f$var$_slicedToArray2.default)(_useState, 2), isEditorReady = _useState2[0], setIsEditorReady = _useState2[1];
    var _useState3 = (0, $b4c3d249ea9fa68f$var$_react.useState)(true), _useState4 = (0, $b4c3d249ea9fa68f$var$_slicedToArray2.default)(_useState3, 2), isMonacoMounting = _useState4[0], setIsMonacoMounting = _useState4[1];
    var editorRef = (0, $b4c3d249ea9fa68f$var$_react.useRef)();
    var monacoRef = (0, $b4c3d249ea9fa68f$var$_react.useRef)();
    var containerRef = (0, $b4c3d249ea9fa68f$var$_react.useRef)();
    (0, $hxOUl.useMount)(function() {
        var cancelable = $g6ngp.monaco.init();
        cancelable.then(function(monaco) {
            return (monacoRef.current = monaco) && setIsMonacoMounting(false);
        }).catch(function(error) {
            return (error === null || error === void 0 ? void 0 : error.type) !== "cancelation" && console.error("Monaco initialization: error:", error);
        });
        return function() {
            return editorRef.current ? disposeEditor() : cancelable.cancel();
        };
    });
    (0, $hxOUl.useUpdate)(function() {
        editorRef.current.updateOptions(options);
    }, [
        options
    ], isEditorReady);
    (0, $hxOUl.useUpdate)(function() {
        if (editorRef.current.getOption(monacoRef.current.editor.EditorOption.readOnly)) editorRef.current.setValue(value);
        else if (value !== editorRef.current.getValue()) {
            editorRef.current.executeEdits("", [
                {
                    range: editorRef.current.getModel().getFullModelRange(),
                    text: value
                }
            ]);
            if (_isControlledMode) {
                var model = editorRef.current.getModel();
                model.forceTokenization(model.getLineCount());
            }
            editorRef.current.pushUndoStop();
        }
    }, [
        value
    ], isEditorReady);
    (0, $hxOUl.useUpdate)(function() {
        monacoRef.current.editor.setModelLanguage(editorRef.current.getModel(), language);
    }, [
        language
    ], isEditorReady);
    (0, $hxOUl.useUpdate)(function() {
        editorRef.current.setScrollPosition({
            scrollTop: line
        });
    }, [
        line
    ], isEditorReady);
    (0, $hxOUl.useUpdate)(function() {
        monacoRef.current.editor.setTheme(theme);
    }, [
        theme
    ], isEditorReady);
    var createEditor = (0, $b4c3d249ea9fa68f$var$_react.useCallback)(function() {
        editorRef.current = monacoRef.current.editor.create(containerRef.current, (0, $b4c3d249ea9fa68f$var$_objectSpread2.default)({
            value: value,
            language: language,
            automaticLayout: true
        }, options), overrideServices);
        editorDidMount(editorRef.current.getValue.bind(editorRef.current), editorRef.current);
        monacoRef.current.editor.defineTheme("dark", $b4c3d249ea9fa68f$var$_themes.default["night-dark"]);
        monacoRef.current.editor.setTheme(theme);
        setIsEditorReady(true);
    }, [
        editorDidMount,
        language,
        options,
        overrideServices,
        theme,
        value
    ]);
    (0, $b4c3d249ea9fa68f$var$_react.useEffect)(function() {
        !isMonacoMounting && !isEditorReady && createEditor();
    }, [
        isMonacoMounting,
        isEditorReady,
        createEditor
    ]);
    var disposeEditor = function disposeEditor() {
        return editorRef.current.dispose();
    };
    return /*#__PURE__*/ $b4c3d249ea9fa68f$var$_react.default.createElement($b4c3d249ea9fa68f$var$_MonacoContainer.default, {
        width: width,
        height: height,
        isEditorReady: isEditorReady,
        loading: loading,
        _ref: containerRef,
        className: className,
        wrapperClassName: wrapperClassName
    });
};
$b4c3d249ea9fa68f$var$Editor.propTypes = {
    value: $b4c3d249ea9fa68f$var$_propTypes.default.string,
    language: $b4c3d249ea9fa68f$var$_propTypes.default.string,
    editorDidMount: $b4c3d249ea9fa68f$var$_propTypes.default.func,
    theme: $b4c3d249ea9fa68f$var$_propTypes.default.string,
    line: $b4c3d249ea9fa68f$var$_propTypes.default.number,
    width: $b4c3d249ea9fa68f$var$_propTypes.default.oneOfType([
        $b4c3d249ea9fa68f$var$_propTypes.default.number,
        $b4c3d249ea9fa68f$var$_propTypes.default.string
    ]),
    height: $b4c3d249ea9fa68f$var$_propTypes.default.oneOfType([
        $b4c3d249ea9fa68f$var$_propTypes.default.number,
        $b4c3d249ea9fa68f$var$_propTypes.default.string
    ]),
    loading: $b4c3d249ea9fa68f$var$_propTypes.default.oneOfType([
        $b4c3d249ea9fa68f$var$_propTypes.default.element,
        $b4c3d249ea9fa68f$var$_propTypes.default.string
    ]),
    options: $b4c3d249ea9fa68f$var$_propTypes.default.object,
    className: $b4c3d249ea9fa68f$var$_propTypes.default.string,
    wrapperClassName: $b4c3d249ea9fa68f$var$_propTypes.default.string,
    overrideServices: $b4c3d249ea9fa68f$var$_propTypes.default.object,
    _isControlledMode: $b4c3d249ea9fa68f$var$_propTypes.default.bool
};
$b4c3d249ea9fa68f$var$Editor.defaultProps = {
    editorDidMount: $g6ngp.noop,
    theme: "light",
    width: "100%",
    height: "100%",
    loading: "Loading...",
    options: {},
    overrideServices: {},
    _isControlledMode: false
};
var $b4c3d249ea9fa68f$var$_default = $b4c3d249ea9fa68f$var$Editor;
module.exports.default = $b4c3d249ea9fa68f$var$_default;

});
parcelRegister("daKb1", function(module, exports) {

var $kcJAA = parcelRequire("kcJAA");
function $9970074128bbf86e$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $9970074128bbf86e$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $9970074128bbf86e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $kcJAA(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $9970074128bbf86e$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
module.exports = $9970074128bbf86e$var$_interopRequireWildcard;

});
parcelRegister("kcJAA", function(module, exports) {
function $eb584ab3aed4e177$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") module.exports = $eb584ab3aed4e177$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else module.exports = $eb584ab3aed4e177$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eb584ab3aed4e177$var$_typeof(obj);
}
module.exports = $eb584ab3aed4e177$var$_typeof;

});


parcelRegister("llXtj", function(module, exports) {

var $cnt34 = parcelRequire("cnt34");
function $f8b9b101343864a5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f8b9b101343864a5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f8b9b101343864a5$var$ownKeys(Object(source), true).forEach(function(key) {
            $cnt34(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f8b9b101343864a5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
module.exports = $f8b9b101343864a5$var$_objectSpread2;

});
parcelRegister("cnt34", function(module, exports) {
function $902e2a77c7e421ba$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $902e2a77c7e421ba$var$_defineProperty;

});


parcelRegister("bT9X2", function(module, exports) {

var $8JjNm = parcelRequire("8JjNm");

var $cet8C = parcelRequire("cet8C");

var $cyQYU = parcelRequire("cyQYU");

var $2XMZK = parcelRequire("2XMZK");
function $8a7c8cda476cd1ab$var$_slicedToArray(arr, i) {
    return $8JjNm(arr) || $cet8C(arr, i) || $cyQYU(arr, i) || $2XMZK();
}
module.exports = $8a7c8cda476cd1ab$var$_slicedToArray;

});
parcelRegister("8JjNm", function(module, exports) {
function $65b1e195f6cdb953$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $65b1e195f6cdb953$var$_arrayWithHoles;

});

parcelRegister("cet8C", function(module, exports) {
function $8e7d651149ece428$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = $8e7d651149ece428$var$_iterableToArrayLimit;

});

parcelRegister("cyQYU", function(module, exports) {

var $7Px7O = parcelRequire("7Px7O");
function $9251c20769b06c38$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7Px7O(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7Px7O(o, minLen);
}
module.exports = $9251c20769b06c38$var$_unsupportedIterableToArray;

});
parcelRegister("7Px7O", function(module, exports) {
function $0178a0feff34c2fb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $0178a0feff34c2fb$var$_arrayLikeToArray;

});


parcelRegister("2XMZK", function(module, exports) {
function $228718d3c26e0d08$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $228718d3c26e0d08$var$_nonIterableRest;

});


parcelRegister("26IBV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $188ebf0fb21a217d$var$ReactIs, $188ebf0fb21a217d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("kHujd"))();

});
parcelRegister("kHujd", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1gTt1 = parcelRequire("1gTt1");
function $f11f558512582ed5$var$emptyFunction() {}
function $f11f558512582ed5$var$emptyFunctionWithReset() {}
$f11f558512582ed5$var$emptyFunctionWithReset.resetWarningCache = $f11f558512582ed5$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $1gTt1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f11f558512582ed5$var$emptyFunctionWithReset,
        resetWarningCache: $f11f558512582ed5$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("1gTt1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $0ed24fabe6ffc3d4$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $0ed24fabe6ffc3d4$var$ReactPropTypesSecret;

});



parcelRegister("dYlT9", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jSIPP = parcelRequire("jSIPP");

var $a2c1db971c755f86$var$_MonacoContainer = $1rPoN((parcelRequire("bRQGe")));
var $a2c1db971c755f86$var$_default = /*#__PURE__*/ (0, $jSIPP.memo)($a2c1db971c755f86$var$_MonacoContainer.default);
module.exports.default = $a2c1db971c755f86$var$_default;

});
parcelRegister("bRQGe", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a3d822084d8bfe0$var$_objectSpread2 = $1rPoN((parcelRequire("llXtj")));

var $8a3d822084d8bfe0$var$_react = $1rPoN((parcelRequire("jSIPP")));

var $8a3d822084d8bfe0$var$_propTypes = $1rPoN((parcelRequire("26IBV")));

var $8a3d822084d8bfe0$var$_Loading = $1rPoN((parcelRequire("gFT6g")));

var $8a3d822084d8bfe0$var$_styles = $1rPoN((parcelRequire("fHCbx")));
// ** forwardref render functions do not support proptypes or defaultprops **
// one of the reasons why we use a separate prop for passing ref instead of using forwardref
var $8a3d822084d8bfe0$var$MonacoContainer = function MonacoContainer(_ref2) {
    var width = _ref2.width, height = _ref2.height, isEditorReady = _ref2.isEditorReady, loading = _ref2.loading, _ref = _ref2._ref, className = _ref2.className, wrapperClassName = _ref2.wrapperClassName;
    return /*#__PURE__*/ $8a3d822084d8bfe0$var$_react.default.createElement("section", {
        style: (0, $8a3d822084d8bfe0$var$_objectSpread2.default)((0, $8a3d822084d8bfe0$var$_objectSpread2.default)({}, $8a3d822084d8bfe0$var$_styles.default.wrapper), {}, {
            width: width,
            height: height
        }),
        className: wrapperClassName
    }, !isEditorReady && /*#__PURE__*/ $8a3d822084d8bfe0$var$_react.default.createElement($8a3d822084d8bfe0$var$_Loading.default, {
        content: loading
    }), /*#__PURE__*/ $8a3d822084d8bfe0$var$_react.default.createElement("div", {
        ref: _ref,
        style: (0, $8a3d822084d8bfe0$var$_objectSpread2.default)((0, $8a3d822084d8bfe0$var$_objectSpread2.default)({}, $8a3d822084d8bfe0$var$_styles.default.fullWidth), !isEditorReady && $8a3d822084d8bfe0$var$_styles.default.hide),
        className: className
    }));
};
$8a3d822084d8bfe0$var$MonacoContainer.propTypes = {
    width: $8a3d822084d8bfe0$var$_propTypes.default.oneOfType([
        $8a3d822084d8bfe0$var$_propTypes.default.number,
        $8a3d822084d8bfe0$var$_propTypes.default.string
    ]).isRequired,
    height: $8a3d822084d8bfe0$var$_propTypes.default.oneOfType([
        $8a3d822084d8bfe0$var$_propTypes.default.number,
        $8a3d822084d8bfe0$var$_propTypes.default.string
    ]).isRequired,
    loading: $8a3d822084d8bfe0$var$_propTypes.default.oneOfType([
        $8a3d822084d8bfe0$var$_propTypes.default.element,
        $8a3d822084d8bfe0$var$_propTypes.default.string
    ]).isRequired,
    isEditorReady: $8a3d822084d8bfe0$var$_propTypes.default.bool.isRequired,
    className: $8a3d822084d8bfe0$var$_propTypes.default.string,
    wrapperClassName: $8a3d822084d8bfe0$var$_propTypes.default.string
};
var $8a3d822084d8bfe0$var$_default = $8a3d822084d8bfe0$var$MonacoContainer;
module.exports.default = $8a3d822084d8bfe0$var$_default;

});
parcelRegister("gFT6g", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c23b3766117f1904$var$_Loading = $1rPoN((parcelRequire("7yWQY")));
var $c23b3766117f1904$var$_default = $c23b3766117f1904$var$_Loading.default;
module.exports.default = $c23b3766117f1904$var$_default;

});
parcelRegister("7yWQY", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58195c71852e65fa$var$_react = $1rPoN((parcelRequire("jSIPP")));
var $58195c71852e65fa$var$loadingStyles = {
    display: "flex",
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
};
function $58195c71852e65fa$var$Loading(_ref) {
    var content = _ref.content;
    return /*#__PURE__*/ $58195c71852e65fa$var$_react.default.createElement("div", {
        style: $58195c71852e65fa$var$loadingStyles
    }, content);
}
var $58195c71852e65fa$var$_default = $58195c71852e65fa$var$Loading;
module.exports.default = $58195c71852e65fa$var$_default;

});


parcelRegister("fHCbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b6e87deffde36b03$var$styles = {
    wrapper: {
        display: "flex",
        position: "relative",
        textAlign: "initial"
    },
    fullWidth: {
        width: "100%"
    },
    hide: {
        display: "none"
    }
};
var $b6e87deffde36b03$var$_default = $b6e87deffde36b03$var$styles;
module.exports.default = $b6e87deffde36b03$var$_default;

});



parcelRegister("g6ngp", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "noop", {
    enumerable: true,
    get: function get() {
        return $bb8f409384da993e$var$_noop.default;
    }
});
Object.defineProperty(module.exports, "compose", {
    enumerable: true,
    get: function get() {
        return $bb8f409384da993e$var$_compose.default;
    }
});
Object.defineProperty(module.exports, "deepMerge", {
    enumerable: true,
    get: function get() {
        return $bb8f409384da993e$var$_deepMerge.default;
    }
});
Object.defineProperty(module.exports, "makeCancelable", {
    enumerable: true,
    get: function get() {
        return $bb8f409384da993e$var$_makeCancelable.default;
    }
});
Object.defineProperty(module.exports, "monaco", {
    enumerable: true,
    get: function get() {
        return $bb8f409384da993e$var$_monaco.default;
    }
});

var $bb8f409384da993e$var$_noop = $1rPoN((parcelRequire("5Av2v")));

var $bb8f409384da993e$var$_compose = $1rPoN((parcelRequire("d7WWD")));

var $bb8f409384da993e$var$_deepMerge = $1rPoN((parcelRequire("hMqjR")));

var $bb8f409384da993e$var$_makeCancelable = $1rPoN((parcelRequire("3CQDN")));

var $bb8f409384da993e$var$_monaco = $1rPoN((parcelRequire("7MdgV")));

});
parcelRegister("5Av2v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4118644f64b7e23e$var$noop = function noop() {};
var $4118644f64b7e23e$var$_default = $4118644f64b7e23e$var$noop;
module.exports.default = $4118644f64b7e23e$var$_default;

});

parcelRegister("d7WWD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $98e9a704e196e3ce$var$compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
};
var $98e9a704e196e3ce$var$_default = $98e9a704e196e3ce$var$compose;
module.exports.default = $98e9a704e196e3ce$var$_default;

});

parcelRegister("hMqjR", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf1b55d9d6e0d72d$var$_objectSpread2 = $1rPoN((parcelRequire("llXtj")));
var $cf1b55d9d6e0d72d$var$merge = function merge(target, source) {
    Object.keys(source).forEach(function(key) {
        if (source[key] instanceof Object) target[key] && Object.assign(source[key], merge(target[key], source[key]));
    });
    return (0, $cf1b55d9d6e0d72d$var$_objectSpread2.default)((0, $cf1b55d9d6e0d72d$var$_objectSpread2.default)({}, target), source);
};
var $cf1b55d9d6e0d72d$var$_default = $cf1b55d9d6e0d72d$var$merge;
module.exports.default = $cf1b55d9d6e0d72d$var$_default;

});

parcelRegister("3CQDN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var $2a3dc11b65e22a7a$var$CANCELATION_MESSAGE = {
    type: "cancelation",
    msg: "operation is manually canceled"
};
var $2a3dc11b65e22a7a$var$makeCancelable = function makeCancelable(promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(val) {
            return hasCanceled_ ? reject($2a3dc11b65e22a7a$var$CANCELATION_MESSAGE) : resolve(val);
        });
        promise.catch(reject);
    });
    return wrappedPromise.cancel = function() {
        return hasCanceled_ = true;
    }, wrappedPromise;
};
var $2a3dc11b65e22a7a$var$_default = $2a3dc11b65e22a7a$var$makeCancelable;
module.exports.default = $2a3dc11b65e22a7a$var$_default;

});

parcelRegister("7MdgV", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a974f9fa1c6ee1b$var$_objectWithoutProperties2 = $1rPoN((parcelRequire("dhZIZ")));

var $5a974f9fa1c6ee1b$var$_slicedToArray2 = $1rPoN((parcelRequire("bT9X2")));

var $3T9kJ = parcelRequire("3T9kJ");

var $5a974f9fa1c6ee1b$var$_config = $1rPoN((parcelRequire("jcmSQ")));

var $g6ngp = parcelRequire("g6ngp");
var $5a974f9fa1c6ee1b$var$_createState = (0, $3T9kJ.create)({
    config: $5a974f9fa1c6ee1b$var$_config.default,
    isInitialized: false,
    configScriptSrc: null,
    resolve: null,
    reject: null
}), $5a974f9fa1c6ee1b$var$_createState2 = (0, $5a974f9fa1c6ee1b$var$_slicedToArray2.default)($5a974f9fa1c6ee1b$var$_createState, 2), $5a974f9fa1c6ee1b$var$getState = $5a974f9fa1c6ee1b$var$_createState2[0], $5a974f9fa1c6ee1b$var$setState = $5a974f9fa1c6ee1b$var$_createState2[1];
var $5a974f9fa1c6ee1b$var$MONACO_INIT = "monaco_init";
function $5a974f9fa1c6ee1b$var$config(_ref) {
    var src = _ref.src, config = (0, $5a974f9fa1c6ee1b$var$_objectWithoutProperties2.default)(_ref, [
        "src"
    ]);
    $5a974f9fa1c6ee1b$var$setState(function(state) {
        return {
            configScriptSrc: src,
            config: (0, $g6ngp.deepMerge)(state.config, $5a974f9fa1c6ee1b$var$validateConfig(config))
        };
    });
}
function $5a974f9fa1c6ee1b$var$init() {
    var state = $5a974f9fa1c6ee1b$var$getState(function(_ref2) {
        var isInitialized = _ref2.isInitialized;
        return {
            isInitialized: isInitialized
        };
    });
    if (!state.isInitialized) {
        if (window.monaco && window.monaco.editor) return Promise.resolve(window.monaco);
        document.addEventListener($5a974f9fa1c6ee1b$var$MONACO_INIT, $5a974f9fa1c6ee1b$var$handleConfigScriptLoad);
        (0, $g6ngp.compose)($5a974f9fa1c6ee1b$var$injectScripts, $5a974f9fa1c6ee1b$var$createMonacoLoaderScript, $5a974f9fa1c6ee1b$var$createConfigScript)();
        $5a974f9fa1c6ee1b$var$setState({
            isInitialized: true
        });
    }
    return (0, $g6ngp.makeCancelable)($5a974f9fa1c6ee1b$var$wrapperPromise);
}
function $5a974f9fa1c6ee1b$var$validateConfig(config) {
    if (config.urls) {
        $5a974f9fa1c6ee1b$var$informAboutDepreciation();
        return {
            paths: {
                vs: config.urls.monacoBase
            }
        };
    }
    return config;
}
function $5a974f9fa1c6ee1b$var$injectScripts(script) {
    return document.body.appendChild(script);
}
function $5a974f9fa1c6ee1b$var$createScript(src) {
    var script = document.createElement("script");
    return src && (script.src = src), script;
}
function $5a974f9fa1c6ee1b$var$handleConfigScriptLoad() {
    var state = $5a974f9fa1c6ee1b$var$getState(function(_ref3) {
        var resolve = _ref3.resolve;
        return {
            resolve: resolve
        };
    });
    document.removeEventListener($5a974f9fa1c6ee1b$var$MONACO_INIT, $5a974f9fa1c6ee1b$var$handleConfigScriptLoad);
    state.resolve(window.monaco);
}
function $5a974f9fa1c6ee1b$var$createMonacoLoaderScript(configScript) {
    var state = $5a974f9fa1c6ee1b$var$getState(function(_ref4) {
        var config = _ref4.config, reject = _ref4.reject;
        return {
            config: config,
            reject: reject
        };
    });
    var loaderScript = $5a974f9fa1c6ee1b$var$createScript("".concat(state.config.paths.vs, "/loader.js"));
    loaderScript.onload = function() {
        return $5a974f9fa1c6ee1b$var$injectScripts(configScript);
    };
    loaderScript.onerror = state.reject;
    return loaderScript;
}
function $5a974f9fa1c6ee1b$var$createConfigScript() {
    var state = $5a974f9fa1c6ee1b$var$getState(function(_ref5) {
        var configScriptSrc = _ref5.configScriptSrc, config = _ref5.config, reject = _ref5.reject;
        return {
            configScriptSrc: configScriptSrc,
            config: config,
            reject: reject
        };
    });
    var configScript = $5a974f9fa1c6ee1b$var$createScript();
    if (state.configScriptSrc) // it will be helpfull in case of CSP, which doesn't allow
    // inline script execution
    configScript.src = state.configScriptSrc;
    else configScript.innerHTML = "\n      require.config(".concat(JSON.stringify(state.config), ");\n      require(['vs/editor/editor.main'], function() {\n        document.dispatchEvent(new Event('monaco_init'));\n      });\n    ");
    configScript.onerror = state.reject;
    return configScript;
}
function $5a974f9fa1c6ee1b$var$informAboutDepreciation() {
    console.warn("Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-react#config\n  ");
}
var $5a974f9fa1c6ee1b$var$wrapperPromise = new Promise(function(resolve, reject) {
    return $5a974f9fa1c6ee1b$var$setState({
        resolve: resolve,
        reject: reject
    });
});
var $5a974f9fa1c6ee1b$var$_default = {
    config: $5a974f9fa1c6ee1b$var$config,
    init: $5a974f9fa1c6ee1b$var$init
};
module.exports.default = $5a974f9fa1c6ee1b$var$_default;

});
parcelRegister("dhZIZ", function(module, exports) {

var $6kSKS = parcelRequire("6kSKS");
function $027f2c5b639a59a2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6kSKS(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $027f2c5b639a59a2$var$_objectWithoutProperties;

});
parcelRegister("6kSKS", function(module, exports) {
function $49cf15925e823422$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $49cf15925e823422$var$_objectWithoutPropertiesLoose;

});


parcelRegister("3T9kJ", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function n(r) {
            if (t[r]) return t[r].exports;
            var o = t[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return r;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            function r() {
                for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                return function(e) {
                    return t.reduceRight(function(e, t) {
                        return t(e);
                    }, e);
                };
            }
            function o(e) {
                return function t() {
                    for(var n = this, r = arguments.length, o = new Array(r), i = 0; i < r; i++)o[i] = arguments[i];
                    return o.length >= e.length ? e.apply(this, o) : function() {
                        for(var e = arguments.length, r = new Array(e), i = 0; i < e; i++)r[i] = arguments[i];
                        return t.apply(n, [].concat(o, r));
                    };
                };
            }
            function i(e) {
                return ({}).toString.call(e).includes("Object");
            }
            function u(e) {
                return "function" == typeof e;
            }
            n.r(t), n.d(t, "create", function() {
                return p;
            });
            var c = o(function(e, t) {
                throw new Error(e[t] || e.default);
            })({
                initialIsRequired: "initial state is required",
                initialType: "initial state should be an object",
                initialContent: "initial state shouldn't be an empty object",
                handlerType: "handler should be an object or a function",
                handlersType: "all handlers should be a functions",
                selectorType: "selector should be a function",
                changeType: "provided value of changes should be an object",
                changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
                default: "an unknown error accured in `state-local` package"
            }), a = {
                changes: function(e, t) {
                    return i(t) || c("changeType"), Object.keys(t).some(function(t) {
                        var n, r;
                        return n = e, r = t, !Object.prototype.hasOwnProperty.call(n, r);
                    }) && c("changeField"), t;
                },
                selector: function(e) {
                    u(e) || c("selectorType");
                },
                handler: function(e) {
                    u(e) || i(e) || c("handlerType"), i(e) && Object.values(e).some(function(e) {
                        return !u(e);
                    }) && c("handlersType");
                },
                initial: function(e) {
                    var t;
                    e || c("initialIsRequired"), i(e) || c("initialType"), t = e, Object.keys(t).length || c("initialContent");
                }
            };
            function l(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t && (r = r.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function f(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? l(Object(n), !0).forEach(function(t) {
                        s(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                }
                return e;
            }
            function s(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            function p(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                a.initial(e), a.handler(t);
                var n = {
                    current: e
                }, i = o(b)(n, t), u = o(y)(n), c = o(a.changes)(e), l = o(d)(n);
                function f() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function(e) {
                        return e;
                    };
                    return a.selector(e), e(n.current);
                }
                function s(e) {
                    r(i, u, c, l)(e);
                }
                return [
                    f,
                    s
                ];
            }
            function d(e, t) {
                return u(t) ? t(e.current) : t;
            }
            function y(e, t) {
                return e.current = f(f({}, e.current), t), t;
            }
            function b(e, t, n) {
                return u(t) ? t(e.current) : Object.keys(n).forEach(function(n) {
                    var r;
                    return null === (r = t[n]) || void 0 === r ? void 0 : r.call(t, e.current[n]);
                }), n;
            }
            t.default = {
                create: p
            };
        }
    ]);
});

});

parcelRegister("jcmSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dfa0e3879f24663d$var$config = {
    paths: {
        vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.21.2/min/vs"
    }
};
var $dfa0e3879f24663d$var$_default = $dfa0e3879f24663d$var$config;
module.exports.default = $dfa0e3879f24663d$var$_default;

});



parcelRegister("hxOUl", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useMount", {
    enumerable: true,
    get: function get() {
        return $cc5d01f8e85ae4b3$var$_useMount.default;
    }
});
Object.defineProperty(module.exports, "useUpdate", {
    enumerable: true,
    get: function get() {
        return $cc5d01f8e85ae4b3$var$_useUpdate.default;
    }
});

var $cc5d01f8e85ae4b3$var$_useMount = $1rPoN((parcelRequire("ge6WL")));

var $cc5d01f8e85ae4b3$var$_useUpdate = $1rPoN((parcelRequire("37kKD")));

});
parcelRegister("ge6WL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jSIPP = parcelRequire("jSIPP");
var $bd0357a942519a2e$var$useMount = function useMount(effect) {
    return (0, $jSIPP.useEffect)(effect, []);
};
var $bd0357a942519a2e$var$_default = $bd0357a942519a2e$var$useMount;
module.exports.default = $bd0357a942519a2e$var$_default;

});

parcelRegister("37kKD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jSIPP = parcelRequire("jSIPP");
var $24521f51a739a018$var$useUpdate = function useUpdate(effect, deps) {
    var applyChanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var isInitialMount = (0, $jSIPP.useRef)(true);
    (0, $jSIPP.useEffect)(isInitialMount.current || !applyChanges ? function() {
        isInitialMount.current = false;
    } : effect, deps);
};
var $24521f51a739a018$var$_default = $24521f51a739a018$var$useUpdate;
module.exports.default = $24521f51a739a018$var$_default;

});


parcelRegister("8WPfY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $683b8001cbb03a68$var$themes = {
    "night-dark": {
        base: "vs-dark",
        inherit: true,
        rules: [],
        colors: {
            "editor.background": "#202124"
        }
    }
};
var $683b8001cbb03a68$var$_default = $683b8001cbb03a68$var$themes;
module.exports.default = $683b8001cbb03a68$var$_default;

});



parcelRegister("hrLEX", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jSIPP = parcelRequire("jSIPP");

var $cb39ed810ce9c5df$var$_DiffEditor = $1rPoN((parcelRequire("2UUQV")));
var $cb39ed810ce9c5df$var$_default = /*#__PURE__*/ (0, $jSIPP.memo)($cb39ed810ce9c5df$var$_DiffEditor.default);
module.exports.default = $cb39ed810ce9c5df$var$_default;

});
parcelRegister("2UUQV", function(module, exports) {
"use strict";

var $daKb1 = parcelRequire("daKb1");

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21fce978450ad401$var$_objectSpread2 = $1rPoN((parcelRequire("llXtj")));

var $21fce978450ad401$var$_slicedToArray2 = $1rPoN((parcelRequire("bT9X2")));

var $21fce978450ad401$var$_react = $daKb1((parcelRequire("jSIPP")));

var $21fce978450ad401$var$_propTypes = $1rPoN((parcelRequire("26IBV")));

var $21fce978450ad401$var$_MonacoContainer = $1rPoN((parcelRequire("dYlT9")));

var $g6ngp = parcelRequire("g6ngp");

var $hxOUl = parcelRequire("hxOUl");

var $21fce978450ad401$var$_themes = $1rPoN((parcelRequire("8WPfY")));
var $21fce978450ad401$var$DiffEditor = function DiffEditor(_ref) {
    var original = _ref.original, modified = _ref.modified, language = _ref.language, originalLanguage = _ref.originalLanguage, modifiedLanguage = _ref.modifiedLanguage, editorDidMount = _ref.editorDidMount, theme = _ref.theme, width = _ref.width, height = _ref.height, loading = _ref.loading, options = _ref.options, className = _ref.className, wrapperClassName = _ref.wrapperClassName;
    var _useState = (0, $21fce978450ad401$var$_react.useState)(false), _useState2 = (0, $21fce978450ad401$var$_slicedToArray2.default)(_useState, 2), isEditorReady = _useState2[0], setIsEditorReady = _useState2[1];
    var _useState3 = (0, $21fce978450ad401$var$_react.useState)(true), _useState4 = (0, $21fce978450ad401$var$_slicedToArray2.default)(_useState3, 2), isMonacoMounting = _useState4[0], setIsMonacoMounting = _useState4[1];
    var editorRef = (0, $21fce978450ad401$var$_react.useRef)();
    var monacoRef = (0, $21fce978450ad401$var$_react.useRef)();
    var containerRef = (0, $21fce978450ad401$var$_react.useRef)();
    (0, $hxOUl.useMount)(function() {
        var cancelable = $g6ngp.monaco.init();
        cancelable.then(function(monaco) {
            return (monacoRef.current = monaco) && setIsMonacoMounting(false);
        }).catch(function(error) {
            return (error === null || error === void 0 ? void 0 : error.type) !== "cancelation" && console.error("Monaco initialization: error:", error);
        });
        return function() {
            return editorRef.current ? disposeEditor() : cancelable.cancel();
        };
    });
    (0, $hxOUl.useUpdate)(function() {
        editorRef.current.getModel().modified.setValue(modified);
    }, [
        modified
    ], isEditorReady);
    (0, $hxOUl.useUpdate)(function() {
        editorRef.current.getModel().original.setValue(original);
    }, [
        original
    ], isEditorReady);
    (0, $hxOUl.useUpdate)(function() {
        var _editorRef$current$ge = editorRef.current.getModel(), original = _editorRef$current$ge.original, modified = _editorRef$current$ge.modified;
        monacoRef.current.editor.setModelLanguage(original, originalLanguage || language);
        monacoRef.current.editor.setModelLanguage(modified, modifiedLanguage || language);
    }, [
        language,
        originalLanguage,
        modifiedLanguage
    ], isEditorReady);
    (0, $hxOUl.useUpdate)(function() {
        monacoRef.current.editor.setTheme(theme);
    }, [
        theme
    ], isEditorReady);
    (0, $hxOUl.useUpdate)(function() {
        editorRef.current.updateOptions(options);
    }, [
        options
    ], isEditorReady);
    var setModels = (0, $21fce978450ad401$var$_react.useCallback)(function() {
        var originalModel = monacoRef.current.editor.createModel(original, originalLanguage || language);
        var modifiedModel = monacoRef.current.editor.createModel(modified, modifiedLanguage || language);
        editorRef.current.setModel({
            original: originalModel,
            modified: modifiedModel
        });
    }, [
        language,
        modified,
        modifiedLanguage,
        original,
        originalLanguage
    ]);
    var createEditor = (0, $21fce978450ad401$var$_react.useCallback)(function() {
        editorRef.current = monacoRef.current.editor.createDiffEditor(containerRef.current, (0, $21fce978450ad401$var$_objectSpread2.default)({
            automaticLayout: true
        }, options));
        setModels();
        var _editorRef$current$ge2 = editorRef.current.getModel(), original = _editorRef$current$ge2.original, modified = _editorRef$current$ge2.modified;
        editorDidMount(modified.getValue.bind(modified), original.getValue.bind(original), editorRef.current);
        monacoRef.current.editor.defineTheme("dark", $21fce978450ad401$var$_themes.default["night-dark"]);
        monacoRef.current.editor.setTheme(theme);
        setIsEditorReady(true);
    }, [
        editorDidMount,
        options,
        theme,
        setModels
    ]);
    (0, $21fce978450ad401$var$_react.useEffect)(function() {
        !isMonacoMounting && !isEditorReady && createEditor();
    }, [
        isMonacoMounting,
        isEditorReady,
        createEditor
    ]);
    var disposeEditor = function disposeEditor() {
        return editorRef.current.dispose();
    };
    return /*#__PURE__*/ $21fce978450ad401$var$_react.default.createElement($21fce978450ad401$var$_MonacoContainer.default, {
        width: width,
        height: height,
        isEditorReady: isEditorReady,
        loading: loading,
        _ref: containerRef,
        className: className,
        wrapperClassName: wrapperClassName
    });
};
$21fce978450ad401$var$DiffEditor.propTypes = {
    original: $21fce978450ad401$var$_propTypes.default.string,
    modified: $21fce978450ad401$var$_propTypes.default.string,
    language: $21fce978450ad401$var$_propTypes.default.string,
    originalLanguage: $21fce978450ad401$var$_propTypes.default.string,
    modifiedLanguage: $21fce978450ad401$var$_propTypes.default.string,
    editorDidMount: $21fce978450ad401$var$_propTypes.default.func,
    theme: $21fce978450ad401$var$_propTypes.default.string,
    width: $21fce978450ad401$var$_propTypes.default.oneOfType([
        $21fce978450ad401$var$_propTypes.default.number,
        $21fce978450ad401$var$_propTypes.default.string
    ]),
    height: $21fce978450ad401$var$_propTypes.default.oneOfType([
        $21fce978450ad401$var$_propTypes.default.number,
        $21fce978450ad401$var$_propTypes.default.string
    ]),
    loading: $21fce978450ad401$var$_propTypes.default.oneOfType([
        $21fce978450ad401$var$_propTypes.default.element,
        $21fce978450ad401$var$_propTypes.default.string
    ]),
    options: $21fce978450ad401$var$_propTypes.default.object,
    className: $21fce978450ad401$var$_propTypes.default.string,
    wrapperClassName: $21fce978450ad401$var$_propTypes.default.string
};
$21fce978450ad401$var$DiffEditor.defaultProps = {
    editorDidMount: $g6ngp.noop,
    theme: "light",
    width: "100%",
    height: "100%",
    loading: "Loading...",
    options: {}
};
var $21fce978450ad401$var$_default = $21fce978450ad401$var$DiffEditor;
module.exports.default = $21fce978450ad401$var$_default;

});


parcelRegister("29IjN", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jSIPP = parcelRequire("jSIPP");

var $191eccc005288a83$var$_ControlledEditor = $1rPoN((parcelRequire("ko1A7")));
var $191eccc005288a83$var$_default = /*#__PURE__*/ (0, $jSIPP.memo)($191eccc005288a83$var$_ControlledEditor.default);
module.exports.default = $191eccc005288a83$var$_default;

});
parcelRegister("ko1A7", function(module, exports) {
"use strict";

var $daKb1 = parcelRequire("daKb1");

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed7746a014da76d7$var$_extends2 = $1rPoN((parcelRequire("1Gnf1")));

var $ed7746a014da76d7$var$_objectWithoutProperties2 = $1rPoN((parcelRequire("dhZIZ")));

var $ed7746a014da76d7$var$_react = $daKb1((parcelRequire("jSIPP")));

var $ed7746a014da76d7$var$_propTypes = $1rPoN((parcelRequire("26IBV")));

var $ed7746a014da76d7$var$_ = $1rPoN((parcelRequire("iOWL4")));

var $g6ngp = parcelRequire("g6ngp");
function $ed7746a014da76d7$var$ControlledEditor(_ref) {
    var providedValue = _ref.value, onChange = _ref.onChange, editorDidMount = _ref.editorDidMount, props = (0, $ed7746a014da76d7$var$_objectWithoutProperties2.default)(_ref, [
        "value",
        "onChange",
        "editorDidMount"
    ]);
    var editor = (0, $ed7746a014da76d7$var$_react.useRef)(null);
    var listener = (0, $ed7746a014da76d7$var$_react.useRef)(null);
    var value = (0, $ed7746a014da76d7$var$_react.useRef)(providedValue); // to avoid unnecessary updates in `handleEditorModelChange`
    // (that depends on the `current value` and will trigger to update `attachChangeEventListener`,
    // thus, the listener will be disposed and attached again for every value change)
    // the current value is stored in ref (useRef) instead of being a dependency of `handleEditorModelChange`
    value.current = providedValue;
    var handleEditorModelChange = (0, $ed7746a014da76d7$var$_react.useCallback)(function(event) {
        var editorValue = editor.current.getValue();
        if (value.current !== editorValue) {
            var directChange = onChange(event, editorValue);
            if (typeof directChange === "string" && editorValue !== directChange) editor.current.setValue(directChange);
        }
    }, [
        onChange
    ]);
    var attachChangeEventListener = (0, $ed7746a014da76d7$var$_react.useCallback)(function() {
        var _editor$current;
        listener.current = (_editor$current = editor.current) === null || _editor$current === void 0 ? void 0 : _editor$current.onDidChangeModelContent(handleEditorModelChange);
    }, [
        handleEditorModelChange
    ]);
    (0, $ed7746a014da76d7$var$_react.useEffect)(function() {
        attachChangeEventListener();
        return function() {
            var _listener$current;
            return (_listener$current = listener.current) === null || _listener$current === void 0 ? void 0 : _listener$current.dispose();
        };
    }, [
        attachChangeEventListener
    ]);
    var handleEditorDidMount = (0, $ed7746a014da76d7$var$_react.useCallback)(function(getValue, _editor) {
        editor.current = _editor;
        attachChangeEventListener();
        editorDidMount(getValue, _editor);
    }, [
        attachChangeEventListener,
        editorDidMount
    ]);
    return /*#__PURE__*/ $ed7746a014da76d7$var$_react.default.createElement($ed7746a014da76d7$var$_.default, (0, $ed7746a014da76d7$var$_extends2.default)({
        value: providedValue,
        editorDidMount: handleEditorDidMount,
        _isControlledMode: true
    }, props));
}
$ed7746a014da76d7$var$ControlledEditor.propTypes = {
    value: $ed7746a014da76d7$var$_propTypes.default.string,
    editorDidMount: $ed7746a014da76d7$var$_propTypes.default.func,
    onChange: $ed7746a014da76d7$var$_propTypes.default.func
};
$ed7746a014da76d7$var$ControlledEditor.defaultProps = {
    editorDidMount: $g6ngp.noop,
    onChange: $g6ngp.noop
};
var $ed7746a014da76d7$var$_default = $ed7746a014da76d7$var$ControlledEditor;
module.exports.default = $ed7746a014da76d7$var$_default;

});
parcelRegister("1Gnf1", function(module, exports) {
function $139bbdf0c1c6e7bc$var$_extends() {
    module.exports = $139bbdf0c1c6e7bc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $139bbdf0c1c6e7bc$var$_extends.apply(this, arguments);
}
module.exports = $139bbdf0c1c6e7bc$var$_extends;

});




parcelRegister("31NQl", function(module, exports) {
"use strict";
var $234820ea5e2e97ad$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $234820ea5e2e97ad$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $234820ea5e2e97ad$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("7MuIT", function(module, exports) {
"use strict";
var $5aa4d90dd24de348$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $5aa4d90dd24de348$var$has = Object.prototype.hasOwnProperty;
    var $5aa4d90dd24de348$var$toStr = Object.prototype.toString;
    var $5aa4d90dd24de348$var$isArgs = (parcelRequire("31NQl")); // eslint-disable-line global-require
    var $5aa4d90dd24de348$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $5aa4d90dd24de348$var$hasDontEnumBug = !$5aa4d90dd24de348$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $5aa4d90dd24de348$var$hasProtoEnumBug = $5aa4d90dd24de348$var$isEnumerable.call(function() {}, "prototype");
    var $5aa4d90dd24de348$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $5aa4d90dd24de348$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $5aa4d90dd24de348$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $5aa4d90dd24de348$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$5aa4d90dd24de348$var$excludedKeys["$" + k] && $5aa4d90dd24de348$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $5aa4d90dd24de348$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $5aa4d90dd24de348$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$5aa4d90dd24de348$var$hasAutomationEqualityBug) return $5aa4d90dd24de348$var$equalsConstructorPrototype(o);
        try {
            return $5aa4d90dd24de348$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $5aa4d90dd24de348$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $5aa4d90dd24de348$var$toStr.call(object) === "[object Function]";
        var isArguments = $5aa4d90dd24de348$var$isArgs(object);
        var isString = isObject && $5aa4d90dd24de348$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $5aa4d90dd24de348$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$5aa4d90dd24de348$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $5aa4d90dd24de348$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($5aa4d90dd24de348$var$hasDontEnumBug) {
            var skipConstructor = $5aa4d90dd24de348$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $5aa4d90dd24de348$var$dontEnums.length; ++k)if (!(skipConstructor && $5aa4d90dd24de348$var$dontEnums[k] === "constructor") && $5aa4d90dd24de348$var$has.call(object, $5aa4d90dd24de348$var$dontEnums[k])) theKeys.push($5aa4d90dd24de348$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $5aa4d90dd24de348$var$keysShim;

});

parcelRegister("e0BBw", function(module, exports) {
"use strict";
/* globals
	AggregateError,
	Atomics,
	FinalizationRegistry,
	SharedArrayBuffer,
	WeakRef,
*/ var $a32e3c2da1678e38$var$undefined1;
var $a32e3c2da1678e38$var$$SyntaxError = SyntaxError;
var $a32e3c2da1678e38$var$$Function = Function;
var $a32e3c2da1678e38$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $a32e3c2da1678e38$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        // eslint-disable-next-line no-new-func
        return Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $a32e3c2da1678e38$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($a32e3c2da1678e38$var$$gOPD) try {
    $a32e3c2da1678e38$var$$gOPD({}, "");
} catch (e) {
    $a32e3c2da1678e38$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $a32e3c2da1678e38$var$throwTypeError = function() {
    throw new $a32e3c2da1678e38$var$$TypeError();
};
var $a32e3c2da1678e38$var$ThrowTypeError = $a32e3c2da1678e38$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $a32e3c2da1678e38$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $a32e3c2da1678e38$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $a32e3c2da1678e38$var$throwTypeError;
        }
    }
}() : $a32e3c2da1678e38$var$throwTypeError;

var $a32e3c2da1678e38$var$hasSymbols = (parcelRequire("3MbC0"))();
var $a32e3c2da1678e38$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $a32e3c2da1678e38$var$asyncGenFunction = $a32e3c2da1678e38$var$getEvalledConstructor("async function* () {}");
var $a32e3c2da1678e38$var$asyncGenFunctionPrototype = $a32e3c2da1678e38$var$asyncGenFunction ? $a32e3c2da1678e38$var$asyncGenFunction.prototype : undefined;
var $a32e3c2da1678e38$var$asyncGenPrototype = $a32e3c2da1678e38$var$asyncGenFunctionPrototype ? $a32e3c2da1678e38$var$asyncGenFunctionPrototype.prototype : undefined;
var $a32e3c2da1678e38$var$TypedArray = typeof Uint8Array === "undefined" ? undefined : $a32e3c2da1678e38$var$getProto(Uint8Array);
var $a32e3c2da1678e38$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $a32e3c2da1678e38$var$hasSymbols ? $a32e3c2da1678e38$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $a32e3c2da1678e38$var$getEvalledConstructor("async function () {}"),
    "%AsyncGenerator%": $a32e3c2da1678e38$var$asyncGenFunctionPrototype,
    "%AsyncGeneratorFunction%": $a32e3c2da1678e38$var$asyncGenFunction,
    "%AsyncIteratorPrototype%": $a32e3c2da1678e38$var$asyncGenPrototype ? $a32e3c2da1678e38$var$getProto($a32e3c2da1678e38$var$asyncGenPrototype) : undefined,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $a32e3c2da1678e38$var$$Function,
    "%GeneratorFunction%": $a32e3c2da1678e38$var$getEvalledConstructor("function* () {}"),
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $a32e3c2da1678e38$var$hasSymbols ? $a32e3c2da1678e38$var$getProto($a32e3c2da1678e38$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$a32e3c2da1678e38$var$hasSymbols ? undefined : $a32e3c2da1678e38$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$a32e3c2da1678e38$var$hasSymbols ? undefined : $a32e3c2da1678e38$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $a32e3c2da1678e38$var$hasSymbols ? $a32e3c2da1678e38$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $a32e3c2da1678e38$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $a32e3c2da1678e38$var$$SyntaxError,
    "%ThrowTypeError%": $a32e3c2da1678e38$var$ThrowTypeError,
    "%TypedArray%": $a32e3c2da1678e38$var$TypedArray,
    "%TypeError%": $a32e3c2da1678e38$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
var $a32e3c2da1678e38$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $dcAqh = parcelRequire("dcAqh");

var $aaOJF = parcelRequire("aaOJF");
var $a32e3c2da1678e38$var$$concat = $dcAqh.call(Function.call, Array.prototype.concat);
var $a32e3c2da1678e38$var$$spliceApply = $dcAqh.call(Function.apply, Array.prototype.splice);
var $a32e3c2da1678e38$var$$replace = $dcAqh.call(Function.call, String.prototype.replace);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $a32e3c2da1678e38$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $a32e3c2da1678e38$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $a32e3c2da1678e38$var$stringToPath = function stringToPath(string) {
    var result = [];
    $a32e3c2da1678e38$var$$replace(string, $a32e3c2da1678e38$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $a32e3c2da1678e38$var$$replace(subString, $a32e3c2da1678e38$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $a32e3c2da1678e38$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($aaOJF($a32e3c2da1678e38$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $a32e3c2da1678e38$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($aaOJF($a32e3c2da1678e38$var$INTRINSICS, intrinsicName)) {
        var value = $a32e3c2da1678e38$var$INTRINSICS[intrinsicName];
        if (typeof value === "undefined" && !allowMissing) throw new $a32e3c2da1678e38$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $a32e3c2da1678e38$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $a32e3c2da1678e38$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $a32e3c2da1678e38$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $a32e3c2da1678e38$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $a32e3c2da1678e38$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $a32e3c2da1678e38$var$$spliceApply(parts, $a32e3c2da1678e38$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($aaOJF($a32e3c2da1678e38$var$INTRINSICS, intrinsicRealName)) value = $a32e3c2da1678e38$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if ($a32e3c2da1678e38$var$$gOPD && i + 1 >= parts.length) {
                var desc = $a32e3c2da1678e38$var$$gOPD(value, part);
                isOwn = !!desc;
                if (!allowMissing && !(part in value)) throw new $a32e3c2da1678e38$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $aaOJF(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $a32e3c2da1678e38$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aaOJF", function(module, exports) {
"use strict";

var $dcAqh = parcelRequire("dcAqh");
module.exports = $dcAqh.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRegister("jX9hu", function(module, exports) {
"use strict";
var $e86aba0e13940cb1$var$strValue = String.prototype.valueOf;
var $e86aba0e13940cb1$var$tryStringObject = function tryStringObject(value) {
    try {
        $e86aba0e13940cb1$var$strValue.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $e86aba0e13940cb1$var$toStr = Object.prototype.toString;
var $e86aba0e13940cb1$var$strClass = "[object String]";
var $e86aba0e13940cb1$var$hasToStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
module.exports = function isString(value) {
    if (typeof value === "string") return true;
    if (typeof value !== "object") return false;
    return $e86aba0e13940cb1$var$hasToStringTag ? $e86aba0e13940cb1$var$tryStringObject(value) : $e86aba0e13940cb1$var$toStr.call(value) === $e86aba0e13940cb1$var$strClass;
};

});

parcelRegister("ghOdW", function(module, exports) {
"use strict";

var $e0BBw = parcelRequire("e0BBw");

var $b8j4z = parcelRequire("b8j4z");
var $bdb5314df6875341$var$$indexOf = $b8j4z($e0BBw("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $e0BBw(name, !!allowMissing);
    if (typeof intrinsic === "function" && $bdb5314df6875341$var$$indexOf(name, ".prototype.") > -1) return $b8j4z(intrinsic);
    return intrinsic;
};

});
parcelRegister("b8j4z", function(module, exports) {
"use strict";

var $dcAqh = parcelRequire("dcAqh");

var $e0BBw = parcelRequire("e0BBw");
var $81af3c80846f32fe$var$$apply = $e0BBw("%Function.prototype.apply%");
var $81af3c80846f32fe$var$$call = $e0BBw("%Function.prototype.call%");
var $81af3c80846f32fe$var$$reflectApply = $e0BBw("%Reflect.apply%", true) || $dcAqh.call($81af3c80846f32fe$var$$call, $81af3c80846f32fe$var$$apply);
var $81af3c80846f32fe$var$$defineProperty = $e0BBw("%Object.defineProperty%", true);
if ($81af3c80846f32fe$var$$defineProperty) try {
    $81af3c80846f32fe$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $81af3c80846f32fe$var$$defineProperty = null;
}
module.exports = function callBind() {
    return $81af3c80846f32fe$var$$reflectApply($dcAqh, $81af3c80846f32fe$var$$call, arguments);
};
var $81af3c80846f32fe$var$applyBind = function applyBind() {
    return $81af3c80846f32fe$var$$reflectApply($dcAqh, $81af3c80846f32fe$var$$apply, arguments);
};
if ($81af3c80846f32fe$var$$defineProperty) $81af3c80846f32fe$var$$defineProperty(module.exports, "apply", {
    value: $81af3c80846f32fe$var$applyBind
});
else module.exports.apply = $81af3c80846f32fe$var$applyBind;

});


parcelRegister("85iSE", function(module, exports) {
"use strict";
var $5e2d6fa3ea754cec$var$$Map = typeof Map === "function" && Map.prototype ? Map : null;
var $5e2d6fa3ea754cec$var$$Set = typeof Set === "function" && Set.prototype ? Set : null;
var $5e2d6fa3ea754cec$var$exported;
if (!$5e2d6fa3ea754cec$var$$Map) // eslint-disable-next-line no-unused-vars
$5e2d6fa3ea754cec$var$exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
};
var $5e2d6fa3ea754cec$var$$mapHas = $5e2d6fa3ea754cec$var$$Map ? Map.prototype.has : null;
var $5e2d6fa3ea754cec$var$$setHas = $5e2d6fa3ea754cec$var$$Set ? Set.prototype.has : null;
if (!$5e2d6fa3ea754cec$var$exported && !$5e2d6fa3ea754cec$var$$mapHas) // eslint-disable-next-line no-unused-vars
$5e2d6fa3ea754cec$var$exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
};
module.exports = $5e2d6fa3ea754cec$var$exported || function isMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $5e2d6fa3ea754cec$var$$mapHas.call(x);
        if ($5e2d6fa3ea754cec$var$$setHas) try {
            $5e2d6fa3ea754cec$var$$setHas.call(x);
        } catch (e) {
            return true;
        }
        return x instanceof $5e2d6fa3ea754cec$var$$Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

});

parcelRegister("5BCLe", function(module, exports) {
"use strict";
var $414e798f3a8b4d16$var$$Map = typeof Map === "function" && Map.prototype ? Map : null;
var $414e798f3a8b4d16$var$$Set = typeof Set === "function" && Set.prototype ? Set : null;
var $414e798f3a8b4d16$var$exported;
if (!$414e798f3a8b4d16$var$$Set) // eslint-disable-next-line no-unused-vars
$414e798f3a8b4d16$var$exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
};
var $414e798f3a8b4d16$var$$mapHas = $414e798f3a8b4d16$var$$Map ? Map.prototype.has : null;
var $414e798f3a8b4d16$var$$setHas = $414e798f3a8b4d16$var$$Set ? Set.prototype.has : null;
if (!$414e798f3a8b4d16$var$exported && !$414e798f3a8b4d16$var$$setHas) // eslint-disable-next-line no-unused-vars
$414e798f3a8b4d16$var$exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
};
module.exports = $414e798f3a8b4d16$var$exported || function isSet(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $414e798f3a8b4d16$var$$setHas.call(x);
        if ($414e798f3a8b4d16$var$$mapHas) try {
            $414e798f3a8b4d16$var$$mapHas.call(x);
        } catch (e) {
            return true;
        }
        return x instanceof $414e798f3a8b4d16$var$$Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

});

parcelRegister("jdvcJ", function(module, exports) {
var $dfd76fc1ab3e869a$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $dfd76fc1ab3e869a$var$toString.call(arr) == "[object Array]";
};

});

var $3442482cdebda331$exports = {};
"use strict";

$3442482cdebda331$exports = (parcelRequire("3WzGF"));


var $21460db0bcbeacf5$exports = {};

var $iQDV7 = parcelRequire("iQDV7");
"use strict";
/*  ------------------------------------------------------------------------ */ const $21460db0bcbeacf5$var$O = Object, $21460db0bcbeacf5$var$isBrowser = typeof window !== "undefined" && window.window === window && window.navigator, $21460db0bcbeacf5$var$lastOf = (x)=>x[x.length - 1];
var $7af3eabc4a44b167$exports = {};
"use strict";
/*  ------------------------------------------------------------------------ */ const $7af3eabc4a44b167$var$O = Object, $7af3eabc4a44b167$var$isBrowser = typeof window !== "undefined" && window.window === window && window.navigator;
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $e24e008e549c410d$export$4d99f7c30e854ff;
var $e24e008e549c410d$export$194e92554d04abdd;
var $e24e008e549c410d$export$7e987e8f375d24c2;

$e24e008e549c410d$export$4d99f7c30e854ff = (parcelRequire("6r4il")).SourceMapGenerator;

$e24e008e549c410d$export$194e92554d04abdd = (parcelRequire("edOZl")).SourceMapConsumer;

$e24e008e549c410d$export$7e987e8f375d24c2 = (parcelRequire("aPQuV")).SourceNode;


var $7af3eabc4a44b167$require$SourceMapConsumer = $e24e008e549c410d$export$194e92554d04abdd;
var $8f15afb24c6b7513$exports = {};

var $iQDV7 = parcelRequire("iQDV7");
"use strict";
/*  ------------------------------------------------------------------------ */ const $8f15afb24c6b7513$var$isBrowser = typeof window !== "undefined" && window.window === window && window.navigator;
const $8f15afb24c6b7513$var$cwd = $8f15afb24c6b7513$var$isBrowser ? window.location.href : $iQDV7.cwd();
const $8f15afb24c6b7513$var$urlRegexp = new RegExp("^((https|http)://)?[a-z0-9A-Z]{3}.[a-z0-9A-Z][a-z0-9A-Z]{0,61}?[a-z0-9A-Z].com|net|cn|cc (:s[0-9]{1-4})?/$");
/*  ------------------------------------------------------------------------ */ const $8f15afb24c6b7513$var$path = $8f15afb24c6b7513$exports = {
    concat (a, b) {
        const a_endsWithSlash = a[a.length - 1] === "/", b_startsWithSlash = b[0] === "/";
        return a + (a_endsWithSlash || b_startsWithSlash ? "" : "/") + (a_endsWithSlash && b_startsWithSlash ? b.substring(1) : b);
    },
    resolve (x) {
        if ($8f15afb24c6b7513$var$path.isAbsolute(x)) return $8f15afb24c6b7513$var$path.normalize(x);
        return $8f15afb24c6b7513$var$path.normalize($8f15afb24c6b7513$var$path.concat($8f15afb24c6b7513$var$cwd, x));
    },
    normalize (x) {
        let output = [], skip = 0;
        x.split("/").reverse().filter((x)=>x !== ".").forEach((x)=>{
            if (x === "..") skip++;
            else if (skip === 0) output.push(x);
            else skip--;
        });
        const result = output.reverse().join("/");
        return ($8f15afb24c6b7513$var$isBrowser && result[0] === "/" ? window.location.origin : "") + result;
    },
    isData: (x)=>x.indexOf("data:") === 0,
    isURL: (x)=>$8f15afb24c6b7513$var$urlRegexp.test(x),
    isAbsolute: (x)=>x[0] === "/" || /^[^\/]*:/.test(x),
    relativeToFile (a, b) {
        return $8f15afb24c6b7513$var$path.isData(a) || $8f15afb24c6b7513$var$path.isAbsolute(b) ? $8f15afb24c6b7513$var$path.normalize(b) : $8f15afb24c6b7513$var$path.normalize($8f15afb24c6b7513$var$path.concat(a.split("/").slice(0, -1).join("/"), b));
    }
} /*  ------------------------------------------------------------------------ */ ;


const $7af3eabc4a44b167$var$isURL = $8f15afb24c6b7513$exports.isURL;
var $837b7d8ba659aa49$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3f6bf06693ea9a56$export$a143d493d941bafc;
var $3f6bf06693ea9a56$export$e4cf37d7f6fb9e0a;
var $3f6bf06693ea9a56$export$f99ded8fe4b79145;
var $3f6bf06693ea9a56$export$599f31c3813fae4d;
"use strict";
var $d9fdf5bdbb84785c$export$a48f0734ac7c2329;
var $d9fdf5bdbb84785c$export$d622b2ad8d90c771;
var $d9fdf5bdbb84785c$export$6100ba28696e12de;
"use strict";
$d9fdf5bdbb84785c$export$a48f0734ac7c2329 = $d9fdf5bdbb84785c$var$byteLength;
$d9fdf5bdbb84785c$export$d622b2ad8d90c771 = $d9fdf5bdbb84785c$var$toByteArray;
$d9fdf5bdbb84785c$export$6100ba28696e12de = $d9fdf5bdbb84785c$var$fromByteArray;
var $d9fdf5bdbb84785c$var$lookup = [];
var $d9fdf5bdbb84785c$var$revLookup = [];
var $d9fdf5bdbb84785c$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $d9fdf5bdbb84785c$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $d9fdf5bdbb84785c$var$i = 0, $d9fdf5bdbb84785c$var$len = $d9fdf5bdbb84785c$var$code.length; $d9fdf5bdbb84785c$var$i < $d9fdf5bdbb84785c$var$len; ++$d9fdf5bdbb84785c$var$i){
    $d9fdf5bdbb84785c$var$lookup[$d9fdf5bdbb84785c$var$i] = $d9fdf5bdbb84785c$var$code[$d9fdf5bdbb84785c$var$i];
    $d9fdf5bdbb84785c$var$revLookup[$d9fdf5bdbb84785c$var$code.charCodeAt($d9fdf5bdbb84785c$var$i)] = $d9fdf5bdbb84785c$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$d9fdf5bdbb84785c$var$revLookup["-".charCodeAt(0)] = 62;
$d9fdf5bdbb84785c$var$revLookup["_".charCodeAt(0)] = 63;
function $d9fdf5bdbb84785c$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $d9fdf5bdbb84785c$var$byteLength(b64) {
    var lens = $d9fdf5bdbb84785c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d9fdf5bdbb84785c$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d9fdf5bdbb84785c$var$toByteArray(b64) {
    var tmp;
    var lens = $d9fdf5bdbb84785c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $d9fdf5bdbb84785c$var$Arr($d9fdf5bdbb84785c$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i)] << 18 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i)] << 2 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i)] << 10 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $d9fdf5bdbb84785c$var$tripletToBase64(num) {
    return $d9fdf5bdbb84785c$var$lookup[num >> 18 & 0x3F] + $d9fdf5bdbb84785c$var$lookup[num >> 12 & 0x3F] + $d9fdf5bdbb84785c$var$lookup[num >> 6 & 0x3F] + $d9fdf5bdbb84785c$var$lookup[num & 0x3F];
}
function $d9fdf5bdbb84785c$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($d9fdf5bdbb84785c$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $d9fdf5bdbb84785c$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($d9fdf5bdbb84785c$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($d9fdf5bdbb84785c$var$lookup[tmp >> 2] + $d9fdf5bdbb84785c$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($d9fdf5bdbb84785c$var$lookup[tmp >> 10] + $d9fdf5bdbb84785c$var$lookup[tmp >> 4 & 0x3F] + $d9fdf5bdbb84785c$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $b822c8ad7030d15d$export$aafa59e2e03f2942;
var $b822c8ad7030d15d$export$68d8715fc104d294;
$b822c8ad7030d15d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$b822c8ad7030d15d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $3f6bf06693ea9a56$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$3f6bf06693ea9a56$export$a143d493d941bafc = $3f6bf06693ea9a56$var$Buffer;
$3f6bf06693ea9a56$export$e4cf37d7f6fb9e0a = $3f6bf06693ea9a56$var$SlowBuffer;
$3f6bf06693ea9a56$export$f99ded8fe4b79145 = 50;
const $3f6bf06693ea9a56$var$K_MAX_LENGTH = 0x7fffffff;
$3f6bf06693ea9a56$export$599f31c3813fae4d = $3f6bf06693ea9a56$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3f6bf06693ea9a56$var$Buffer.TYPED_ARRAY_SUPPORT = $3f6bf06693ea9a56$var$typedArraySupport();
if (!$3f6bf06693ea9a56$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3f6bf06693ea9a56$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3f6bf06693ea9a56$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3f6bf06693ea9a56$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3f6bf06693ea9a56$var$createBuffer(length) {
    if (length > $3f6bf06693ea9a56$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3f6bf06693ea9a56$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3f6bf06693ea9a56$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3f6bf06693ea9a56$var$allocUnsafe(arg);
    }
    return $3f6bf06693ea9a56$var$from(arg, encodingOrOffset, length);
}
$3f6bf06693ea9a56$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3f6bf06693ea9a56$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $3f6bf06693ea9a56$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3f6bf06693ea9a56$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3f6bf06693ea9a56$var$isInstance(value, ArrayBuffer) || value && $3f6bf06693ea9a56$var$isInstance(value.buffer, ArrayBuffer)) return $3f6bf06693ea9a56$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($3f6bf06693ea9a56$var$isInstance(value, SharedArrayBuffer) || value && $3f6bf06693ea9a56$var$isInstance(value.buffer, SharedArrayBuffer))) return $3f6bf06693ea9a56$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3f6bf06693ea9a56$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3f6bf06693ea9a56$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $3f6bf06693ea9a56$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3f6bf06693ea9a56$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3f6bf06693ea9a56$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3f6bf06693ea9a56$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3f6bf06693ea9a56$var$Buffer, Uint8Array);
function $3f6bf06693ea9a56$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3f6bf06693ea9a56$var$alloc(size, fill, encoding) {
    $3f6bf06693ea9a56$var$assertSize(size);
    if (size <= 0) return $3f6bf06693ea9a56$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $3f6bf06693ea9a56$var$createBuffer(size).fill(fill, encoding) : $3f6bf06693ea9a56$var$createBuffer(size).fill(fill);
    return $3f6bf06693ea9a56$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3f6bf06693ea9a56$var$Buffer.alloc = function(size, fill, encoding) {
    return $3f6bf06693ea9a56$var$alloc(size, fill, encoding);
};
function $3f6bf06693ea9a56$var$allocUnsafe(size) {
    $3f6bf06693ea9a56$var$assertSize(size);
    return $3f6bf06693ea9a56$var$createBuffer(size < 0 ? 0 : $3f6bf06693ea9a56$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3f6bf06693ea9a56$var$Buffer.allocUnsafe = function(size) {
    return $3f6bf06693ea9a56$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3f6bf06693ea9a56$var$Buffer.allocUnsafeSlow = function(size) {
    return $3f6bf06693ea9a56$var$allocUnsafe(size);
};
function $3f6bf06693ea9a56$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$3f6bf06693ea9a56$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $3f6bf06693ea9a56$var$byteLength(string, encoding) | 0;
    let buf = $3f6bf06693ea9a56$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3f6bf06693ea9a56$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3f6bf06693ea9a56$var$checked(array.length) | 0;
    const buf = $3f6bf06693ea9a56$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3f6bf06693ea9a56$var$fromArrayView(arrayView) {
    if ($3f6bf06693ea9a56$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3f6bf06693ea9a56$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3f6bf06693ea9a56$var$fromArrayLike(arrayView);
}
function $3f6bf06693ea9a56$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3f6bf06693ea9a56$var$Buffer.prototype);
    return buf;
}
function $3f6bf06693ea9a56$var$fromObject(obj) {
    if ($3f6bf06693ea9a56$var$Buffer.isBuffer(obj)) {
        const len = $3f6bf06693ea9a56$var$checked(obj.length) | 0;
        const buf = $3f6bf06693ea9a56$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $3f6bf06693ea9a56$var$numberIsNaN(obj.length)) return $3f6bf06693ea9a56$var$createBuffer(0);
        return $3f6bf06693ea9a56$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $3f6bf06693ea9a56$var$fromArrayLike(obj.data);
}
function $3f6bf06693ea9a56$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3f6bf06693ea9a56$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3f6bf06693ea9a56$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $3f6bf06693ea9a56$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3f6bf06693ea9a56$var$Buffer.alloc(+length);
}
$3f6bf06693ea9a56$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3f6bf06693ea9a56$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3f6bf06693ea9a56$var$Buffer.compare = function compare(a, b) {
    if ($3f6bf06693ea9a56$var$isInstance(a, Uint8Array)) a = $3f6bf06693ea9a56$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3f6bf06693ea9a56$var$isInstance(b, Uint8Array)) b = $3f6bf06693ea9a56$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(a) || !$3f6bf06693ea9a56$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3f6bf06693ea9a56$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$3f6bf06693ea9a56$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3f6bf06693ea9a56$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3f6bf06693ea9a56$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3f6bf06693ea9a56$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(buf)) buf = $3f6bf06693ea9a56$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3f6bf06693ea9a56$var$byteLength(string, encoding) {
    if ($3f6bf06693ea9a56$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3f6bf06693ea9a56$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $3f6bf06693ea9a56$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $3f6bf06693ea9a56$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3f6bf06693ea9a56$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3f6bf06693ea9a56$var$Buffer.byteLength = $3f6bf06693ea9a56$var$byteLength;
function $3f6bf06693ea9a56$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $3f6bf06693ea9a56$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $3f6bf06693ea9a56$var$utf8Slice(this, start, end);
        case "ascii":
            return $3f6bf06693ea9a56$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $3f6bf06693ea9a56$var$latin1Slice(this, start, end);
        case "base64":
            return $3f6bf06693ea9a56$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $3f6bf06693ea9a56$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3f6bf06693ea9a56$var$Buffer.prototype._isBuffer = true;
function $3f6bf06693ea9a56$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3f6bf06693ea9a56$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$3f6bf06693ea9a56$var$swap(this, i, i + 1);
    return this;
};
$3f6bf06693ea9a56$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $3f6bf06693ea9a56$var$swap(this, i, i + 3);
        $3f6bf06693ea9a56$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3f6bf06693ea9a56$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $3f6bf06693ea9a56$var$swap(this, i, i + 7);
        $3f6bf06693ea9a56$var$swap(this, i + 1, i + 6);
        $3f6bf06693ea9a56$var$swap(this, i + 2, i + 5);
        $3f6bf06693ea9a56$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3f6bf06693ea9a56$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $3f6bf06693ea9a56$var$utf8Slice(this, 0, length);
    return $3f6bf06693ea9a56$var$slowToString.apply(this, arguments);
};
$3f6bf06693ea9a56$var$Buffer.prototype.toLocaleString = $3f6bf06693ea9a56$var$Buffer.prototype.toString;
$3f6bf06693ea9a56$var$Buffer.prototype.equals = function equals(b) {
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $3f6bf06693ea9a56$var$Buffer.compare(this, b) === 0;
};
$3f6bf06693ea9a56$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $3f6bf06693ea9a56$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($3f6bf06693ea9a56$var$customInspectSymbol) $3f6bf06693ea9a56$var$Buffer.prototype[$3f6bf06693ea9a56$var$customInspectSymbol] = $3f6bf06693ea9a56$var$Buffer.prototype.inspect;
$3f6bf06693ea9a56$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3f6bf06693ea9a56$var$isInstance(target, Uint8Array)) target = $3f6bf06693ea9a56$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3f6bf06693ea9a56$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3f6bf06693ea9a56$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $3f6bf06693ea9a56$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3f6bf06693ea9a56$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3f6bf06693ea9a56$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3f6bf06693ea9a56$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $3f6bf06693ea9a56$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3f6bf06693ea9a56$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3f6bf06693ea9a56$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3f6bf06693ea9a56$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3f6bf06693ea9a56$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3f6bf06693ea9a56$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3f6bf06693ea9a56$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3f6bf06693ea9a56$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3f6bf06693ea9a56$var$utf8Write(buf, string, offset, length) {
    return $3f6bf06693ea9a56$var$blitBuffer($3f6bf06693ea9a56$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3f6bf06693ea9a56$var$asciiWrite(buf, string, offset, length) {
    return $3f6bf06693ea9a56$var$blitBuffer($3f6bf06693ea9a56$var$asciiToBytes(string), buf, offset, length);
}
function $3f6bf06693ea9a56$var$base64Write(buf, string, offset, length) {
    return $3f6bf06693ea9a56$var$blitBuffer($3f6bf06693ea9a56$var$base64ToBytes(string), buf, offset, length);
}
function $3f6bf06693ea9a56$var$ucs2Write(buf, string, offset, length) {
    return $3f6bf06693ea9a56$var$blitBuffer($3f6bf06693ea9a56$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3f6bf06693ea9a56$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $3f6bf06693ea9a56$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $3f6bf06693ea9a56$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $3f6bf06693ea9a56$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $3f6bf06693ea9a56$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $3f6bf06693ea9a56$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3f6bf06693ea9a56$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3f6bf06693ea9a56$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $d9fdf5bdbb84785c$export$6100ba28696e12de(buf);
    else return $d9fdf5bdbb84785c$export$6100ba28696e12de(buf.slice(start, end));
}
function $3f6bf06693ea9a56$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3f6bf06693ea9a56$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3f6bf06693ea9a56$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3f6bf06693ea9a56$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3f6bf06693ea9a56$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3f6bf06693ea9a56$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3f6bf06693ea9a56$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3f6bf06693ea9a56$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3f6bf06693ea9a56$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $3f6bf06693ea9a56$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3f6bf06693ea9a56$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3f6bf06693ea9a56$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3f6bf06693ea9a56$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3f6bf06693ea9a56$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$3f6bf06693ea9a56$var$Buffer.prototype.readUintLE = $3f6bf06693ea9a56$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUintBE = $3f6bf06693ea9a56$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint8 = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint16LE = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint16BE = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint32LE = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint32BE = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3f6bf06693ea9a56$var$Buffer.prototype.readBigUInt64LE = $3f6bf06693ea9a56$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3f6bf06693ea9a56$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f6bf06693ea9a56$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3f6bf06693ea9a56$var$Buffer.prototype.readBigUInt64BE = $3f6bf06693ea9a56$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3f6bf06693ea9a56$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f6bf06693ea9a56$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3f6bf06693ea9a56$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3f6bf06693ea9a56$var$Buffer.prototype.readBigInt64LE = $3f6bf06693ea9a56$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3f6bf06693ea9a56$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f6bf06693ea9a56$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3f6bf06693ea9a56$var$Buffer.prototype.readBigInt64BE = $3f6bf06693ea9a56$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3f6bf06693ea9a56$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f6bf06693ea9a56$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3f6bf06693ea9a56$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return $b822c8ad7030d15d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$3f6bf06693ea9a56$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return $b822c8ad7030d15d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$3f6bf06693ea9a56$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 8, this.length);
    return $b822c8ad7030d15d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$3f6bf06693ea9a56$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 8, this.length);
    return $b822c8ad7030d15d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $3f6bf06693ea9a56$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$3f6bf06693ea9a56$var$Buffer.prototype.writeUintLE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3f6bf06693ea9a56$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUintBE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3f6bf06693ea9a56$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint8 = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint16LE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint16BE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint32LE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint32BE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3f6bf06693ea9a56$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3f6bf06693ea9a56$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3f6bf06693ea9a56$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3f6bf06693ea9a56$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3f6bf06693ea9a56$var$Buffer.prototype.writeBigUInt64LE = $3f6bf06693ea9a56$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3f6bf06693ea9a56$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$3f6bf06693ea9a56$var$Buffer.prototype.writeBigUInt64BE = $3f6bf06693ea9a56$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3f6bf06693ea9a56$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$3f6bf06693ea9a56$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3f6bf06693ea9a56$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3f6bf06693ea9a56$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeBigInt64LE = $3f6bf06693ea9a56$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3f6bf06693ea9a56$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$3f6bf06693ea9a56$var$Buffer.prototype.writeBigInt64BE = $3f6bf06693ea9a56$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3f6bf06693ea9a56$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $3f6bf06693ea9a56$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $3f6bf06693ea9a56$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $b822c8ad7030d15d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3f6bf06693ea9a56$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3f6bf06693ea9a56$var$writeFloat(this, value, offset, true, noAssert);
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3f6bf06693ea9a56$var$writeFloat(this, value, offset, false, noAssert);
};
function $3f6bf06693ea9a56$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $b822c8ad7030d15d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3f6bf06693ea9a56$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3f6bf06693ea9a56$var$writeDouble(this, value, offset, true, noAssert);
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3f6bf06693ea9a56$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3f6bf06693ea9a56$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3f6bf06693ea9a56$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$3f6bf06693ea9a56$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3f6bf06693ea9a56$var$Buffer.isBuffer(val) ? val : $3f6bf06693ea9a56$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3f6bf06693ea9a56$var$errors = {};
function $3f6bf06693ea9a56$var$E(sym, getMessage, Base) {
    $3f6bf06693ea9a56$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$3f6bf06693ea9a56$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$3f6bf06693ea9a56$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3f6bf06693ea9a56$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3f6bf06693ea9a56$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3f6bf06693ea9a56$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3f6bf06693ea9a56$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3f6bf06693ea9a56$var$checkBounds(buf, offset, byteLength) {
    $3f6bf06693ea9a56$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3f6bf06693ea9a56$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3f6bf06693ea9a56$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3f6bf06693ea9a56$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $3f6bf06693ea9a56$var$checkBounds(buf, offset, byteLength);
}
function $3f6bf06693ea9a56$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $3f6bf06693ea9a56$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $3f6bf06693ea9a56$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3f6bf06693ea9a56$var$validateNumber(value, type);
        throw new $3f6bf06693ea9a56$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $3f6bf06693ea9a56$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3f6bf06693ea9a56$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3f6bf06693ea9a56$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3f6bf06693ea9a56$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3f6bf06693ea9a56$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $3f6bf06693ea9a56$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $3f6bf06693ea9a56$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3f6bf06693ea9a56$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3f6bf06693ea9a56$var$base64ToBytes(str) {
    return $d9fdf5bdbb84785c$export$d622b2ad8d90c771($3f6bf06693ea9a56$var$base64clean(str));
}
function $3f6bf06693ea9a56$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3f6bf06693ea9a56$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3f6bf06693ea9a56$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3f6bf06693ea9a56$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3f6bf06693ea9a56$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $3f6bf06693ea9a56$var$BufferBigIntNotDefined : fn;
}
function $3f6bf06693ea9a56$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $837b7d8ba659aa49$require$Buffer = $3f6bf06693ea9a56$export$a143d493d941bafc;
"use strict";
/**
 * Module exports.
 */ $837b7d8ba659aa49$exports = $837b7d8ba659aa49$var$dataUriToBuffer;
/**
 * Returns a `Buffer` instance from the given data URI `uri`.
 *
 * @param {String} uri Data URI to turn into a Buffer instance
 * @return {Buffer} Buffer instance from Data URI
 * @api public
 */ function $837b7d8ba659aa49$var$dataUriToBuffer(uri) {
    if (!/^data\:/i.test(uri)) throw new TypeError('`uri` does not appear to be a Data URI (must begin with "data:")');
    // strip newlines
    uri = uri.replace(/\r?\n/g, "");
    // split the URI up into the "metadata" and the "data" portions
    var firstComma = uri.indexOf(",");
    if (-1 === firstComma || firstComma <= 4) throw new TypeError("malformed data: URI");
    // remove the "data:" scheme and parse the metadata
    var meta = uri.substring(5, firstComma).split(";");
    var type = meta[0] || "text/plain";
    var typeFull = type;
    var base64 = false;
    var charset = "";
    for(var i = 1; i < meta.length; i++)if ("base64" == meta[i]) base64 = true;
    else {
        typeFull += ";" + meta[i];
        if (0 == meta[i].indexOf("charset=")) charset = meta[i].substring(8);
    }
    // defaults to US-ASCII only if type is not provided
    if (!meta[0] && !charset.length) {
        typeFull += ";charset=US-ASCII";
        charset = "US-ASCII";
    }
    // get the encoded data portion and decode URI-encoded chars
    var data = unescape(uri.substring(firstComma + 1));
    var encoding = base64 ? "base64" : "ascii";
    var buffer = $837b7d8ba659aa49$require$Buffer.from ? $837b7d8ba659aa49$require$Buffer.from(data, encoding) : new $837b7d8ba659aa49$require$Buffer(data, encoding);
    // set `.type` and `.typeFull` properties to MIME type
    buffer.type = type;
    buffer.typeFull = typeFull;
    // set the `.charset` property
    buffer.charset = charset;
    return buffer;
}


/*  ------------------------------------------------------------------------ */ const $7af3eabc4a44b167$var$memoize = (f)=>{
    const m = (x)=>x in m.cache ? m.cache[x] : m.cache[x] = f(x);
    m.forgetEverything = ()=>{
        m.cache = Object.create(null);
    };
    m.cache = Object.create(null);
    return m;
};
/*  ------------------------------------------------------------------------ */ const $7af3eabc4a44b167$var$newSourceFileMemoized = $7af3eabc4a44b167$var$memoize((file)=>new $7af3eabc4a44b167$var$SourceFile(file));
const $7af3eabc4a44b167$var$getSource = $7af3eabc4a44b167$exports = (file)=>{
    return $7af3eabc4a44b167$var$newSourceFileMemoized($8f15afb24c6b7513$exports.resolve(file));
};
$7af3eabc4a44b167$var$getSource.resetCache = ()=>$7af3eabc4a44b167$var$newSourceFileMemoized.forgetEverything();
$7af3eabc4a44b167$var$getSource.getCache = ()=>$7af3eabc4a44b167$var$newSourceFileMemoized.cache;
/*  ------------------------------------------------------------------------ */ class $7af3eabc4a44b167$var$SourceMap {
    sourceFor(file) {
        const content = this.parsed.sourceContentFor(file, true);
        const fullPath = $8f15afb24c6b7513$exports.relativeToFile(this.file.path, file);
        return content ? new $7af3eabc4a44b167$var$SourceFile(fullPath, content) : $7af3eabc4a44b167$var$getSource(fullPath);
    }
    resolve(loc) {
        const originalLoc = this.parsed.originalPositionFor(loc);
        return originalLoc.source ? this.sourceFor(originalLoc.source).resolve($7af3eabc4a44b167$var$O.assign({}, loc, {
            line: originalLoc.line,
            column: originalLoc.column + 1,
            name: originalLoc.name
        })) : loc;
    }
    constructor(originalFilePath, sourceMapPath){
        this.file = sourceMapPath.startsWith("data:") ? new $7af3eabc4a44b167$var$SourceFile(originalFilePath, $837b7d8ba659aa49$exports(sourceMapPath).toString()) : $7af3eabc4a44b167$var$getSource($8f15afb24c6b7513$exports.relativeToFile(originalFilePath, sourceMapPath));
        this.parsed = this.file.text && $7af3eabc4a44b167$require$SourceMapConsumer(JSON.parse(this.file.text)) || null;
        this.sourceFor = $7af3eabc4a44b167$var$memoize(this.sourceFor.bind(this));
    }
}

/*  ------------------------------------------------------------------------ */ class $7af3eabc4a44b167$var$SourceFile {
    get lines() {
        return this.lines_ = this.lines_ || this.text.split("\n");
    }
    get sourceMap() {
        try {
            if (this.sourceMap_ === undefined) {
                /*  Extract the last sourceMap occurence (TODO: support multiple sourcemaps)   */ const re = /\u0023 sourceMappingURL=(.+)\n?/g;
                let lastMatch = undefined;
                while(true){
                    const match = re.exec(this.text);
                    if (match) lastMatch = match;
                    else break;
                }
                const url = lastMatch && lastMatch[1];
                if (url) {
                    const sourceMap = new $7af3eabc4a44b167$var$SourceMap(this.path, url);
                    if (sourceMap.parsed) this.sourceMap_ = sourceMap;
                } else this.sourceMap_ = null;
            }
        } catch (e) {
            this.sourceMap_ = null;
            this.sourceMapError = e;
        }
        return this.sourceMap_;
    }
    resolve(loc /* { line[, column] } */ ) /* → { line, column, sourceFile, sourceLine } */ {
        if (this.sourceMap) {
            const newLoc = this.sourceMap.resolve(loc);
            if (newLoc.sourceFile) return newLoc;
        }
        return $7af3eabc4a44b167$var$O.assign({}, loc, {
            sourceFile: this,
            sourceLine: this.lines[loc.line - 1] || "",
            error: this.error
        });
    }
    constructor(path, text /* optional */ ){
        this.path = path;
        if (text) this.text = text;
        else try {
            if ($7af3eabc4a44b167$var$isBrowser) {
                let xhr = new XMLHttpRequest();
                xhr.open("GET", path, false);
                xhr.send(null);
                this.text = xhr.responseText;
            } else this.text = (parcelRequire("7K7Bf")).readFileSync(path, {
                encoding: "utf8"
            });
        } catch (e) {
            this.error = e;
            this.text = "";
        }
    }
} /*  ------------------------------------------------------------------------ */ 


var $25f77f6a9c6e17c6$exports = {};
"use strict";
$25f77f6a9c6e17c6$exports = (arr_, pred)=>{
    const arr = arr_ || [], spans = [];
    let span = {
        label: undefined,
        items: [
            arr.first
        ]
    };
    arr.forEach((x)=>{
        const label = pred(x);
        if (span.label !== label && span.items.length) spans.push(span = {
            label: label,
            items: [
                x
            ]
        });
        else span.items.push(x);
    });
    return spans;
};


var $673f6fd3f7455265$exports = {};
"use strict";
function $673f6fd3f7455265$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
const $673f6fd3f7455265$var$O = Object;
var $fc1186fde7854824$exports = {};
"use strict";
var $fc1186fde7854824$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
const $fc1186fde7854824$var$ansiEscapeCode = "[\x1b\x9b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]", $fc1186fde7854824$var$zeroWidthCharacterExceptNewline = "\x00-\b\v-\x19\x1b\x9b\xad\u200B\u2028\u2029\uFEFF\uFE00-\uFE0F", $fc1186fde7854824$var$zeroWidthCharacter = "\n" + $fc1186fde7854824$var$zeroWidthCharacterExceptNewline, $fc1186fde7854824$var$zeroWidthCharactersExceptNewline = new RegExp("(?:" + $fc1186fde7854824$var$ansiEscapeCode + ")|[" + $fc1186fde7854824$var$zeroWidthCharacterExceptNewline + "]", "g"), $fc1186fde7854824$var$zeroWidthCharacters = new RegExp("(?:" + $fc1186fde7854824$var$ansiEscapeCode + ")|[" + $fc1186fde7854824$var$zeroWidthCharacter + "]", "g"), $fc1186fde7854824$var$partition = new RegExp("((?:" + $fc1186fde7854824$var$ansiEscapeCode + ")|[	" + $fc1186fde7854824$var$zeroWidthCharacter + "])?([^	" + $fc1186fde7854824$var$zeroWidthCharacter + "]*)", "g");
$fc1186fde7854824$exports = {
    zeroWidthCharacters: $fc1186fde7854824$var$zeroWidthCharacters,
    ansiEscapeCodes: new RegExp($fc1186fde7854824$var$ansiEscapeCode, "g"),
    strlen: (s)=>Array.from(s.replace($fc1186fde7854824$var$zeroWidthCharacters, "")).length,
    isBlank: (s)=>s.replace($fc1186fde7854824$var$zeroWidthCharacters, "").replace(/\s/g, "").length === 0,
    blank: (s)=>Array.from(s.replace($fc1186fde7854824$var$zeroWidthCharactersExceptNewline, "")) // Array.from solves the emoji problem as described here: http://blog.jonnew.com/posts/poo-dot-length-equals-two
        .map((x)=>x === "	" || x === "\n" ? x : " ").join(""),
    partition (s) {
        for(var m, spans = []; $fc1186fde7854824$var$partition.lastIndex !== s.length && (m = $fc1186fde7854824$var$partition.exec(s));)spans.push([
            m[1] || "",
            m[2]
        ]);
        $fc1186fde7854824$var$partition.lastIndex = 0; // reset
        return spans;
    },
    first (s, n) {
        let result = "", length = 0;
        for (const _ref of $fc1186fde7854824$exports.partition(s)){
            var _ref2 = $fc1186fde7854824$var$_slicedToArray(_ref, 2);
            const nonPrintable = _ref2[0];
            const printable = _ref2[1];
            const text = Array.from(printable).slice(0, n - length); // Array.from solves the emoji problem as described here: http://blog.jonnew.com/posts/poo-dot-length-equals-two
            result += nonPrintable + text.join("");
            length += text.length;
        }
        return result;
    }
};


const $673f6fd3f7455265$var$first = $fc1186fde7854824$exports.first, $673f6fd3f7455265$var$strlen = $fc1186fde7854824$exports.strlen, $673f6fd3f7455265$var$limit = (s, n)=>$673f6fd3f7455265$var$first(s, n - 1) + "\u2026";
const $673f6fd3f7455265$var$asColumns = (rows, cfg_)=>{
    const zip = (arrs, f)=>arrs.reduce((a, b)=>b.map((b, i)=>[].concat($673f6fd3f7455265$var$_toConsumableArray(a[i] || []), [
                    b
                ])), []).map((args)=>f.apply(undefined, $673f6fd3f7455265$var$_toConsumableArray(args))), /*  Convert cell data to string (converting multiline text to singleline) */ cells = rows.map((r)=>r.map((c)=>c.replace(/\n/g, "\\n"))), /*  Compute column widths (per row) and max widths (per column)     */ cellWidths = cells.map((r)=>r.map($673f6fd3f7455265$var$strlen)), maxWidths = zip(cellWidths, Math.max), /*  Default config     */ cfg = $673f6fd3f7455265$var$O.assign({
        delimiter: "  ",
        minColumnWidths: maxWidths.map((x)=>0),
        maxTotalWidth: 0
    }, cfg_), delimiterLength = $673f6fd3f7455265$var$strlen(cfg.delimiter), /*  Project desired column widths, taking maxTotalWidth and minColumnWidths in account.     */ totalWidth = maxWidths.reduce((a, b)=>a + b, 0), relativeWidths = maxWidths.map((w)=>w / totalWidth), maxTotalWidth = cfg.maxTotalWidth - delimiterLength * (maxWidths.length - 1), excessWidth = Math.max(0, totalWidth - maxTotalWidth), computedWidths = zip([
        cfg.minColumnWidths,
        maxWidths,
        relativeWidths
    ], (min, max, relative)=>Math.max(min, Math.floor(max - excessWidth * relative))), /*  This is how many symbols we should pad or cut (per column).  */ restCellWidths = cellWidths.map((widths)=>zip([
            computedWidths,
            widths
        ], (a, b)=>a - b));
    /*  Perform final composition.   */ return zip([
        cells,
        restCellWidths
    ], (a, b)=>zip([
            a,
            b
        ], (str, w)=>w >= 0 ? cfg.right ? " ".repeat(w) + str : str + " ".repeat(w) : $673f6fd3f7455265$var$limit(str, $673f6fd3f7455265$var$strlen(str) + w)).join(cfg.delimiter));
};
const $673f6fd3f7455265$var$asTable = (cfg)=>$673f6fd3f7455265$var$O.assign((arr)=>{
        var _ref;
        /*  Print arrays  */ if (arr[0] && Array.isArray(arr[0])) return $673f6fd3f7455265$var$asColumns(arr.map((r)=>r.map((c, i)=>c === undefined ? "" : cfg.print(c, i))), cfg).join("\n");
        /*  Print objects   */ const colNames = [].concat($673f6fd3f7455265$var$_toConsumableArray(new Set((_ref = []).concat.apply(_ref, $673f6fd3f7455265$var$_toConsumableArray(arr.map($673f6fd3f7455265$var$O.keys)))))), columns = [
            colNames.map(cfg.title)
        ].concat($673f6fd3f7455265$var$_toConsumableArray(arr.map((o)=>colNames.map((key)=>o[key] === undefined ? "" : cfg.print(o[key], key))))), lines = $673f6fd3f7455265$var$asColumns(columns, cfg);
        return (cfg.dash ? [
            lines[0],
            cfg.dash.repeat($673f6fd3f7455265$var$strlen(lines[0]))
        ].concat($673f6fd3f7455265$var$_toConsumableArray(lines.slice(1))) : lines).join("\n");
    }, cfg, {
        configure: (newConfig)=>$673f6fd3f7455265$var$asTable($673f6fd3f7455265$var$O.assign({}, cfg, newConfig))
    });
$673f6fd3f7455265$exports = $673f6fd3f7455265$var$asTable({
    maxTotalWidth: Number.MAX_SAFE_INTEGER,
    print: String,
    title: String,
    dash: "-",
    right: false
});


const $21460db0bcbeacf5$var$nixSlashes = (x)=>x.replace(/\\/g, "/"), $21460db0bcbeacf5$var$pathRoot = $21460db0bcbeacf5$var$isBrowser ? window.location.href : $21460db0bcbeacf5$var$nixSlashes($iQDV7.cwd()) + "/";

const $21460db0bcbeacf5$var$pathToRelative = $21460db0bcbeacf5$var$isBrowser ? (root, full)=>full.replace(root, "") : (parcelRequire("4Pw02")).relative;

/*  ------------------------------------------------------------------------ */ class $21460db0bcbeacf5$var$StackTracey extends Array {
    static extractEntryMetadata(e) {
        const fileRelative = $21460db0bcbeacf5$var$StackTracey.relativePath(e.file || "");
        return $21460db0bcbeacf5$var$O.assign(e, {
            calleeShort: e.calleeShort || $21460db0bcbeacf5$var$lastOf((e.callee || "").split(".")),
            fileRelative: fileRelative,
            fileShort: $21460db0bcbeacf5$var$StackTracey.shortenPath(fileRelative),
            fileName: $21460db0bcbeacf5$var$lastOf((e.file || "").split("/")),
            thirdParty: $21460db0bcbeacf5$var$StackTracey.isThirdParty(fileRelative) && !e.index
        });
    }
    static shortenPath(relativePath) {
        return relativePath.replace(/^node_modules\//, "").replace(/^webpack\/bootstrap\//, "");
    }
    static relativePath(fullPath) {
        return $21460db0bcbeacf5$var$nixSlashes($21460db0bcbeacf5$var$pathToRelative($21460db0bcbeacf5$var$pathRoot, fullPath)).replace(/^.*\:\/\/?\/?/, "");
    }
    static isThirdParty(relativePath) {
        return relativePath[0] === "~" || // webpack-specific heuristic
        relativePath[0] === "/" || // external source
        relativePath.indexOf("node_modules") === 0 || relativePath.indexOf("webpack/bootstrap") === 0;
    }
    static rawParse(str) {
        const lines = (str || "").split("\n");
        const entries = lines.map((line)=>{
            line = line.trim();
            let callee, fileLineColumn = [], native, planA, planB;
            if ((planA = line.match(/at (.+) \((.+)\)/)) || line.slice(0, 3) !== "at " && (planA = line.match(/(.*)@(.*)/))) {
                callee = planA[1];
                native = planA[2] === "native";
                fileLineColumn = (planA[2].match(/(.*):(.+):(.+)/) || []).slice(1);
            } else if (planB = line.match(/^(at\s+)*(.+):([0-9]+):([0-9]+)/)) fileLineColumn = planB.slice(2);
            else return undefined;
            /*  Detect things like Array.reduce
            TODO: detect more built-in types            */ if (callee && !fileLineColumn[0]) {
                const type = callee.split(".")[0];
                if (type === "Array") native = true;
            }
            return {
                beforeParse: line,
                callee: callee || "",
                index: $21460db0bcbeacf5$var$isBrowser && fileLineColumn[0] === window.location.href,
                native: native || false,
                file: $21460db0bcbeacf5$var$nixSlashes(fileLineColumn[0] || ""),
                line: parseInt(fileLineColumn[1] || "", 10) || undefined,
                column: parseInt(fileLineColumn[2] || "", 10) || undefined
            };
        });
        return entries.filter((x)=>x !== undefined);
    }
    withSource(i) {
        return this[i] && $21460db0bcbeacf5$var$StackTracey.withSource(this[i]);
    }
    static withSource(loc) {
        if (loc.sourceFile || loc.file && loc.file.indexOf("<") >= 0) return loc;
        else {
            let resolved = $7af3eabc4a44b167$exports(loc.file || "").resolve(loc);
            if (!resolved.sourceFile) return loc;
            if (!resolved.sourceFile.error) {
                resolved.file = $21460db0bcbeacf5$var$nixSlashes(resolved.sourceFile.path);
                resolved = $21460db0bcbeacf5$var$StackTracey.extractEntryMetadata(resolved);
            }
            if (!resolved.sourceLine.error) {
                if (resolved.sourceLine.includes("// @hide")) {
                    resolved.sourceLine = resolved.sourceLine.replace("// @hide", "");
                    resolved.hide = true;
                }
                if (resolved.sourceLine.includes("__webpack_require__") || // webpack-specific heuristics
                resolved.sourceLine.includes("/******/ ({")) resolved.thirdParty = true;
            }
            return $21460db0bcbeacf5$var$O.assign({
                sourceLine: ""
            }, loc, resolved);
        }
    }
    get withSources() {
        return new $21460db0bcbeacf5$var$StackTracey(this.map($21460db0bcbeacf5$var$StackTracey.withSource));
    }
    get mergeRepeatedLines() {
        return new $21460db0bcbeacf5$var$StackTracey($25f77f6a9c6e17c6$exports(this, (e)=>e.file + e.line).map((group)=>{
            return group.items.slice(1).reduce((memo, entry)=>{
                memo.callee = (memo.callee || "<anonymous>") + " \u2192 " + (entry.callee || "<anonymous>");
                memo.calleeShort = (memo.calleeShort || "<anonymous>") + " \u2192 " + (entry.calleeShort || "<anonymous>");
                return memo;
            }, $21460db0bcbeacf5$var$O.assign({}, group.items[0]));
        }));
    }
    get clean() {
        return this.withSources.mergeRepeatedLines.filter((e, i)=>i === 0 || !(e.thirdParty || e.hide || e.native));
    }
    at(i) {
        return $21460db0bcbeacf5$var$O.assign({
            beforeParse: "",
            callee: "<???>",
            index: false,
            native: false,
            file: "<???>",
            line: 0,
            column: 0
        }, this[i]);
    }
    static locationsEqual(a, b) {
        return a.file === b.file && a.line === b.line && a.column === b.column;
    }
    get pretty() {
        const trimEnd = (s, n)=>s && (s.length > n ? s.slice(0, n - 1) + "\u2026" : s);
        const trimStart = (s, n)=>s && (s.length > n ? "\u2026" + s.slice(-(n - 1)) : s);
        return $673f6fd3f7455265$exports(this.withSources.map((e)=>[
                "at " + trimEnd(e.calleeShort, $21460db0bcbeacf5$var$StackTracey.maxColumnWidths.callee),
                trimStart(e.fileShort && e.fileShort + ":" + e.line || "", $21460db0bcbeacf5$var$StackTracey.maxColumnWidths.file),
                trimEnd((e.sourceLine || "").trim() || "", $21460db0bcbeacf5$var$StackTracey.maxColumnWidths.sourceLine)
            ]));
    }
    static resetCache() {
        $7af3eabc4a44b167$exports.resetCache();
    }
    constructor(input, offset){
        const originalInput = input, isParseableSyntaxError = input && input instanceof SyntaxError && !$21460db0bcbeacf5$var$isBrowser;
        super();
        /*  Fixes for Safari    */ this.constructor = $21460db0bcbeacf5$var$StackTracey;
        this.__proto__ = $21460db0bcbeacf5$var$StackTracey.prototype;
        /*  new StackTracey ()            */ if (!input) {
            input = new Error();
            offset = offset === undefined ? 1 : offset;
        }
        /*  new StackTracey (Error)      */ if (input instanceof Error) input = input[$21460db0bcbeacf5$var$StackTracey.stack] || input.stack || "";
        /*  new StackTracey (string)     */ if (typeof input === "string") input = $21460db0bcbeacf5$var$StackTracey.rawParse(input).slice(offset).map($21460db0bcbeacf5$var$StackTracey.extractEntryMetadata);
        /*  new StackTracey (array)      */ if (Array.isArray(input)) {
            if (isParseableSyntaxError) {
                const rawLines = (parcelRequire("ezvW0")).inspect(originalInput).split("\n"), fileLine = rawLines[0].split(":"), line = fileLine.pop(), file = fileLine.join(":");
                if (file) input.unshift({
                    file: $21460db0bcbeacf5$var$nixSlashes(file),
                    line: line,
                    column: (rawLines[2] || "").indexOf("^") + 1,
                    sourceLine: rawLines[1],
                    callee: "(syntax error)",
                    syntaxError: true
                });
            }
            this.length = input.length;
            input.forEach((x, i)=>this[i] = x);
        }
    }
}
/*  Some default configuration options
    ------------------------------------------------------------------------ */ $21460db0bcbeacf5$var$StackTracey.maxColumnWidths = {
    callee: 30,
    file: 60,
    sourceLine: 80
} /*  Chaining helper for .isThirdParty
    ------------------------------------------------------------------------ */ ;
(()=>{
    const methods = {
        include (pred) {
            const f = $21460db0bcbeacf5$var$StackTracey.isThirdParty;
            $21460db0bcbeacf5$var$O.assign($21460db0bcbeacf5$var$StackTracey.isThirdParty = (path)=>f(path) || pred(path), methods);
        },
        except (pred) {
            const f = $21460db0bcbeacf5$var$StackTracey.isThirdParty;
            $21460db0bcbeacf5$var$O.assign($21460db0bcbeacf5$var$StackTracey.isThirdParty = (path)=>f(path) && !pred(path), methods);
        }
    };
    $21460db0bcbeacf5$var$O.assign($21460db0bcbeacf5$var$StackTracey.isThirdParty, methods);
})() /*  Array methods
    ------------------------------------------------------------------------ */ ;
[
    "map",
    "filter",
    "slice",
    "concat",
    "reverse"
].forEach((name)=>{
    $21460db0bcbeacf5$var$StackTracey.prototype[name] = function() {
        const arr = Array.from(this);
        return new $21460db0bcbeacf5$var$StackTracey(arr[name].apply(arr, arguments));
    };
});
/*  A private field that an Error instance can expose
    ------------------------------------------------------------------------ */ $21460db0bcbeacf5$var$StackTracey.stack = /* istanbul ignore next */ typeof Symbol !== "undefined" ? Symbol.for("StackTracey") : "__StackTracey";
/*  ------------------------------------------------------------------------ */ $21460db0bcbeacf5$exports = $21460db0bcbeacf5$var$StackTracey /*  ------------------------------------------------------------------------ */ ;



const { assign: $16f28a614e2cb9e7$var$assign } = Object;
const { min: $16f28a614e2cb9e7$var$min, max: $16f28a614e2cb9e7$var$max } = Math;
/*  DOM HELPERS --------------------------------------------------------------------    */ const $16f28a614e2cb9e7$var$nanoscript = (classPrefix = "")=>function createElement(tagIdClasses, props = {}, children = []) {
        if (props instanceof Node || typeof props === "string" || Array.isArray(props)) {
            children = props;
            props = {};
        }
        if (children && !Array.isArray(children)) children = [
            children
        ];
        const [tagId, ...classes] = tagIdClasses.split(".");
        const [tag, id] = tagId.split("#");
        const el = document.createElement(tag || "div");
        if (id) el.id = id;
        for (const c of classes)el.classList.add(classPrefix + c);
        for (const c of children)if (c) el.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
        return $16f28a614e2cb9e7$var$assign(el, props);
    };
const $16f28a614e2cb9e7$var$h = $16f28a614e2cb9e7$var$nanoscript("panic-overlay__");
/*  CSS --------------------------------------------------------------------------    */ const $16f28a614e2cb9e7$var$style = $16f28a614e2cb9e7$var$h("style", `

.panic-overlay__modal {
    
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background:white;
    z-index: 10000;
    box-sizing: border-box;
    overflow-y: scroll;
    overflow-x: hidden;
    font-size:18px;
    --left-pad: 60px;
}

.panic-overlay__modal,
.panic-overlay__modal * {
    display: block;
    padding: 0;
    margin: 0;
    font-family: Menlo, Monaco, "Courier New", Courier, monospace;
}

.panic-overlay__modal span,
.panic-overlay__modal em,
.panic-overlay__modal strong {
    display: inline;
}

.panic-overlay strong {
    font-weight: bold;
}

.panic-overlay__hidden {
    display: none;
}

.panic-overlay__modal h1 {

    color: black;
    margin: 0;
    padding: 0;
    font-size: 1.77em;
    font-weight: 600;
    opacity: 0.75;
    margin-top:50px;
    margin-bottom:45px;
    position: relative;
    padding-left: var(--left-pad);
}

.panic-overlay__close {
    color: black;
    font-weight: normal;
    text-decoration: none;
    position: absolute;
    top:-0.32em;
    right: 1em;
    font-size: 1.77em;
    opacity: 0.15;
    transition: all 0.25s ease-in-out;
}

.panic-overlay__close:hover {
    transform:scale(1.5);
    opacity: 0.25;
}

.panic-overlay__error {
    margin: 1em 0 3em 0;
    left:0;
}

.panic-overlay__error-title {
    display: flex;
    align-items: stretch;
    padding-right: 50px;
}

.panic-overlay__error-type {
    min-height: 2.8em;
    display: flex !important;
    align-items: center;
    padding:0 1em;
    background: rgb(255, 0, 64);
    color: white;
    margin-right: 2em;
    padding-left: var(--left-pad);
    white-space: nowrap;
}

.panic-overlay__error-counter {
    color: white;
    opacity: 0.3;
    position: absolute;
    left: 0.8em;
}

.panic-overlay__error-message {
    display: flex !important;
    align-items: center;
    font-weight:400;
    line-height: 1em;
}

.panic-overlay__error-stack {
    margin-top: 2em;
    white-space: pre;
    padding-left: var(--left-pad);
}

.panic-overlay__stack-entry {
    cursor: pointer;
    margin-bottom: 2.5em;
}

.panic-overlay__collapsed .panic-overlay__stack-entry-hidden {
    display: none;
}

.panic-overlay__file {
    font-weight: bold;
    margin-top: 2.5em;
    margin-bottom: 1.5em;
    color: rgb(202, 17, 63);
}

.panic-overlay__file strong {
    text-decoration: underline;
}

.panic-overlay__file:before,
.panic-overlay__more:before {
    content: '@ ';
    opacity: 0.5;
    margin-left: -1.25em;
}

.panic-overlay__more:before {
    content: '\u{25B7} ';
    opacity: 0.5;
}

.panic-overlay__more {
    opacity: 0.25;
    color: black;
    font-size: 0.835em;
    cursor: pointer;
    text-align: center;
    display: none;
}

.panic-overlay__more em {
    font-style: normal;
    font-weight: normal;
    border-bottom: 1px dashed black;
}

.panic-overlay__collapsed .panic-overlay__more {
    display: block;
}

.panic-overlay__lines {
    color:rgb(187, 165, 165);
    font-size: 0.835em;
}

.panic-overlay__lines:not(.panic-overlay__no-fade) {
    -webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,1) 75%, rgba(0,0,0,0));
    mask-image: linear-gradient(to bottom, rgba(0,0,0,1) 75%, rgba(0,0,0,0));
}

.panic-overlay__line-number { 
    padding-right: 1.5em;
    opacity: 0.5;
}

.panic-overlay__line-hili {
    background: #ffff78;
    color: #5f4545;
}

.panic-overlay__stack-entry:first-child .panic-overlay__line-hili strong {
    text-decoration: underline wavy #ff0040;
}

.panic-overlay__line-hili em {
    font-style: italic;
    color: rgb(255, 0, 64);
    font-size: 0.75em;
    margin-left: 2em;
    opacity: 0.25;
    position: relative;
    top: -0.115em;
    white-space: nowrap;
}

.panic-overlay__line-hili em:before {
    content: '\u{2190} ';
}

.panic-overlay__no-source {
    font-style: italic;
}

@media only screen and (max-width: 640px) {

    .panic-overlay__modal {
        font-size: 15px;
        --left-pad: 50px;
    }
    
    .panic-overlay__modal h1 {
        margin:40px 0;
    }
}

@media only screen and (max-width: 500px) {
    
    .panic-overlay__modal {
        font-size: 14px;
        --left-pad: 45px;
    }
    
    .panic-overlay__modal h1 {
        margin:30px 0;
    }
}

`);
/*  CONFIGURATION --------------------------------------------------------------------------    */ const $16f28a614e2cb9e7$var$defaultConfig = {
    handleErrors: true,
    projectRoot: undefined,
    stackEntryClicked (entry) {
        if (this.projectRoot) window.location = `vscode://file/${(0, (/*@__PURE__*/$parcel$interopDefault($8f15afb24c6b7513$exports))).concat(this.projectRoot, entry.fileRelative)}:${entry.line}:${entry.column}`;
    }
};
const $16f28a614e2cb9e7$var$config = $16f28a614e2cb9e7$var$defaultConfig;
/*  RENDERING --------------------------------------------------------------------------    */ const $16f28a614e2cb9e7$var$errors = $16f28a614e2cb9e7$var$h(".errors");
const $16f28a614e2cb9e7$var$modal = $16f28a614e2cb9e7$var$h(".modal.hidden.collapsed", [
    $16f28a614e2cb9e7$var$h("h1", [
        "Oops :(",
        $16f28a614e2cb9e7$var$h("a.close", {
            href: "#",
            onclick () {
                $16f28a614e2cb9e7$var$toggle(false);
            }
        }, "\xd7")
    ]),
    $16f28a614e2cb9e7$var$errors
]);
const $16f28a614e2cb9e7$var$shouldHideEntry = (entry, i)=>(entry.thirdParty || entry["native"] || entry.hide) && i !== 0;
function $16f28a614e2cb9e7$var$renderStackEntry(entry, i, message) {
    const { sourceFile: sourceFile = {
        lines: []
    }, line: line, column: column, fileShort: fileShort, calleeShort: calleeShort, fileRelative: fileRelative } = entry;
    const lineIndex = line - 1;
    const maxLines = sourceFile.lines.length;
    const window1 = 4;
    let start = lineIndex - window1, end = lineIndex + window1 + 2;
    if (start < 0) {
        end = $16f28a614e2cb9e7$var$min(end - start, maxLines);
        start = 0;
    }
    if (end > maxLines) {
        start = $16f28a614e2cb9e7$var$max(0, start - (end - maxLines));
        end = maxLines;
    }
    const lines = sourceFile.lines.slice(start, end);
    const lineNumberWidth = String(start + lines.length).length;
    const hiliIndex = line - start - 1;
    const hiliMsg = i === 0 ? message : "";
    const onLastLine = hiliIndex === lines.length - 1;
    const className = ".stack-entry" + ($16f28a614e2cb9e7$var$shouldHideEntry(entry, i) ? ".stack-entry-hidden" : "");
    return $16f28a614e2cb9e7$var$h(className, {
        onclick () {
            $16f28a614e2cb9e7$var$config.stackEntryClicked(entry);
        }
    }, [
        $16f28a614e2cb9e7$var$h(".file", $16f28a614e2cb9e7$var$h("strong", fileShort)),
        $16f28a614e2cb9e7$var$h(".lines" + (onLastLine ? ".no-fade" : ""), lines.length ? lines.map((text, i)=>$16f28a614e2cb9e7$var$h(".line" + (i === hiliIndex ? ".line-hili" : ""), [
                $16f28a614e2cb9e7$var$h("span.line-number", String(start + i + 1).padStart(lineNumberWidth, " ")),
                $16f28a614e2cb9e7$var$h("span.line-text", i === hiliIndex ? $16f28a614e2cb9e7$var$renderHighlightedLine(text, column, hiliMsg) : text)
            ])) : [
            $16f28a614e2cb9e7$var$h(".line", [
                $16f28a614e2cb9e7$var$h("span.line-number", String(line)),
                $16f28a614e2cb9e7$var$h("span.line-text.no-source", `\u{2026} somewhere at ${calleeShort ? calleeShort + "()" : "???"} \u{2026}`)
            ])
        ])
    ]);
}
function $16f28a614e2cb9e7$var$renderHighlightedLine(text, column, msg) {
    const [before, after] = [
        text.slice(0, column - 1),
        text.slice(column - 1)
    ];
    return [
        before,
        $16f28a614e2cb9e7$var$h("strong", after)
    ];
}
function $16f28a614e2cb9e7$var$panic(err) {
    const stack = new (0, (/*@__PURE__*/$parcel$interopDefault($21460db0bcbeacf5$exports)))(err).withSources;
    const indexText = stack.clean.pretty;
    // Deduplication
    for (const el of $16f28a614e2cb9e7$var$errors.childNodes)if (el._indexText === indexText) {
        $16f28a614e2cb9e7$var$assign(el.querySelector(".panic-overlay__error-counter"), {
            innerText: el._counter = (el._counter || 1) + 1,
            style: ""
        });
        return;
    }
    const showMore = ()=>$16f28a614e2cb9e7$var$modal.classList.remove("panic-overlay__collapsed");
    const type = String(err && (err.type || err.constructor && err.constructor.name) || typeof err);
    const msg = String(err && err.message);
    const el = $16f28a614e2cb9e7$var$h(".error", {
        _indexText: indexText
    }, [
        $16f28a614e2cb9e7$var$h(".error-title", [
            $16f28a614e2cb9e7$var$h("span.error-type", [
                type,
                $16f28a614e2cb9e7$var$h("span.error-counter", {
                    style: "display: none;"
                })
            ]),
            $16f28a614e2cb9e7$var$h("span.error-message", msg)
        ]),
        $16f28a614e2cb9e7$var$h(".error-stack", [
            ...stack.map((e, i)=>$16f28a614e2cb9e7$var$renderStackEntry(e, i, msg)),
            $16f28a614e2cb9e7$var$h(".more", $16f28a614e2cb9e7$var$h("em", {
                onclick: showMore
            }, "show more"))
        ])
    ]);
    if (!stack.find($16f28a614e2cb9e7$var$shouldHideEntry)) showMore() // hides "show more" if nothing to show
    ;
    $16f28a614e2cb9e7$var$errors.insertBefore(el, $16f28a614e2cb9e7$var$errors.firstChild);
    if ($16f28a614e2cb9e7$var$errors.childElementCount > 10) $16f28a614e2cb9e7$var$errors.lastChild.remove() // prevents hang in case of vast number of errors
    ;
    $16f28a614e2cb9e7$var$toggle(true);
    return $16f28a614e2cb9e7$var$panic;
}
/*  VISIBILITY ON/OFF --------------------------------------------------------------------------    */ let $16f28a614e2cb9e7$var$visible = false;
function $16f28a614e2cb9e7$var$toggle(yes) {
    if (document.body) {
        if (yes) {
            document.head.appendChild($16f28a614e2cb9e7$var$style);
            document.body.appendChild($16f28a614e2cb9e7$var$modal);
        }
        document.body.classList.toggle("panic-overlay__visible", yes);
    }
    $16f28a614e2cb9e7$var$modal.classList.toggle("panic-overlay__hidden", !yes);
    if ($16f28a614e2cb9e7$var$visible && !yes) {
        $16f28a614e2cb9e7$var$errors.innerText = "";
        $16f28a614e2cb9e7$var$modal.classList.add("panic-overlay__collapsed");
    }
    $16f28a614e2cb9e7$var$visible = yes;
    return $16f28a614e2cb9e7$var$panic;
}
/*  EVENTS --------------------------------------------------------------------------    */ function $16f28a614e2cb9e7$var$onUncaughtError(e) {
    if ($16f28a614e2cb9e7$var$config.handleErrors) $16f28a614e2cb9e7$var$panic(e);
}
window.addEventListener("error", (e)=>$16f28a614e2cb9e7$var$onUncaughtError(e.error));
window.addEventListener("unhandledrejection", (e)=>$16f28a614e2cb9e7$var$onUncaughtError(e.reason));
(function onReady(fn) {
    if (document.body) fn();
    else document.addEventListener("DOMContentLoaded", fn);
})(()=>{
    $16f28a614e2cb9e7$var$toggle($16f28a614e2cb9e7$var$visible);
});
/*  EXPORT --------------------------------------------------------------------------    */ $16f28a614e2cb9e7$var$panic.toggle = $16f28a614e2cb9e7$var$toggle;
$16f28a614e2cb9e7$var$panic.configure = function configure(cfg) {
    $16f28a614e2cb9e7$var$assign($16f28a614e2cb9e7$var$config, $16f28a614e2cb9e7$var$defaultConfig, cfg);
    return $16f28a614e2cb9e7$var$panic;
};
var $16f28a614e2cb9e7$export$2e2bcd8739ae039 = $16f28a614e2cb9e7$var$panic;


parcelRequire("jSIPP");
var $3ab9800416b64e29$exports = {};
"use strict";
function $3ab9800416b64e29$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3ab9800416b64e29$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3ab9800416b64e29$var$checkDCE();

$3ab9800416b64e29$exports = (parcelRequire("6iqOz"));



function $dfb8d665a0f6a70e$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $7e9b970aebca32bd$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $dfb8d665a0f6a70e$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}




var $jSIPP = parcelRequire("jSIPP");

var $iOWL4 = parcelRequire("iOWL4");
var $c029b53b9555391a$exports = {};
"use strict";
Object.defineProperty($c029b53b9555391a$exports, "__esModule", {
    value: true
});
var $c029b53b9555391a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jSIPP = parcelRequire("jSIPP");
var $c029b53b9555391a$var$_react2 = $c029b53b9555391a$var$_interopRequireDefault($jSIPP);

var $26IBV = parcelRequire("26IBV");
var $c029b53b9555391a$var$_propTypes2 = $c029b53b9555391a$var$_interopRequireDefault($26IBV);
var $a000fe6a3e56f02a$exports = {};
"use strict";
Object.defineProperty($a000fe6a3e56f02a$exports, "__esModule", {
    value: true
});
$a000fe6a3e56f02a$exports["default"] = $a000fe6a3e56f02a$var$ajaxGet;
function $a000fe6a3e56f02a$var$ajaxGet(url, callback) {
    if (typeof XDomainRequest !== "undefined") {
        callback(null);
        return null;
    }
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) callback(JSON.parse(xhr.responseText));
    };
    xhr.open("GET", url, true);
    xhr.send();
    return xhr;
}
$a000fe6a3e56f02a$exports = $a000fe6a3e56f02a$exports["default"];


var $c029b53b9555391a$var$_ajaxGet2 = $c029b53b9555391a$var$_interopRequireDefault($a000fe6a3e56f02a$exports);
var $5049c63bab0d34b8$exports = {};
"use strict";
Object.defineProperty($5049c63bab0d34b8$exports, "__esModule", {
    value: true
});
$5049c63bab0d34b8$exports.classNames = $5049c63bab0d34b8$var$classNames;
function $5049c63bab0d34b8$var$classNames(classSet) {
    return Object.keys(classSet).filter(function(key) {
        return classSet[key];
    }).join(" ");
}


var $c029b53b9555391a$var$utils = $c029b53b9555391a$var$_interopRequireWildcard($5049c63bab0d34b8$exports);
function $c029b53b9555391a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}
function $c029b53b9555391a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c029b53b9555391a$var$_defaults(obj, defaults) {
    var keys = Object.getOwnPropertyNames(defaults);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key);
        if (value && value.configurable && obj[key] === undefined) Object.defineProperty(obj, key, value);
    }
    return obj;
}
function $c029b53b9555391a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c029b53b9555391a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $c029b53b9555391a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c029b53b9555391a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c029b53b9555391a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : $c029b53b9555391a$var$_defaults(subClass, superClass);
}
var $c029b53b9555391a$var$typeToLabel = {
    stargazers: "Star",
    watchers: "Watch",
    forks: "Fork"
};
var $c029b53b9555391a$var$typeToPath = {
    forks: "network"
};
var $c029b53b9555391a$var$GitHubButton = function(_React$Component) {
    $c029b53b9555391a$var$_inherits(GitHubButton, _React$Component);
    function GitHubButton() {
        var _temp, _this, _ret;
        $c029b53b9555391a$var$_classCallCheck(this, GitHubButton);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $c029b53b9555391a$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            count: null
        }, _temp), $c029b53b9555391a$var$_possibleConstructorReturn(_this, _ret);
    }
    GitHubButton.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this.xhr = (0, $c029b53b9555391a$var$_ajaxGet2["default"])(this.getRequestUrl(), function(response) {
            _this2.setCount(response);
        });
    };
    GitHubButton.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.xhr) this.xhr.abort();
    };
    GitHubButton.prototype.setCount = function setCount(data) {
        if (!data) return;
        var count = data[this.props.type + "_count"];
        this.setState({
            count: count
        });
    };
    GitHubButton.prototype.getRequestUrl = function getRequestUrl() {
        var _props = this.props, namespace = _props.namespace, repo = _props.repo;
        return "//api.github.com/repos/" + namespace + "/" + repo;
    };
    GitHubButton.prototype.getRepoUrl = function getRepoUrl() {
        var _props2 = this.props, namespace = _props2.namespace, repo = _props2.repo;
        return "//github.com/" + namespace + "/" + repo + "/";
    };
    GitHubButton.prototype.getCountUrl = function getCountUrl() {
        var _props3 = this.props, namespace = _props3.namespace, repo = _props3.repo, type = _props3.type;
        return "//github.com/" + namespace + "/" + repo + "/" + ($c029b53b9555391a$var$typeToPath[type] || type) + "/";
    };
    GitHubButton.prototype.getCountStyle = function getCountStyle() {
        var count = this.state.count;
        if (count !== null) return {
            display: "block"
        };
        return null;
    };
    GitHubButton.prototype.render = function render() {
        var _props4 = this.props, className = _props4.className, type = _props4.type, size = _props4.size, rest = $c029b53b9555391a$var$_objectWithoutProperties(_props4, [
            "className",
            "type",
            "size"
        ]);
        delete rest.namespace;
        delete rest.repo;
        var count = this.state.count;
        var buttonClassName = $c029b53b9555391a$var$utils.classNames($c029b53b9555391a$var$_defineProperty({
            "github-btn": true,
            "github-btn-large": size === "large"
        }, className, className));
        return $c029b53b9555391a$var$_react2["default"].createElement("span", $c029b53b9555391a$var$_extends({}, rest, {
            className: buttonClassName
        }), $c029b53b9555391a$var$_react2["default"].createElement("a", {
            className: "gh-btn",
            href: this.getRepoUrl(),
            target: "_blank"
        }, $c029b53b9555391a$var$_react2["default"].createElement("span", {
            className: "gh-ico",
            "aria-hidden": "true"
        }), $c029b53b9555391a$var$_react2["default"].createElement("span", {
            className: "gh-text"
        }, $c029b53b9555391a$var$typeToLabel[type])), $c029b53b9555391a$var$_react2["default"].createElement("a", {
            className: "gh-count",
            target: "_blank",
            href: this.getCountUrl(),
            style: this.getCountStyle()
        }, count));
    };
    return GitHubButton;
}($c029b53b9555391a$var$_react2["default"].Component);
$c029b53b9555391a$var$GitHubButton.displayName = "GitHubButton";
$c029b53b9555391a$var$GitHubButton.propTypes = {
    className: $c029b53b9555391a$var$_propTypes2["default"].string,
    type: $c029b53b9555391a$var$_propTypes2["default"].oneOf([
        "stargazers",
        "watchers",
        "forks"
    ]).isRequired,
    namespace: $c029b53b9555391a$var$_propTypes2["default"].string.isRequired,
    repo: $c029b53b9555391a$var$_propTypes2["default"].string.isRequired,
    size: $c029b53b9555391a$var$_propTypes2["default"].oneOf([
        "large"
    ])
};
$c029b53b9555391a$exports["default"] = $c029b53b9555391a$var$GitHubButton;
$c029b53b9555391a$exports = $c029b53b9555391a$exports["default"];


/*! pako 2.0.2 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $5cd34eeeac41a6e5$var$Z_FIXED = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $5cd34eeeac41a6e5$var$Z_BINARY = 0;
const $5cd34eeeac41a6e5$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $5cd34eeeac41a6e5$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $5cd34eeeac41a6e5$var$zero(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $5cd34eeeac41a6e5$var$STORED_BLOCK = 0;
const $5cd34eeeac41a6e5$var$STATIC_TREES = 1;
const $5cd34eeeac41a6e5$var$DYN_TREES = 2;
/* The three kinds of block type */ const $5cd34eeeac41a6e5$var$MIN_MATCH = 3;
const $5cd34eeeac41a6e5$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $5cd34eeeac41a6e5$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $5cd34eeeac41a6e5$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $5cd34eeeac41a6e5$var$L_CODES = $5cd34eeeac41a6e5$var$LITERALS + 1 + $5cd34eeeac41a6e5$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $5cd34eeeac41a6e5$var$D_CODES = 30;
/* number of distance codes */ const $5cd34eeeac41a6e5$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $5cd34eeeac41a6e5$var$HEAP_SIZE = 2 * $5cd34eeeac41a6e5$var$L_CODES + 1;
/* maximum heap size */ const $5cd34eeeac41a6e5$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $5cd34eeeac41a6e5$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $5cd34eeeac41a6e5$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $5cd34eeeac41a6e5$var$END_BLOCK = 256;
/* end of block literal code */ const $5cd34eeeac41a6e5$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $5cd34eeeac41a6e5$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $5cd34eeeac41a6e5$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $5cd34eeeac41a6e5$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $5cd34eeeac41a6e5$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $5cd34eeeac41a6e5$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $5cd34eeeac41a6e5$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $5cd34eeeac41a6e5$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $5cd34eeeac41a6e5$var$static_ltree = new Array(($5cd34eeeac41a6e5$var$L_CODES + 2) * 2);
$5cd34eeeac41a6e5$var$zero($5cd34eeeac41a6e5$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $5cd34eeeac41a6e5$var$static_dtree = new Array($5cd34eeeac41a6e5$var$D_CODES * 2);
$5cd34eeeac41a6e5$var$zero($5cd34eeeac41a6e5$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $5cd34eeeac41a6e5$var$_dist_code = new Array($5cd34eeeac41a6e5$var$DIST_CODE_LEN);
$5cd34eeeac41a6e5$var$zero($5cd34eeeac41a6e5$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $5cd34eeeac41a6e5$var$_length_code = new Array($5cd34eeeac41a6e5$var$MAX_MATCH - $5cd34eeeac41a6e5$var$MIN_MATCH + 1);
$5cd34eeeac41a6e5$var$zero($5cd34eeeac41a6e5$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $5cd34eeeac41a6e5$var$base_length = new Array($5cd34eeeac41a6e5$var$LENGTH_CODES);
$5cd34eeeac41a6e5$var$zero($5cd34eeeac41a6e5$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $5cd34eeeac41a6e5$var$base_dist = new Array($5cd34eeeac41a6e5$var$D_CODES);
$5cd34eeeac41a6e5$var$zero($5cd34eeeac41a6e5$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $5cd34eeeac41a6e5$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $5cd34eeeac41a6e5$var$static_l_desc;
let $5cd34eeeac41a6e5$var$static_d_desc;
let $5cd34eeeac41a6e5$var$static_bl_desc;
function $5cd34eeeac41a6e5$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $5cd34eeeac41a6e5$var$d_code = (dist)=>{
    return dist < 256 ? $5cd34eeeac41a6e5$var$_dist_code[dist] : $5cd34eeeac41a6e5$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $5cd34eeeac41a6e5$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $5cd34eeeac41a6e5$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $5cd34eeeac41a6e5$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $5cd34eeeac41a6e5$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $5cd34eeeac41a6e5$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $5cd34eeeac41a6e5$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $5cd34eeeac41a6e5$var$send_code = (s, c, tree)=>{
    $5cd34eeeac41a6e5$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $5cd34eeeac41a6e5$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $5cd34eeeac41a6e5$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $5cd34eeeac41a6e5$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $5cd34eeeac41a6e5$var$gen_bitlen = (s, desc)=>//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $5cd34eeeac41a6e5$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $5cd34eeeac41a6e5$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $5cd34eeeac41a6e5$var$gen_codes = (tree, max_code, bl_count)=>//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    const next_code = new Array($5cd34eeeac41a6e5$var$MAX_BITS + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $5cd34eeeac41a6e5$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $5cd34eeeac41a6e5$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $5cd34eeeac41a6e5$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($5cd34eeeac41a6e5$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $5cd34eeeac41a6e5$var$LENGTH_CODES - 1; code++){
        $5cd34eeeac41a6e5$var$base_length[code] = length;
        for(n = 0; n < 1 << $5cd34eeeac41a6e5$var$extra_lbits[code]; n++)$5cd34eeeac41a6e5$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $5cd34eeeac41a6e5$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $5cd34eeeac41a6e5$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $5cd34eeeac41a6e5$var$extra_dbits[code]; n++)$5cd34eeeac41a6e5$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $5cd34eeeac41a6e5$var$D_CODES; code++){
        $5cd34eeeac41a6e5$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $5cd34eeeac41a6e5$var$extra_dbits[code] - 7; n++)$5cd34eeeac41a6e5$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $5cd34eeeac41a6e5$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $5cd34eeeac41a6e5$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $5cd34eeeac41a6e5$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $5cd34eeeac41a6e5$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $5cd34eeeac41a6e5$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $5cd34eeeac41a6e5$var$gen_codes($5cd34eeeac41a6e5$var$static_ltree, $5cd34eeeac41a6e5$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $5cd34eeeac41a6e5$var$D_CODES; n++){
        $5cd34eeeac41a6e5$var$static_dtree[n * 2 + 1] = 5;
        $5cd34eeeac41a6e5$var$static_dtree[n * 2] = $5cd34eeeac41a6e5$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $5cd34eeeac41a6e5$var$static_l_desc = new $5cd34eeeac41a6e5$var$StaticTreeDesc($5cd34eeeac41a6e5$var$static_ltree, $5cd34eeeac41a6e5$var$extra_lbits, $5cd34eeeac41a6e5$var$LITERALS + 1, $5cd34eeeac41a6e5$var$L_CODES, $5cd34eeeac41a6e5$var$MAX_BITS);
    $5cd34eeeac41a6e5$var$static_d_desc = new $5cd34eeeac41a6e5$var$StaticTreeDesc($5cd34eeeac41a6e5$var$static_dtree, $5cd34eeeac41a6e5$var$extra_dbits, 0, $5cd34eeeac41a6e5$var$D_CODES, $5cd34eeeac41a6e5$var$MAX_BITS);
    $5cd34eeeac41a6e5$var$static_bl_desc = new $5cd34eeeac41a6e5$var$StaticTreeDesc(new Array(0), $5cd34eeeac41a6e5$var$extra_blbits, 0, $5cd34eeeac41a6e5$var$BL_CODES, $5cd34eeeac41a6e5$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $5cd34eeeac41a6e5$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $5cd34eeeac41a6e5$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $5cd34eeeac41a6e5$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $5cd34eeeac41a6e5$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$5cd34eeeac41a6e5$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $5cd34eeeac41a6e5$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $5cd34eeeac41a6e5$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ const $5cd34eeeac41a6e5$var$copy_block = (s, buf, len, header)=>//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $5cd34eeeac41a6e5$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $5cd34eeeac41a6e5$var$put_short(s, len);
        $5cd34eeeac41a6e5$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
    s.pending += len;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $5cd34eeeac41a6e5$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $5cd34eeeac41a6e5$var$pqdownheap = (s, tree, k)=>//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $5cd34eeeac41a6e5$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($5cd34eeeac41a6e5$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $5cd34eeeac41a6e5$var$compress_block = (s, ltree, dtree)=>//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let lx = 0; /* running index in l_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $5cd34eeeac41a6e5$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $5cd34eeeac41a6e5$var$_length_code[lc];
            $5cd34eeeac41a6e5$var$send_code(s, code + $5cd34eeeac41a6e5$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $5cd34eeeac41a6e5$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $5cd34eeeac41a6e5$var$base_length[code];
                $5cd34eeeac41a6e5$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $5cd34eeeac41a6e5$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $5cd34eeeac41a6e5$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $5cd34eeeac41a6e5$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $5cd34eeeac41a6e5$var$base_dist[code];
                $5cd34eeeac41a6e5$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $5cd34eeeac41a6e5$var$send_code(s, $5cd34eeeac41a6e5$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $5cd34eeeac41a6e5$var$build_tree = (s, desc)=>//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $5cd34eeeac41a6e5$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$5cd34eeeac41a6e5$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $5cd34eeeac41a6e5$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $5cd34eeeac41a6e5$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $5cd34eeeac41a6e5$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $5cd34eeeac41a6e5$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $5cd34eeeac41a6e5$var$scan_tree = (s, tree, max_code)=>//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$5cd34eeeac41a6e5$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$5cd34eeeac41a6e5$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$5cd34eeeac41a6e5$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $5cd34eeeac41a6e5$var$send_tree = (s, tree, max_code)=>//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $5cd34eeeac41a6e5$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $5cd34eeeac41a6e5$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $5cd34eeeac41a6e5$var$send_code(s, $5cd34eeeac41a6e5$var$REP_3_6, s.bl_tree);
            $5cd34eeeac41a6e5$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $5cd34eeeac41a6e5$var$send_code(s, $5cd34eeeac41a6e5$var$REPZ_3_10, s.bl_tree);
            $5cd34eeeac41a6e5$var$send_bits(s, count - 3, 3);
        } else {
            $5cd34eeeac41a6e5$var$send_code(s, $5cd34eeeac41a6e5$var$REPZ_11_138, s.bl_tree);
            $5cd34eeeac41a6e5$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $5cd34eeeac41a6e5$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $5cd34eeeac41a6e5$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $5cd34eeeac41a6e5$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $5cd34eeeac41a6e5$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $5cd34eeeac41a6e5$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$5cd34eeeac41a6e5$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $5cd34eeeac41a6e5$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $5cd34eeeac41a6e5$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $5cd34eeeac41a6e5$var$send_bits(s, dcodes - 1, 5);
    $5cd34eeeac41a6e5$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $5cd34eeeac41a6e5$var$send_bits(s, s.bl_tree[$5cd34eeeac41a6e5$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $5cd34eeeac41a6e5$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $5cd34eeeac41a6e5$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $5cd34eeeac41a6e5$var$detect_data_type = (s)=>{
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let black_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $5cd34eeeac41a6e5$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $5cd34eeeac41a6e5$var$Z_TEXT;
    for(n = 32; n < $5cd34eeeac41a6e5$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $5cd34eeeac41a6e5$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $5cd34eeeac41a6e5$var$Z_BINARY;
};
let $5cd34eeeac41a6e5$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $5cd34eeeac41a6e5$var$_tr_init = (s)=>{
    if (!$5cd34eeeac41a6e5$var$static_init_done) {
        $5cd34eeeac41a6e5$var$tr_static_init();
        $5cd34eeeac41a6e5$var$static_init_done = true;
    }
    s.l_desc = new $5cd34eeeac41a6e5$var$TreeDesc(s.dyn_ltree, $5cd34eeeac41a6e5$var$static_l_desc);
    s.d_desc = new $5cd34eeeac41a6e5$var$TreeDesc(s.dyn_dtree, $5cd34eeeac41a6e5$var$static_d_desc);
    s.bl_desc = new $5cd34eeeac41a6e5$var$TreeDesc(s.bl_tree, $5cd34eeeac41a6e5$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $5cd34eeeac41a6e5$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $5cd34eeeac41a6e5$var$_tr_stored_block = (s, buf, stored_len, last)=>//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $5cd34eeeac41a6e5$var$send_bits(s, ($5cd34eeeac41a6e5$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $5cd34eeeac41a6e5$var$copy_block(s, buf, stored_len, true); /* with header */ 
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $5cd34eeeac41a6e5$var$_tr_align = (s)=>{
    $5cd34eeeac41a6e5$var$send_bits(s, $5cd34eeeac41a6e5$var$STATIC_TREES << 1, 3);
    $5cd34eeeac41a6e5$var$send_code(s, $5cd34eeeac41a6e5$var$END_BLOCK, $5cd34eeeac41a6e5$var$static_ltree);
    $5cd34eeeac41a6e5$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ const $5cd34eeeac41a6e5$var$_tr_flush_block = (s, buf, stored_len, last)=>//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $5cd34eeeac41a6e5$var$Z_UNKNOWN) s.strm.data_type = $5cd34eeeac41a6e5$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $5cd34eeeac41a6e5$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $5cd34eeeac41a6e5$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $5cd34eeeac41a6e5$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $5cd34eeeac41a6e5$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $5cd34eeeac41a6e5$var$Z_FIXED || static_lenb === opt_lenb) {
        $5cd34eeeac41a6e5$var$send_bits(s, ($5cd34eeeac41a6e5$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $5cd34eeeac41a6e5$var$compress_block(s, $5cd34eeeac41a6e5$var$static_ltree, $5cd34eeeac41a6e5$var$static_dtree);
    } else {
        $5cd34eeeac41a6e5$var$send_bits(s, ($5cd34eeeac41a6e5$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $5cd34eeeac41a6e5$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $5cd34eeeac41a6e5$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $5cd34eeeac41a6e5$var$init_block(s);
    if (last) $5cd34eeeac41a6e5$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $5cd34eeeac41a6e5$var$_tr_tally = (s, dist, lc)=>//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //let out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($5cd34eeeac41a6e5$var$_length_code[lc] + $5cd34eeeac41a6e5$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$5cd34eeeac41a6e5$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ };
var $5cd34eeeac41a6e5$var$_tr_init_1 = $5cd34eeeac41a6e5$var$_tr_init;
var $5cd34eeeac41a6e5$var$_tr_stored_block_1 = $5cd34eeeac41a6e5$var$_tr_stored_block;
var $5cd34eeeac41a6e5$var$_tr_flush_block_1 = $5cd34eeeac41a6e5$var$_tr_flush_block;
var $5cd34eeeac41a6e5$var$_tr_tally_1 = $5cd34eeeac41a6e5$var$_tr_tally;
var $5cd34eeeac41a6e5$var$_tr_align_1 = $5cd34eeeac41a6e5$var$_tr_align;
var $5cd34eeeac41a6e5$var$trees = {
    _tr_init: $5cd34eeeac41a6e5$var$_tr_init_1,
    _tr_stored_block: $5cd34eeeac41a6e5$var$_tr_stored_block_1,
    _tr_flush_block: $5cd34eeeac41a6e5$var$_tr_flush_block_1,
    _tr_tally: $5cd34eeeac41a6e5$var$_tr_tally_1,
    _tr_align: $5cd34eeeac41a6e5$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $5cd34eeeac41a6e5$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $5cd34eeeac41a6e5$var$adler32_1 = $5cd34eeeac41a6e5$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $5cd34eeeac41a6e5$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $5cd34eeeac41a6e5$var$crcTable = new Uint32Array($5cd34eeeac41a6e5$var$makeTable());
const $5cd34eeeac41a6e5$var$crc32 = (crc, buf, len, pos)=>{
    const t = $5cd34eeeac41a6e5$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $5cd34eeeac41a6e5$var$crc32_1 = $5cd34eeeac41a6e5$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $5cd34eeeac41a6e5$var$messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $5cd34eeeac41a6e5$var$constants = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $5cd34eeeac41a6e5$var$_tr_init$1, _tr_stored_block: $5cd34eeeac41a6e5$var$_tr_stored_block$1, _tr_flush_block: $5cd34eeeac41a6e5$var$_tr_flush_block$1, _tr_tally: $5cd34eeeac41a6e5$var$_tr_tally$1, _tr_align: $5cd34eeeac41a6e5$var$_tr_align$1 } = $5cd34eeeac41a6e5$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $5cd34eeeac41a6e5$var$Z_NO_FLUSH, Z_PARTIAL_FLUSH: $5cd34eeeac41a6e5$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $5cd34eeeac41a6e5$var$Z_FULL_FLUSH, Z_FINISH: $5cd34eeeac41a6e5$var$Z_FINISH, Z_BLOCK: $5cd34eeeac41a6e5$var$Z_BLOCK, Z_OK: $5cd34eeeac41a6e5$var$Z_OK, Z_STREAM_END: $5cd34eeeac41a6e5$var$Z_STREAM_END, Z_STREAM_ERROR: $5cd34eeeac41a6e5$var$Z_STREAM_ERROR, Z_DATA_ERROR: $5cd34eeeac41a6e5$var$Z_DATA_ERROR, Z_BUF_ERROR: $5cd34eeeac41a6e5$var$Z_BUF_ERROR, Z_DEFAULT_COMPRESSION: $5cd34eeeac41a6e5$var$Z_DEFAULT_COMPRESSION, Z_FILTERED: $5cd34eeeac41a6e5$var$Z_FILTERED, Z_HUFFMAN_ONLY: $5cd34eeeac41a6e5$var$Z_HUFFMAN_ONLY, Z_RLE: $5cd34eeeac41a6e5$var$Z_RLE, Z_FIXED: $5cd34eeeac41a6e5$var$Z_FIXED$1, Z_DEFAULT_STRATEGY: $5cd34eeeac41a6e5$var$Z_DEFAULT_STRATEGY, Z_UNKNOWN: $5cd34eeeac41a6e5$var$Z_UNKNOWN$1, Z_DEFLATED: $5cd34eeeac41a6e5$var$Z_DEFLATED } = $5cd34eeeac41a6e5$var$constants;
/*============================================================================*/ const $5cd34eeeac41a6e5$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $5cd34eeeac41a6e5$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $5cd34eeeac41a6e5$var$DEF_MEM_LEVEL = 8;
const $5cd34eeeac41a6e5$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $5cd34eeeac41a6e5$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $5cd34eeeac41a6e5$var$L_CODES$1 = $5cd34eeeac41a6e5$var$LITERALS$1 + 1 + $5cd34eeeac41a6e5$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $5cd34eeeac41a6e5$var$D_CODES$1 = 30;
/* number of distance codes */ const $5cd34eeeac41a6e5$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $5cd34eeeac41a6e5$var$HEAP_SIZE$1 = 2 * $5cd34eeeac41a6e5$var$L_CODES$1 + 1;
/* maximum heap size */ const $5cd34eeeac41a6e5$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $5cd34eeeac41a6e5$var$MIN_MATCH$1 = 3;
const $5cd34eeeac41a6e5$var$MAX_MATCH$1 = 258;
const $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD = $5cd34eeeac41a6e5$var$MAX_MATCH$1 + $5cd34eeeac41a6e5$var$MIN_MATCH$1 + 1;
const $5cd34eeeac41a6e5$var$PRESET_DICT = 0x20;
const $5cd34eeeac41a6e5$var$INIT_STATE = 42;
const $5cd34eeeac41a6e5$var$EXTRA_STATE = 69;
const $5cd34eeeac41a6e5$var$NAME_STATE = 73;
const $5cd34eeeac41a6e5$var$COMMENT_STATE = 91;
const $5cd34eeeac41a6e5$var$HCRC_STATE = 103;
const $5cd34eeeac41a6e5$var$BUSY_STATE = 113;
const $5cd34eeeac41a6e5$var$FINISH_STATE = 666;
const $5cd34eeeac41a6e5$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $5cd34eeeac41a6e5$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $5cd34eeeac41a6e5$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $5cd34eeeac41a6e5$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $5cd34eeeac41a6e5$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $5cd34eeeac41a6e5$var$err = (strm, errorCode)=>{
    strm.msg = $5cd34eeeac41a6e5$var$messages[errorCode];
    return errorCode;
};
const $5cd34eeeac41a6e5$var$rank = (f)=>{
    return (f << 1) - (f > 4 ? 9 : 0);
};
const $5cd34eeeac41a6e5$var$zero$1 = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* eslint-disable new-cap */ let $5cd34eeeac41a6e5$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $5cd34eeeac41a6e5$var$HASH = $5cd34eeeac41a6e5$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ const $5cd34eeeac41a6e5$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $5cd34eeeac41a6e5$var$flush_block_only = (s, last)=>{
    $5cd34eeeac41a6e5$var$_tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $5cd34eeeac41a6e5$var$flush_pending(s.strm);
};
const $5cd34eeeac41a6e5$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $5cd34eeeac41a6e5$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $5cd34eeeac41a6e5$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $5cd34eeeac41a6e5$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5cd34eeeac41a6e5$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $5cd34eeeac41a6e5$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $5cd34eeeac41a6e5$var$MAX_MATCH$1;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $5cd34eeeac41a6e5$var$MAX_MATCH$1 - (strend - scan);
        scan = strend - $5cd34eeeac41a6e5$var$MAX_MATCH$1;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $5cd34eeeac41a6e5$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $5cd34eeeac41a6e5$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $5cd34eeeac41a6e5$var$MIN_MATCH$1) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $5cd34eeeac41a6e5$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $5cd34eeeac41a6e5$var$HASH(s, s.ins_h, s.window[str + $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $5cd34eeeac41a6e5$var$MIN_MATCH$1) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ const $5cd34eeeac41a6e5$var$deflate_stored = (s, flush)=>{
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ let max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $5cd34eeeac41a6e5$var$fill_window(s);
            if (s.lookahead === 0 && flush === $5cd34eeeac41a6e5$var$Z_NO_FLUSH) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ const max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5cd34eeeac41a6e5$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_FINISH_STARTED;
        /***/ return $5cd34eeeac41a6e5$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
    /***/ }
    return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $5cd34eeeac41a6e5$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD) {
            $5cd34eeeac41a6e5$var$fill_window(s);
            if (s.lookahead < $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD && flush === $5cd34eeeac41a6e5$var$Z_NO_FLUSH) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $5cd34eeeac41a6e5$var$MIN_MATCH$1) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $5cd34eeeac41a6e5$var$HASH(s, s.ins_h, s.window[s.strstart + $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $5cd34eeeac41a6e5$var$longest_match(s, hash_head);
        if (s.match_length >= $5cd34eeeac41a6e5$var$MIN_MATCH$1) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $5cd34eeeac41a6e5$var$_tr_tally$1(s, s.strstart - s.match_start, s.match_length - $5cd34eeeac41a6e5$var$MIN_MATCH$1);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $5cd34eeeac41a6e5$var$MIN_MATCH$1) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $5cd34eeeac41a6e5$var$HASH(s, s.ins_h, s.window[s.strstart + $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $5cd34eeeac41a6e5$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5cd34eeeac41a6e5$var$_tr_tally$1(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1 ? s.strstart : $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1;
    if (flush === $5cd34eeeac41a6e5$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_FINISH_STARTED;
        /***/ return $5cd34eeeac41a6e5$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
    /***/ }
    return $5cd34eeeac41a6e5$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $5cd34eeeac41a6e5$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD) {
            $5cd34eeeac41a6e5$var$fill_window(s);
            if (s.lookahead < $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD && flush === $5cd34eeeac41a6e5$var$Z_NO_FLUSH) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $5cd34eeeac41a6e5$var$MIN_MATCH$1) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $5cd34eeeac41a6e5$var$HASH(s, s.ins_h, s.window[s.strstart + $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $5cd34eeeac41a6e5$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $5cd34eeeac41a6e5$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $5cd34eeeac41a6e5$var$Z_FILTERED || s.match_length === $5cd34eeeac41a6e5$var$MIN_MATCH$1 && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $5cd34eeeac41a6e5$var$MIN_MATCH$1 && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $5cd34eeeac41a6e5$var$MIN_MATCH$1;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $5cd34eeeac41a6e5$var$_tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - $5cd34eeeac41a6e5$var$MIN_MATCH$1);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $5cd34eeeac41a6e5$var$HASH(s, s.ins_h, s.window[s.strstart + $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $5cd34eeeac41a6e5$var$_tr_tally$1(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $5cd34eeeac41a6e5$var$_tr_tally$1(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1 ? s.strstart : $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1;
    if (flush === $5cd34eeeac41a6e5$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_FINISH_STARTED;
        /***/ return $5cd34eeeac41a6e5$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
    /***/ }
    return $5cd34eeeac41a6e5$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $5cd34eeeac41a6e5$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $5cd34eeeac41a6e5$var$MAX_MATCH$1) {
            $5cd34eeeac41a6e5$var$fill_window(s);
            if (s.lookahead <= $5cd34eeeac41a6e5$var$MAX_MATCH$1 && flush === $5cd34eeeac41a6e5$var$Z_NO_FLUSH) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $5cd34eeeac41a6e5$var$MIN_MATCH$1 && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $5cd34eeeac41a6e5$var$MAX_MATCH$1;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $5cd34eeeac41a6e5$var$MAX_MATCH$1 - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $5cd34eeeac41a6e5$var$MIN_MATCH$1) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $5cd34eeeac41a6e5$var$_tr_tally$1(s, 1, s.match_length - $5cd34eeeac41a6e5$var$MIN_MATCH$1);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5cd34eeeac41a6e5$var$_tr_tally$1(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5cd34eeeac41a6e5$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_FINISH_STARTED;
        /***/ return $5cd34eeeac41a6e5$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
    /***/ }
    return $5cd34eeeac41a6e5$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $5cd34eeeac41a6e5$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $5cd34eeeac41a6e5$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $5cd34eeeac41a6e5$var$Z_NO_FLUSH) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5cd34eeeac41a6e5$var$_tr_tally$1(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5cd34eeeac41a6e5$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_FINISH_STARTED;
        /***/ return $5cd34eeeac41a6e5$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5cd34eeeac41a6e5$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5cd34eeeac41a6e5$var$BS_NEED_MORE;
    /***/ }
    return $5cd34eeeac41a6e5$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $5cd34eeeac41a6e5$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $5cd34eeeac41a6e5$var$configuration_table = [
    /*      good lazy nice chain */ new $5cd34eeeac41a6e5$var$Config(0, 0, 0, 0, $5cd34eeeac41a6e5$var$deflate_stored),
    /* 0 store only */ new $5cd34eeeac41a6e5$var$Config(4, 4, 8, 4, $5cd34eeeac41a6e5$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $5cd34eeeac41a6e5$var$Config(4, 5, 16, 8, $5cd34eeeac41a6e5$var$deflate_fast),
    /* 2 */ new $5cd34eeeac41a6e5$var$Config(4, 6, 32, 32, $5cd34eeeac41a6e5$var$deflate_fast),
    /* 3 */ new $5cd34eeeac41a6e5$var$Config(4, 4, 16, 16, $5cd34eeeac41a6e5$var$deflate_slow),
    /* 4 lazy matches */ new $5cd34eeeac41a6e5$var$Config(8, 16, 32, 32, $5cd34eeeac41a6e5$var$deflate_slow),
    /* 5 */ new $5cd34eeeac41a6e5$var$Config(8, 16, 128, 128, $5cd34eeeac41a6e5$var$deflate_slow),
    /* 6 */ new $5cd34eeeac41a6e5$var$Config(8, 32, 128, 256, $5cd34eeeac41a6e5$var$deflate_slow),
    /* 7 */ new $5cd34eeeac41a6e5$var$Config(32, 128, 258, 1024, $5cd34eeeac41a6e5$var$deflate_slow),
    /* 8 */ new $5cd34eeeac41a6e5$var$Config(32, 258, 258, 4096, $5cd34eeeac41a6e5$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $5cd34eeeac41a6e5$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $5cd34eeeac41a6e5$var$zero$1(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $5cd34eeeac41a6e5$var$configuration_table[s.level].max_lazy;
    s.good_match = $5cd34eeeac41a6e5$var$configuration_table[s.level].good_length;
    s.nice_match = $5cd34eeeac41a6e5$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $5cd34eeeac41a6e5$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $5cd34eeeac41a6e5$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $5cd34eeeac41a6e5$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($5cd34eeeac41a6e5$var$HEAP_SIZE$1 * 2);
    this.dyn_dtree = new Uint16Array((2 * $5cd34eeeac41a6e5$var$D_CODES$1 + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $5cd34eeeac41a6e5$var$BL_CODES$1 + 1) * 2);
    $5cd34eeeac41a6e5$var$zero$1(this.dyn_ltree);
    $5cd34eeeac41a6e5$var$zero$1(this.dyn_dtree);
    $5cd34eeeac41a6e5$var$zero$1(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($5cd34eeeac41a6e5$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $5cd34eeeac41a6e5$var$L_CODES$1 + 1); /* heap used to build the Huffman trees */ 
    $5cd34eeeac41a6e5$var$zero$1(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $5cd34eeeac41a6e5$var$L_CODES$1 + 1); //uch depth[2*L_CODES+1];
    $5cd34eeeac41a6e5$var$zero$1(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
const $5cd34eeeac41a6e5$var$deflateResetKeep = (strm)=>{
    if (!strm || !strm.state) return $5cd34eeeac41a6e5$var$err(strm, $5cd34eeeac41a6e5$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $5cd34eeeac41a6e5$var$Z_UNKNOWN$1;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $5cd34eeeac41a6e5$var$INIT_STATE : $5cd34eeeac41a6e5$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $5cd34eeeac41a6e5$var$Z_NO_FLUSH;
    $5cd34eeeac41a6e5$var$_tr_init$1(s);
    return $5cd34eeeac41a6e5$var$Z_OK;
};
const $5cd34eeeac41a6e5$var$deflateReset = (strm)=>{
    const ret = $5cd34eeeac41a6e5$var$deflateResetKeep(strm);
    if (ret === $5cd34eeeac41a6e5$var$Z_OK) $5cd34eeeac41a6e5$var$lm_init(strm.state);
    return ret;
};
const $5cd34eeeac41a6e5$var$deflateSetHeader = (strm, head)=>{
    if (!strm || !strm.state) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $5cd34eeeac41a6e5$var$Z_OK;
};
const $5cd34eeeac41a6e5$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR;
    let wrap = 1;
    if (level === $5cd34eeeac41a6e5$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $5cd34eeeac41a6e5$var$MAX_MEM_LEVEL || method !== $5cd34eeeac41a6e5$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $5cd34eeeac41a6e5$var$Z_FIXED$1) return $5cd34eeeac41a6e5$var$err(strm, $5cd34eeeac41a6e5$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $5cd34eeeac41a6e5$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1) / $5cd34eeeac41a6e5$var$MIN_MATCH$1);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $5cd34eeeac41a6e5$var$deflateReset(strm);
};
const $5cd34eeeac41a6e5$var$deflateInit = (strm, level)=>{
    return $5cd34eeeac41a6e5$var$deflateInit2(strm, level, $5cd34eeeac41a6e5$var$Z_DEFLATED, $5cd34eeeac41a6e5$var$MAX_WBITS, $5cd34eeeac41a6e5$var$DEF_MEM_LEVEL, $5cd34eeeac41a6e5$var$Z_DEFAULT_STRATEGY);
};
const $5cd34eeeac41a6e5$var$deflate = (strm, flush)=>{
    let beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $5cd34eeeac41a6e5$var$Z_BLOCK || flush < 0) return strm ? $5cd34eeeac41a6e5$var$err(strm, $5cd34eeeac41a6e5$var$Z_STREAM_ERROR) : $5cd34eeeac41a6e5$var$Z_STREAM_ERROR;
    const s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $5cd34eeeac41a6e5$var$FINISH_STATE && flush !== $5cd34eeeac41a6e5$var$Z_FINISH) return $5cd34eeeac41a6e5$var$err(strm, strm.avail_out === 0 ? $5cd34eeeac41a6e5$var$Z_BUF_ERROR : $5cd34eeeac41a6e5$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $5cd34eeeac41a6e5$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $5cd34eeeac41a6e5$var$put_byte(s, 31);
            $5cd34eeeac41a6e5$var$put_byte(s, 139);
            $5cd34eeeac41a6e5$var$put_byte(s, 8);
            if (!s.gzhead) {
                $5cd34eeeac41a6e5$var$put_byte(s, 0);
                $5cd34eeeac41a6e5$var$put_byte(s, 0);
                $5cd34eeeac41a6e5$var$put_byte(s, 0);
                $5cd34eeeac41a6e5$var$put_byte(s, 0);
                $5cd34eeeac41a6e5$var$put_byte(s, 0);
                $5cd34eeeac41a6e5$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $5cd34eeeac41a6e5$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $5cd34eeeac41a6e5$var$put_byte(s, $5cd34eeeac41a6e5$var$OS_CODE);
                s.status = $5cd34eeeac41a6e5$var$BUSY_STATE;
            } else {
                $5cd34eeeac41a6e5$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $5cd34eeeac41a6e5$var$put_byte(s, s.gzhead.time & 0xff);
                $5cd34eeeac41a6e5$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $5cd34eeeac41a6e5$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $5cd34eeeac41a6e5$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $5cd34eeeac41a6e5$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $5cd34eeeac41a6e5$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $5cd34eeeac41a6e5$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $5cd34eeeac41a6e5$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $5cd34eeeac41a6e5$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5cd34eeeac41a6e5$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $5cd34eeeac41a6e5$var$EXTRA_STATE;
            }
        } else {
            let header = $5cd34eeeac41a6e5$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            let level_flags = -1;
            if (s.strategy >= $5cd34eeeac41a6e5$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $5cd34eeeac41a6e5$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $5cd34eeeac41a6e5$var$BUSY_STATE;
            $5cd34eeeac41a6e5$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $5cd34eeeac41a6e5$var$putShortMSB(s, strm.adler >>> 16);
                $5cd34eeeac41a6e5$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $5cd34eeeac41a6e5$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5cd34eeeac41a6e5$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5cd34eeeac41a6e5$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $5cd34eeeac41a6e5$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5cd34eeeac41a6e5$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $5cd34eeeac41a6e5$var$NAME_STATE;
            }
        } else s.status = $5cd34eeeac41a6e5$var$NAME_STATE;
    }
    if (s.status === $5cd34eeeac41a6e5$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5cd34eeeac41a6e5$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5cd34eeeac41a6e5$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $5cd34eeeac41a6e5$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5cd34eeeac41a6e5$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $5cd34eeeac41a6e5$var$COMMENT_STATE;
            }
        } else s.status = $5cd34eeeac41a6e5$var$COMMENT_STATE;
    }
    if (s.status === $5cd34eeeac41a6e5$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5cd34eeeac41a6e5$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5cd34eeeac41a6e5$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $5cd34eeeac41a6e5$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5cd34eeeac41a6e5$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $5cd34eeeac41a6e5$var$HCRC_STATE;
        } else s.status = $5cd34eeeac41a6e5$var$HCRC_STATE;
    }
    if (s.status === $5cd34eeeac41a6e5$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $5cd34eeeac41a6e5$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $5cd34eeeac41a6e5$var$put_byte(s, strm.adler & 0xff);
                $5cd34eeeac41a6e5$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $5cd34eeeac41a6e5$var$BUSY_STATE;
            }
        } else s.status = $5cd34eeeac41a6e5$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $5cd34eeeac41a6e5$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $5cd34eeeac41a6e5$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $5cd34eeeac41a6e5$var$rank(flush) <= $5cd34eeeac41a6e5$var$rank(old_flush) && flush !== $5cd34eeeac41a6e5$var$Z_FINISH) return $5cd34eeeac41a6e5$var$err(strm, $5cd34eeeac41a6e5$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $5cd34eeeac41a6e5$var$FINISH_STATE && strm.avail_in !== 0) return $5cd34eeeac41a6e5$var$err(strm, $5cd34eeeac41a6e5$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $5cd34eeeac41a6e5$var$Z_NO_FLUSH && s.status !== $5cd34eeeac41a6e5$var$FINISH_STATE) {
        let bstate = s.strategy === $5cd34eeeac41a6e5$var$Z_HUFFMAN_ONLY ? $5cd34eeeac41a6e5$var$deflate_huff(s, flush) : s.strategy === $5cd34eeeac41a6e5$var$Z_RLE ? $5cd34eeeac41a6e5$var$deflate_rle(s, flush) : $5cd34eeeac41a6e5$var$configuration_table[s.level].func(s, flush);
        if (bstate === $5cd34eeeac41a6e5$var$BS_FINISH_STARTED || bstate === $5cd34eeeac41a6e5$var$BS_FINISH_DONE) s.status = $5cd34eeeac41a6e5$var$FINISH_STATE;
        if (bstate === $5cd34eeeac41a6e5$var$BS_NEED_MORE || bstate === $5cd34eeeac41a6e5$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $5cd34eeeac41a6e5$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $5cd34eeeac41a6e5$var$BS_BLOCK_DONE) {
            if (flush === $5cd34eeeac41a6e5$var$Z_PARTIAL_FLUSH) $5cd34eeeac41a6e5$var$_tr_align$1(s);
            else if (flush !== $5cd34eeeac41a6e5$var$Z_BLOCK) {
                $5cd34eeeac41a6e5$var$_tr_stored_block$1(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $5cd34eeeac41a6e5$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $5cd34eeeac41a6e5$var$zero$1(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $5cd34eeeac41a6e5$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $5cd34eeeac41a6e5$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $5cd34eeeac41a6e5$var$Z_FINISH) return $5cd34eeeac41a6e5$var$Z_OK;
    if (s.wrap <= 0) return $5cd34eeeac41a6e5$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $5cd34eeeac41a6e5$var$put_byte(s, strm.adler & 0xff);
        $5cd34eeeac41a6e5$var$put_byte(s, strm.adler >> 8 & 0xff);
        $5cd34eeeac41a6e5$var$put_byte(s, strm.adler >> 16 & 0xff);
        $5cd34eeeac41a6e5$var$put_byte(s, strm.adler >> 24 & 0xff);
        $5cd34eeeac41a6e5$var$put_byte(s, strm.total_in & 0xff);
        $5cd34eeeac41a6e5$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $5cd34eeeac41a6e5$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $5cd34eeeac41a6e5$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $5cd34eeeac41a6e5$var$putShortMSB(s, strm.adler >>> 16);
        $5cd34eeeac41a6e5$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $5cd34eeeac41a6e5$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $5cd34eeeac41a6e5$var$Z_OK : $5cd34eeeac41a6e5$var$Z_STREAM_END;
};
const $5cd34eeeac41a6e5$var$deflateEnd = (strm)=>{
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR;
    const status = strm.state.status;
    if (status !== $5cd34eeeac41a6e5$var$INIT_STATE && status !== $5cd34eeeac41a6e5$var$EXTRA_STATE && status !== $5cd34eeeac41a6e5$var$NAME_STATE && status !== $5cd34eeeac41a6e5$var$COMMENT_STATE && status !== $5cd34eeeac41a6e5$var$HCRC_STATE && status !== $5cd34eeeac41a6e5$var$BUSY_STATE && status !== $5cd34eeeac41a6e5$var$FINISH_STATE) return $5cd34eeeac41a6e5$var$err(strm, $5cd34eeeac41a6e5$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $5cd34eeeac41a6e5$var$BUSY_STATE ? $5cd34eeeac41a6e5$var$err(strm, $5cd34eeeac41a6e5$var$Z_DATA_ERROR) : $5cd34eeeac41a6e5$var$Z_OK;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $5cd34eeeac41a6e5$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $5cd34eeeac41a6e5$var$INIT_STATE || s.lookahead) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $5cd34eeeac41a6e5$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $5cd34eeeac41a6e5$var$zero$1(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $5cd34eeeac41a6e5$var$fill_window(s);
    while(s.lookahead >= $5cd34eeeac41a6e5$var$MIN_MATCH$1){
        let str = s.strstart;
        let n = s.lookahead - ($5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $5cd34eeeac41a6e5$var$HASH(s, s.ins_h, s.window[str + $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1;
        $5cd34eeeac41a6e5$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $5cd34eeeac41a6e5$var$MIN_MATCH$1 - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $5cd34eeeac41a6e5$var$Z_OK;
};
var $5cd34eeeac41a6e5$var$deflateInit_1 = $5cd34eeeac41a6e5$var$deflateInit;
var $5cd34eeeac41a6e5$var$deflateInit2_1 = $5cd34eeeac41a6e5$var$deflateInit2;
var $5cd34eeeac41a6e5$var$deflateReset_1 = $5cd34eeeac41a6e5$var$deflateReset;
var $5cd34eeeac41a6e5$var$deflateResetKeep_1 = $5cd34eeeac41a6e5$var$deflateResetKeep;
var $5cd34eeeac41a6e5$var$deflateSetHeader_1 = $5cd34eeeac41a6e5$var$deflateSetHeader;
var $5cd34eeeac41a6e5$var$deflate_2 = $5cd34eeeac41a6e5$var$deflate;
var $5cd34eeeac41a6e5$var$deflateEnd_1 = $5cd34eeeac41a6e5$var$deflateEnd;
var $5cd34eeeac41a6e5$var$deflateSetDictionary_1 = $5cd34eeeac41a6e5$var$deflateSetDictionary;
var $5cd34eeeac41a6e5$var$deflateInfo = "pako deflate (from Nodeca project)";
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $5cd34eeeac41a6e5$var$deflate_1 = {
    deflateInit: $5cd34eeeac41a6e5$var$deflateInit_1,
    deflateInit2: $5cd34eeeac41a6e5$var$deflateInit2_1,
    deflateReset: $5cd34eeeac41a6e5$var$deflateReset_1,
    deflateResetKeep: $5cd34eeeac41a6e5$var$deflateResetKeep_1,
    deflateSetHeader: $5cd34eeeac41a6e5$var$deflateSetHeader_1,
    deflate: $5cd34eeeac41a6e5$var$deflate_2,
    deflateEnd: $5cd34eeeac41a6e5$var$deflateEnd_1,
    deflateSetDictionary: $5cd34eeeac41a6e5$var$deflateSetDictionary_1,
    deflateInfo: $5cd34eeeac41a6e5$var$deflateInfo
};
const $5cd34eeeac41a6e5$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $5cd34eeeac41a6e5$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(const p in source)if ($5cd34eeeac41a6e5$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $5cd34eeeac41a6e5$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $5cd34eeeac41a6e5$var$common = {
    assign: $5cd34eeeac41a6e5$var$assign,
    flattenChunks: $5cd34eeeac41a6e5$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $5cd34eeeac41a6e5$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $5cd34eeeac41a6e5$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $5cd34eeeac41a6e5$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$5cd34eeeac41a6e5$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$5cd34eeeac41a6e5$var$_utf8len[254] = $5cd34eeeac41a6e5$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $5cd34eeeac41a6e5$var$string2buf = (str)=>{
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $5cd34eeeac41a6e5$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $5cd34eeeac41a6e5$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = "";
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $5cd34eeeac41a6e5$var$buf2string = (buf, max)=>{
    let i, out;
    const len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $5cd34eeeac41a6e5$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $5cd34eeeac41a6e5$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $5cd34eeeac41a6e5$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $5cd34eeeac41a6e5$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $5cd34eeeac41a6e5$var$strings = {
    string2buf: $5cd34eeeac41a6e5$var$string2buf,
    buf2string: $5cd34eeeac41a6e5$var$buf2string,
    utf8border: $5cd34eeeac41a6e5$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $5cd34eeeac41a6e5$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $5cd34eeeac41a6e5$var$zstream = $5cd34eeeac41a6e5$var$ZStream;
const $5cd34eeeac41a6e5$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $5cd34eeeac41a6e5$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $5cd34eeeac41a6e5$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $5cd34eeeac41a6e5$var$Z_FULL_FLUSH$1, Z_FINISH: $5cd34eeeac41a6e5$var$Z_FINISH$1, Z_OK: $5cd34eeeac41a6e5$var$Z_OK$1, Z_STREAM_END: $5cd34eeeac41a6e5$var$Z_STREAM_END$1, Z_DEFAULT_COMPRESSION: $5cd34eeeac41a6e5$var$Z_DEFAULT_COMPRESSION$1, Z_DEFAULT_STRATEGY: $5cd34eeeac41a6e5$var$Z_DEFAULT_STRATEGY$1, Z_DEFLATED: $5cd34eeeac41a6e5$var$Z_DEFLATED$1 } = $5cd34eeeac41a6e5$var$constants;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $5cd34eeeac41a6e5$var$Deflate(options) {
    this.options = $5cd34eeeac41a6e5$var$common.assign({
        level: $5cd34eeeac41a6e5$var$Z_DEFAULT_COMPRESSION$1,
        method: $5cd34eeeac41a6e5$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $5cd34eeeac41a6e5$var$Z_DEFAULT_STRATEGY$1
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $5cd34eeeac41a6e5$var$zstream();
    this.strm.avail_out = 0;
    let status = $5cd34eeeac41a6e5$var$deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $5cd34eeeac41a6e5$var$Z_OK$1) throw new Error($5cd34eeeac41a6e5$var$messages[status]);
    if (opt.header) $5cd34eeeac41a6e5$var$deflate_1.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $5cd34eeeac41a6e5$var$strings.string2buf(opt.dictionary);
        else if ($5cd34eeeac41a6e5$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $5cd34eeeac41a6e5$var$deflate_1.deflateSetDictionary(this.strm, dict);
        if (status !== $5cd34eeeac41a6e5$var$Z_OK$1) throw new Error($5cd34eeeac41a6e5$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $5cd34eeeac41a6e5$var$Deflate.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $5cd34eeeac41a6e5$var$Z_FINISH$1 : $5cd34eeeac41a6e5$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $5cd34eeeac41a6e5$var$strings.string2buf(data);
    else if ($5cd34eeeac41a6e5$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $5cd34eeeac41a6e5$var$Z_SYNC_FLUSH || _flush_mode === $5cd34eeeac41a6e5$var$Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $5cd34eeeac41a6e5$var$deflate_1.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $5cd34eeeac41a6e5$var$Z_STREAM_END$1) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $5cd34eeeac41a6e5$var$deflate_1.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $5cd34eeeac41a6e5$var$Z_OK$1;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $5cd34eeeac41a6e5$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $5cd34eeeac41a6e5$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $5cd34eeeac41a6e5$var$Z_OK$1) this.result = $5cd34eeeac41a6e5$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $5cd34eeeac41a6e5$var$deflate$1(input, options) {
    const deflator = new $5cd34eeeac41a6e5$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $5cd34eeeac41a6e5$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $5cd34eeeac41a6e5$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $5cd34eeeac41a6e5$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $5cd34eeeac41a6e5$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $5cd34eeeac41a6e5$var$deflate$1(input, options);
}
var $5cd34eeeac41a6e5$var$Deflate_1 = $5cd34eeeac41a6e5$var$Deflate;
var $5cd34eeeac41a6e5$var$deflate_2$1 = $5cd34eeeac41a6e5$var$deflate$1;
var $5cd34eeeac41a6e5$var$deflateRaw_1 = $5cd34eeeac41a6e5$var$deflateRaw;
var $5cd34eeeac41a6e5$var$gzip_1 = $5cd34eeeac41a6e5$var$gzip;
var $5cd34eeeac41a6e5$var$constants$1 = $5cd34eeeac41a6e5$var$constants;
var $5cd34eeeac41a6e5$var$deflate_1$1 = {
    Deflate: $5cd34eeeac41a6e5$var$Deflate_1,
    deflate: $5cd34eeeac41a6e5$var$deflate_2$1,
    deflateRaw: $5cd34eeeac41a6e5$var$deflateRaw_1,
    gzip: $5cd34eeeac41a6e5$var$gzip_1,
    constants: $5cd34eeeac41a6e5$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $5cd34eeeac41a6e5$var$BAD = 30; /* got a data error -- remain here until reset */ 
const $5cd34eeeac41a6e5$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $5cd34eeeac41a6e5$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $5cd34eeeac41a6e5$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $5cd34eeeac41a6e5$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $5cd34eeeac41a6e5$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $5cd34eeeac41a6e5$var$TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $5cd34eeeac41a6e5$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $5cd34eeeac41a6e5$var$MAXBITS = 15;
const $5cd34eeeac41a6e5$var$ENOUGH_LENS = 852;
const $5cd34eeeac41a6e5$var$ENOUGH_DISTS = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $5cd34eeeac41a6e5$var$CODES = 0;
const $5cd34eeeac41a6e5$var$LENS = 1;
const $5cd34eeeac41a6e5$var$DISTS = 2;
const $5cd34eeeac41a6e5$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $5cd34eeeac41a6e5$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $5cd34eeeac41a6e5$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $5cd34eeeac41a6e5$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $5cd34eeeac41a6e5$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    let base_index = 0;
    //  let shoextra;    /* extra bits table to use */
    let end; /* use base and extra for symbol > end */ 
    const count = new Uint16Array($5cd34eeeac41a6e5$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($5cd34eeeac41a6e5$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let extra_index = 0;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $5cd34eeeac41a6e5$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $5cd34eeeac41a6e5$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $5cd34eeeac41a6e5$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $5cd34eeeac41a6e5$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $5cd34eeeac41a6e5$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $5cd34eeeac41a6e5$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $5cd34eeeac41a6e5$var$LENS) {
        base = $5cd34eeeac41a6e5$var$lbase;
        base_index -= 257;
        extra = $5cd34eeeac41a6e5$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $5cd34eeeac41a6e5$var$dbase;
        extra = $5cd34eeeac41a6e5$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $5cd34eeeac41a6e5$var$LENS && used > $5cd34eeeac41a6e5$var$ENOUGH_LENS || type === $5cd34eeeac41a6e5$var$DISTS && used > $5cd34eeeac41a6e5$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $5cd34eeeac41a6e5$var$LENS && used > $5cd34eeeac41a6e5$var$ENOUGH_LENS || type === $5cd34eeeac41a6e5$var$DISTS && used > $5cd34eeeac41a6e5$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $5cd34eeeac41a6e5$var$inftrees = $5cd34eeeac41a6e5$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $5cd34eeeac41a6e5$var$CODES$1 = 0;
const $5cd34eeeac41a6e5$var$LENS$1 = 1;
const $5cd34eeeac41a6e5$var$DISTS$1 = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $5cd34eeeac41a6e5$var$Z_FINISH$2, Z_BLOCK: $5cd34eeeac41a6e5$var$Z_BLOCK$1, Z_TREES: $5cd34eeeac41a6e5$var$Z_TREES, Z_OK: $5cd34eeeac41a6e5$var$Z_OK$2, Z_STREAM_END: $5cd34eeeac41a6e5$var$Z_STREAM_END$2, Z_NEED_DICT: $5cd34eeeac41a6e5$var$Z_NEED_DICT, Z_STREAM_ERROR: $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $5cd34eeeac41a6e5$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $5cd34eeeac41a6e5$var$Z_MEM_ERROR, Z_BUF_ERROR: $5cd34eeeac41a6e5$var$Z_BUF_ERROR$1, Z_DEFLATED: $5cd34eeeac41a6e5$var$Z_DEFLATED$2 } = $5cd34eeeac41a6e5$var$constants;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $5cd34eeeac41a6e5$var$HEAD = 1; /* i: waiting for magic header */ 
const $5cd34eeeac41a6e5$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
const $5cd34eeeac41a6e5$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
const $5cd34eeeac41a6e5$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
const $5cd34eeeac41a6e5$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
const $5cd34eeeac41a6e5$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
const $5cd34eeeac41a6e5$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
const $5cd34eeeac41a6e5$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
const $5cd34eeeac41a6e5$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
const $5cd34eeeac41a6e5$var$DICTID = 10; /* i: waiting for dictionary check value */ 
const $5cd34eeeac41a6e5$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
const $5cd34eeeac41a6e5$var$TYPE$1 = 12; /* i: waiting for type bits, including last-flag bit */ 
const $5cd34eeeac41a6e5$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
const $5cd34eeeac41a6e5$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
const $5cd34eeeac41a6e5$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
const $5cd34eeeac41a6e5$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
const $5cd34eeeac41a6e5$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
const $5cd34eeeac41a6e5$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
const $5cd34eeeac41a6e5$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
const $5cd34eeeac41a6e5$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
const $5cd34eeeac41a6e5$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
const $5cd34eeeac41a6e5$var$LENEXT = 22; /* i: waiting for length extra bits */ 
const $5cd34eeeac41a6e5$var$DIST = 23; /* i: waiting for distance code */ 
const $5cd34eeeac41a6e5$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
const $5cd34eeeac41a6e5$var$MATCH = 25; /* o: waiting for output space to copy string */ 
const $5cd34eeeac41a6e5$var$LIT = 26; /* o: waiting for output space to write literal */ 
const $5cd34eeeac41a6e5$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
const $5cd34eeeac41a6e5$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
const $5cd34eeeac41a6e5$var$DONE = 29; /* finished check, done -- remain here until reset */ 
const $5cd34eeeac41a6e5$var$BAD$1 = 30; /* got a data error -- remain here until reset */ 
const $5cd34eeeac41a6e5$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
const $5cd34eeeac41a6e5$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $5cd34eeeac41a6e5$var$ENOUGH_LENS$1 = 852;
const $5cd34eeeac41a6e5$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $5cd34eeeac41a6e5$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $5cd34eeeac41a6e5$var$DEF_WBITS = $5cd34eeeac41a6e5$var$MAX_WBITS$1;
const $5cd34eeeac41a6e5$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $5cd34eeeac41a6e5$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $5cd34eeeac41a6e5$var$inflateResetKeep = (strm)=>{
    if (!strm || !strm.state) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $5cd34eeeac41a6e5$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($5cd34eeeac41a6e5$var$ENOUGH_LENS$1);
    state.distcode = state.distdyn = new Int32Array($5cd34eeeac41a6e5$var$ENOUGH_DISTS$1);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $5cd34eeeac41a6e5$var$Z_OK$2;
};
const $5cd34eeeac41a6e5$var$inflateReset = (strm)=>{
    if (!strm || !strm.state) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $5cd34eeeac41a6e5$var$inflateResetKeep(strm);
};
const $5cd34eeeac41a6e5$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if (!strm || !strm.state) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $5cd34eeeac41a6e5$var$inflateReset(strm);
};
const $5cd34eeeac41a6e5$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $5cd34eeeac41a6e5$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    const ret = $5cd34eeeac41a6e5$var$inflateReset2(strm, windowBits);
    if (ret !== $5cd34eeeac41a6e5$var$Z_OK$2) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $5cd34eeeac41a6e5$var$inflateInit = (strm)=>{
    return $5cd34eeeac41a6e5$var$inflateInit2(strm, $5cd34eeeac41a6e5$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $5cd34eeeac41a6e5$var$virgin = true;
let $5cd34eeeac41a6e5$var$lenfix, $5cd34eeeac41a6e5$var$distfix; // We have no pointers in JS, so keep tables separate
const $5cd34eeeac41a6e5$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($5cd34eeeac41a6e5$var$virgin) {
        $5cd34eeeac41a6e5$var$lenfix = new Int32Array(512);
        $5cd34eeeac41a6e5$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $5cd34eeeac41a6e5$var$inftrees($5cd34eeeac41a6e5$var$LENS$1, state.lens, 0, 288, $5cd34eeeac41a6e5$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $5cd34eeeac41a6e5$var$inftrees($5cd34eeeac41a6e5$var$DISTS$1, state.lens, 0, 32, $5cd34eeeac41a6e5$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $5cd34eeeac41a6e5$var$virgin = false;
    }
    state.lencode = $5cd34eeeac41a6e5$var$lenfix;
    state.lenbits = 9;
    state.distcode = $5cd34eeeac41a6e5$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $5cd34eeeac41a6e5$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $5cd34eeeac41a6e5$var$inflate = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $5cd34eeeac41a6e5$var$TYPE$1) state.mode = $5cd34eeeac41a6e5$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $5cd34eeeac41a6e5$var$Z_OK$2;
    inf_leave: for(;;)switch(state.mode){
        case $5cd34eeeac41a6e5$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $5cd34eeeac41a6e5$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5cd34eeeac41a6e5$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $5cd34eeeac41a6e5$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            if ((hold & 0x0f) !== $5cd34eeeac41a6e5$var$Z_DEFLATED$2) {
                strm.msg = "unknown compression method";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $5cd34eeeac41a6e5$var$DICTID : $5cd34eeeac41a6e5$var$TYPE$1;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $5cd34eeeac41a6e5$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $5cd34eeeac41a6e5$var$Z_DEFLATED$2) {
                strm.msg = "unknown compression method";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5cd34eeeac41a6e5$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5cd34eeeac41a6e5$var$TIME;
        /* falls through */ case $5cd34eeeac41a6e5$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5cd34eeeac41a6e5$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5cd34eeeac41a6e5$var$OS;
        /* falls through */ case $5cd34eeeac41a6e5$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5cd34eeeac41a6e5$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5cd34eeeac41a6e5$var$EXLEN;
        /* falls through */ case $5cd34eeeac41a6e5$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5cd34eeeac41a6e5$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $5cd34eeeac41a6e5$var$EXTRA;
        /* falls through */ case $5cd34eeeac41a6e5$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5cd34eeeac41a6e5$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $5cd34eeeac41a6e5$var$NAME;
        /* falls through */ case $5cd34eeeac41a6e5$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5cd34eeeac41a6e5$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $5cd34eeeac41a6e5$var$COMMENT;
        /* falls through */ case $5cd34eeeac41a6e5$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5cd34eeeac41a6e5$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $5cd34eeeac41a6e5$var$HCRC;
        /* falls through */ case $5cd34eeeac41a6e5$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $5cd34eeeac41a6e5$var$TYPE$1;
            break;
        case $5cd34eeeac41a6e5$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $5cd34eeeac41a6e5$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5cd34eeeac41a6e5$var$DICT;
        /* falls through */ case $5cd34eeeac41a6e5$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $5cd34eeeac41a6e5$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $5cd34eeeac41a6e5$var$TYPE$1;
        /* falls through */ case $5cd34eeeac41a6e5$var$TYPE$1:
            if (flush === $5cd34eeeac41a6e5$var$Z_BLOCK$1 || flush === $5cd34eeeac41a6e5$var$Z_TREES) break inf_leave;
        /* falls through */ case $5cd34eeeac41a6e5$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $5cd34eeeac41a6e5$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $5cd34eeeac41a6e5$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $5cd34eeeac41a6e5$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $5cd34eeeac41a6e5$var$LEN_; /* decode codes */ 
                    if (flush === $5cd34eeeac41a6e5$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $5cd34eeeac41a6e5$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $5cd34eeeac41a6e5$var$BAD$1;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $5cd34eeeac41a6e5$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5cd34eeeac41a6e5$var$COPY_;
            if (flush === $5cd34eeeac41a6e5$var$Z_TREES) break inf_leave;
        /* falls through */ case $5cd34eeeac41a6e5$var$COPY_:
            state.mode = $5cd34eeeac41a6e5$var$COPY;
        /* falls through */ case $5cd34eeeac41a6e5$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $5cd34eeeac41a6e5$var$TYPE$1;
            break;
        case $5cd34eeeac41a6e5$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $5cd34eeeac41a6e5$var$LENLENS;
        /* falls through */ case $5cd34eeeac41a6e5$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $5cd34eeeac41a6e5$var$inftrees($5cd34eeeac41a6e5$var$CODES$1, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $5cd34eeeac41a6e5$var$CODELENS;
        /* falls through */ case $5cd34eeeac41a6e5$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $5cd34eeeac41a6e5$var$BAD$1) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $5cd34eeeac41a6e5$var$inftrees($5cd34eeeac41a6e5$var$LENS$1, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $5cd34eeeac41a6e5$var$inftrees($5cd34eeeac41a6e5$var$DISTS$1, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $5cd34eeeac41a6e5$var$LEN_;
            if (flush === $5cd34eeeac41a6e5$var$Z_TREES) break inf_leave;
        /* falls through */ case $5cd34eeeac41a6e5$var$LEN_:
            state.mode = $5cd34eeeac41a6e5$var$LEN;
        /* falls through */ case $5cd34eeeac41a6e5$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $5cd34eeeac41a6e5$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $5cd34eeeac41a6e5$var$TYPE$1) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $5cd34eeeac41a6e5$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $5cd34eeeac41a6e5$var$TYPE$1;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $5cd34eeeac41a6e5$var$LENEXT;
        /* falls through */ case $5cd34eeeac41a6e5$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $5cd34eeeac41a6e5$var$DIST;
        /* falls through */ case $5cd34eeeac41a6e5$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $5cd34eeeac41a6e5$var$DISTEXT;
        /* falls through */ case $5cd34eeeac41a6e5$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $5cd34eeeac41a6e5$var$MATCH;
        /* falls through */ case $5cd34eeeac41a6e5$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $5cd34eeeac41a6e5$var$LEN;
            break;
        case $5cd34eeeac41a6e5$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $5cd34eeeac41a6e5$var$LEN;
            break;
        case $5cd34eeeac41a6e5$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5cd34eeeac41a6e5$var$crc32_1(state.check, output, _out, put - _out) : $5cd34eeeac41a6e5$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $5cd34eeeac41a6e5$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $5cd34eeeac41a6e5$var$LENGTH;
        /* falls through */ case $5cd34eeeac41a6e5$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $5cd34eeeac41a6e5$var$BAD$1;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $5cd34eeeac41a6e5$var$DONE;
        /* falls through */ case $5cd34eeeac41a6e5$var$DONE:
            ret = $5cd34eeeac41a6e5$var$Z_STREAM_END$2;
            break inf_leave;
        case $5cd34eeeac41a6e5$var$BAD$1:
            ret = $5cd34eeeac41a6e5$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $5cd34eeeac41a6e5$var$MEM:
            return $5cd34eeeac41a6e5$var$Z_MEM_ERROR;
        case $5cd34eeeac41a6e5$var$SYNC:
        /* falls through */ default:
            return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $5cd34eeeac41a6e5$var$BAD$1 && (state.mode < $5cd34eeeac41a6e5$var$CHECK || flush !== $5cd34eeeac41a6e5$var$Z_FINISH$2)) $5cd34eeeac41a6e5$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5cd34eeeac41a6e5$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $5cd34eeeac41a6e5$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $5cd34eeeac41a6e5$var$TYPE$1 ? 128 : 0) + (state.mode === $5cd34eeeac41a6e5$var$LEN_ || state.mode === $5cd34eeeac41a6e5$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $5cd34eeeac41a6e5$var$Z_FINISH$2) && ret === $5cd34eeeac41a6e5$var$Z_OK$2) ret = $5cd34eeeac41a6e5$var$Z_BUF_ERROR$1;
    return ret;
};
const $5cd34eeeac41a6e5$var$inflateEnd = (strm)=>{
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $5cd34eeeac41a6e5$var$Z_OK$2;
};
const $5cd34eeeac41a6e5$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if (!strm || !strm.state) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $5cd34eeeac41a6e5$var$Z_OK$2;
};
const $5cd34eeeac41a6e5$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $5cd34eeeac41a6e5$var$DICT) return $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $5cd34eeeac41a6e5$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $5cd34eeeac41a6e5$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $5cd34eeeac41a6e5$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $5cd34eeeac41a6e5$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $5cd34eeeac41a6e5$var$MEM;
        return $5cd34eeeac41a6e5$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $5cd34eeeac41a6e5$var$Z_OK$2;
};
var $5cd34eeeac41a6e5$var$inflateReset_1 = $5cd34eeeac41a6e5$var$inflateReset;
var $5cd34eeeac41a6e5$var$inflateReset2_1 = $5cd34eeeac41a6e5$var$inflateReset2;
var $5cd34eeeac41a6e5$var$inflateResetKeep_1 = $5cd34eeeac41a6e5$var$inflateResetKeep;
var $5cd34eeeac41a6e5$var$inflateInit_1 = $5cd34eeeac41a6e5$var$inflateInit;
var $5cd34eeeac41a6e5$var$inflateInit2_1 = $5cd34eeeac41a6e5$var$inflateInit2;
var $5cd34eeeac41a6e5$var$inflate_2 = $5cd34eeeac41a6e5$var$inflate;
var $5cd34eeeac41a6e5$var$inflateEnd_1 = $5cd34eeeac41a6e5$var$inflateEnd;
var $5cd34eeeac41a6e5$var$inflateGetHeader_1 = $5cd34eeeac41a6e5$var$inflateGetHeader;
var $5cd34eeeac41a6e5$var$inflateSetDictionary_1 = $5cd34eeeac41a6e5$var$inflateSetDictionary;
var $5cd34eeeac41a6e5$var$inflateInfo = "pako inflate (from Nodeca project)";
/* Not implemented
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
*/ var $5cd34eeeac41a6e5$var$inflate_1 = {
    inflateReset: $5cd34eeeac41a6e5$var$inflateReset_1,
    inflateReset2: $5cd34eeeac41a6e5$var$inflateReset2_1,
    inflateResetKeep: $5cd34eeeac41a6e5$var$inflateResetKeep_1,
    inflateInit: $5cd34eeeac41a6e5$var$inflateInit_1,
    inflateInit2: $5cd34eeeac41a6e5$var$inflateInit2_1,
    inflate: $5cd34eeeac41a6e5$var$inflate_2,
    inflateEnd: $5cd34eeeac41a6e5$var$inflateEnd_1,
    inflateGetHeader: $5cd34eeeac41a6e5$var$inflateGetHeader_1,
    inflateSetDictionary: $5cd34eeeac41a6e5$var$inflateSetDictionary_1,
    inflateInfo: $5cd34eeeac41a6e5$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $5cd34eeeac41a6e5$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $5cd34eeeac41a6e5$var$gzheader = $5cd34eeeac41a6e5$var$GZheader;
const $5cd34eeeac41a6e5$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $5cd34eeeac41a6e5$var$Z_NO_FLUSH$2, Z_FINISH: $5cd34eeeac41a6e5$var$Z_FINISH$3, Z_OK: $5cd34eeeac41a6e5$var$Z_OK$3, Z_STREAM_END: $5cd34eeeac41a6e5$var$Z_STREAM_END$3, Z_NEED_DICT: $5cd34eeeac41a6e5$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $5cd34eeeac41a6e5$var$Z_DATA_ERROR$2, Z_MEM_ERROR: $5cd34eeeac41a6e5$var$Z_MEM_ERROR$1 } = $5cd34eeeac41a6e5$var$constants;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $5cd34eeeac41a6e5$var$Inflate(options) {
    this.options = $5cd34eeeac41a6e5$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $5cd34eeeac41a6e5$var$zstream();
    this.strm.avail_out = 0;
    let status = $5cd34eeeac41a6e5$var$inflate_1.inflateInit2(this.strm, opt.windowBits);
    if (status !== $5cd34eeeac41a6e5$var$Z_OK$3) throw new Error($5cd34eeeac41a6e5$var$messages[status]);
    this.header = new $5cd34eeeac41a6e5$var$gzheader();
    $5cd34eeeac41a6e5$var$inflate_1.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $5cd34eeeac41a6e5$var$strings.string2buf(opt.dictionary);
        else if ($5cd34eeeac41a6e5$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $5cd34eeeac41a6e5$var$inflate_1.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $5cd34eeeac41a6e5$var$Z_OK$3) throw new Error($5cd34eeeac41a6e5$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $5cd34eeeac41a6e5$var$Inflate.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $5cd34eeeac41a6e5$var$Z_FINISH$3 : $5cd34eeeac41a6e5$var$Z_NO_FLUSH$2;
    // Convert data if needed
    if ($5cd34eeeac41a6e5$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $5cd34eeeac41a6e5$var$inflate_1.inflate(strm, _flush_mode);
        if (status === $5cd34eeeac41a6e5$var$Z_NEED_DICT$1 && dictionary) {
            status = $5cd34eeeac41a6e5$var$inflate_1.inflateSetDictionary(strm, dictionary);
            if (status === $5cd34eeeac41a6e5$var$Z_OK$3) status = $5cd34eeeac41a6e5$var$inflate_1.inflate(strm, _flush_mode);
            else if (status === $5cd34eeeac41a6e5$var$Z_DATA_ERROR$2) // Replace code with more verbose
            status = $5cd34eeeac41a6e5$var$Z_NEED_DICT$1;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $5cd34eeeac41a6e5$var$Z_STREAM_END$3 && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $5cd34eeeac41a6e5$var$inflate_1.inflateReset(strm);
            status = $5cd34eeeac41a6e5$var$inflate_1.inflate(strm, _flush_mode);
        }
        switch(status){
            case $5cd34eeeac41a6e5$var$Z_STREAM_ERROR$2:
            case $5cd34eeeac41a6e5$var$Z_DATA_ERROR$2:
            case $5cd34eeeac41a6e5$var$Z_NEED_DICT$1:
            case $5cd34eeeac41a6e5$var$Z_MEM_ERROR$1:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $5cd34eeeac41a6e5$var$Z_STREAM_END$3) {
                if (this.options.to === "string") {
                    let next_out_utf8 = $5cd34eeeac41a6e5$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $5cd34eeeac41a6e5$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $5cd34eeeac41a6e5$var$Z_OK$3 && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $5cd34eeeac41a6e5$var$Z_STREAM_END$3) {
            status = $5cd34eeeac41a6e5$var$inflate_1.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $5cd34eeeac41a6e5$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $5cd34eeeac41a6e5$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $5cd34eeeac41a6e5$var$Z_OK$3) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $5cd34eeeac41a6e5$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $5cd34eeeac41a6e5$var$inflate$1(input, options) {
    const inflator = new $5cd34eeeac41a6e5$var$Inflate(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $5cd34eeeac41a6e5$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $5cd34eeeac41a6e5$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $5cd34eeeac41a6e5$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $5cd34eeeac41a6e5$var$Inflate_1 = $5cd34eeeac41a6e5$var$Inflate;
var $5cd34eeeac41a6e5$var$inflate_2$1 = $5cd34eeeac41a6e5$var$inflate$1;
var $5cd34eeeac41a6e5$var$inflateRaw_1 = $5cd34eeeac41a6e5$var$inflateRaw;
var $5cd34eeeac41a6e5$var$ungzip = $5cd34eeeac41a6e5$var$inflate$1;
var $5cd34eeeac41a6e5$var$constants$2 = $5cd34eeeac41a6e5$var$constants;
var $5cd34eeeac41a6e5$var$inflate_1$1 = {
    Inflate: $5cd34eeeac41a6e5$var$Inflate_1,
    inflate: $5cd34eeeac41a6e5$var$inflate_2$1,
    inflateRaw: $5cd34eeeac41a6e5$var$inflateRaw_1,
    ungzip: $5cd34eeeac41a6e5$var$ungzip,
    constants: $5cd34eeeac41a6e5$var$constants$2
};
const { Deflate: $5cd34eeeac41a6e5$var$Deflate$1, deflate: $5cd34eeeac41a6e5$var$deflate$2, deflateRaw: $5cd34eeeac41a6e5$var$deflateRaw$1, gzip: $5cd34eeeac41a6e5$var$gzip$1 } = $5cd34eeeac41a6e5$var$deflate_1$1;
const { Inflate: $5cd34eeeac41a6e5$var$Inflate$1, inflate: $5cd34eeeac41a6e5$var$inflate$2, inflateRaw: $5cd34eeeac41a6e5$var$inflateRaw$1, ungzip: $5cd34eeeac41a6e5$var$ungzip$1 } = $5cd34eeeac41a6e5$var$inflate_1$1;
var $5cd34eeeac41a6e5$export$ae157b6234afe138 = $5cd34eeeac41a6e5$var$Deflate$1;
var $5cd34eeeac41a6e5$export$2316623ecd1285ab = $5cd34eeeac41a6e5$var$deflate$2;
var $5cd34eeeac41a6e5$export$e95d6a8f69fb340a = $5cd34eeeac41a6e5$var$deflateRaw$1;
var $5cd34eeeac41a6e5$export$69f0ea7cf3a331a8 = $5cd34eeeac41a6e5$var$gzip$1;
var $5cd34eeeac41a6e5$export$d1de70a877d6e43c = $5cd34eeeac41a6e5$var$Inflate$1;
var $5cd34eeeac41a6e5$export$cae1ce83fe4a1782 = $5cd34eeeac41a6e5$var$inflate$2;
var $5cd34eeeac41a6e5$export$d0f0aa2d05c905c5 = $5cd34eeeac41a6e5$var$inflateRaw$1;
var $5cd34eeeac41a6e5$export$95adf9d270383091 = $5cd34eeeac41a6e5$var$ungzip$1;
var $5cd34eeeac41a6e5$export$1a988e7317c65621 = $5cd34eeeac41a6e5$var$constants;
var $5cd34eeeac41a6e5$var$pako = {
    Deflate: $5cd34eeeac41a6e5$export$ae157b6234afe138,
    deflate: $5cd34eeeac41a6e5$export$2316623ecd1285ab,
    deflateRaw: $5cd34eeeac41a6e5$export$e95d6a8f69fb340a,
    gzip: $5cd34eeeac41a6e5$export$69f0ea7cf3a331a8,
    Inflate: $5cd34eeeac41a6e5$export$d1de70a877d6e43c,
    inflate: $5cd34eeeac41a6e5$export$cae1ce83fe4a1782,
    inflateRaw: $5cd34eeeac41a6e5$export$d0f0aa2d05c905c5,
    ungzip: $5cd34eeeac41a6e5$export$95adf9d270383091,
    constants: $5cd34eeeac41a6e5$export$1a988e7317c65621
};
var $5cd34eeeac41a6e5$export$2e2bcd8739ae039 = $5cd34eeeac41a6e5$var$pako;


var $a92a3f667b0d0758$exports = {};
"use strict";
var $5bfeabec85dbebc9$exports = {};
"use strict";
var $5bfeabec85dbebc9$var$slice = Array.prototype.slice;

var $31NQl = parcelRequire("31NQl");
var $5bfeabec85dbebc9$var$origKeys = Object.keys;

var $5bfeabec85dbebc9$var$keysShim = $5bfeabec85dbebc9$var$origKeys ? function keys(o) {
    return $5bfeabec85dbebc9$var$origKeys(o);
} : (parcelRequire("7MuIT"));
var $5bfeabec85dbebc9$var$originalKeys = Object.keys;
$5bfeabec85dbebc9$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($31NQl(object)) return $5bfeabec85dbebc9$var$originalKeys($5bfeabec85dbebc9$var$slice.call(object));
            return $5bfeabec85dbebc9$var$originalKeys(object);
        };
    } else Object.keys = $5bfeabec85dbebc9$var$keysShim;
    return Object.keys || $5bfeabec85dbebc9$var$keysShim;
};
$5bfeabec85dbebc9$exports = $5bfeabec85dbebc9$var$keysShim;



var $j1gF0 = parcelRequire("j1gF0");
var $980f11be4ac6cf03$exports = {};
"use strict";
var $73d48da9cdc0d7fb$exports = {};
"use strict";

var $73d48da9cdc0d7fb$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $73d48da9cdc0d7fb$var$toStr = Object.prototype.toString;
var $73d48da9cdc0d7fb$var$concat = Array.prototype.concat;
var $73d48da9cdc0d7fb$var$origDefineProperty = Object.defineProperty;
var $73d48da9cdc0d7fb$var$isFunction = function(fn) {
    return typeof fn === "function" && $73d48da9cdc0d7fb$var$toStr.call(fn) === "[object Function]";
};
var $73d48da9cdc0d7fb$var$arePropertyDescriptorsSupported = function() {
    var obj = {};
    try {
        $73d48da9cdc0d7fb$var$origDefineProperty(obj, "x", {
            enumerable: false,
            value: obj
        });
        // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)return false;
        return obj.x === obj;
    } catch (e) {
        return false;
    }
};
var $73d48da9cdc0d7fb$var$supportsDescriptors = $73d48da9cdc0d7fb$var$origDefineProperty && $73d48da9cdc0d7fb$var$arePropertyDescriptorsSupported();
var $73d48da9cdc0d7fb$var$defineProperty = function(object, name, value, predicate) {
    if (name in object && (!$73d48da9cdc0d7fb$var$isFunction(predicate) || !predicate())) return;
    if ($73d48da9cdc0d7fb$var$supportsDescriptors) $73d48da9cdc0d7fb$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var $73d48da9cdc0d7fb$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $5bfeabec85dbebc9$exports(map);
    if ($73d48da9cdc0d7fb$var$hasSymbols) props = $73d48da9cdc0d7fb$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$73d48da9cdc0d7fb$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$73d48da9cdc0d7fb$var$defineProperties.supportsDescriptors = !!$73d48da9cdc0d7fb$var$supportsDescriptors;
$73d48da9cdc0d7fb$exports = $73d48da9cdc0d7fb$var$defineProperties;



var $b8j4z = parcelRequire("b8j4z");
var $c3f9f4cfb6577e29$exports = {};
"use strict";
var $c3f9f4cfb6577e29$var$numberIsNaN = function(value) {
    return value !== value;
};
$c3f9f4cfb6577e29$exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($c3f9f4cfb6577e29$var$numberIsNaN(a) && $c3f9f4cfb6577e29$var$numberIsNaN(b)) return true;
    return false;
};


var $d250f69f76e667ae$exports = {};
"use strict";

$d250f69f76e667ae$exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $c3f9f4cfb6577e29$exports;
};


var $2afbd757c133a8eb$exports = {};
"use strict";


$2afbd757c133a8eb$exports = function shimObjectIs() {
    var polyfill = $d250f69f76e667ae$exports();
    $73d48da9cdc0d7fb$exports(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};


var $980f11be4ac6cf03$var$polyfill = $b8j4z($d250f69f76e667ae$exports(), Object);
$73d48da9cdc0d7fb$exports($980f11be4ac6cf03$var$polyfill, {
    getPolyfill: $d250f69f76e667ae$exports,
    implementation: $c3f9f4cfb6577e29$exports,
    shim: $2afbd757c133a8eb$exports
});
$980f11be4ac6cf03$exports = $980f11be4ac6cf03$var$polyfill;


var $dcae452e1a72a3d9$exports = {};
"use strict";

var $dcae452e1a72a3d9$var$hasSymbols = (parcelRequire("3MbC0"))();
var $dcae452e1a72a3d9$var$hasToStringTag = $dcae452e1a72a3d9$var$hasSymbols && typeof Symbol.toStringTag === "symbol";
var $dcae452e1a72a3d9$var$hasOwnProperty;
var $dcae452e1a72a3d9$var$regexExec;
var $dcae452e1a72a3d9$var$isRegexMarker;
var $dcae452e1a72a3d9$var$badStringifier;
if ($dcae452e1a72a3d9$var$hasToStringTag) {
    $dcae452e1a72a3d9$var$hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
    $dcae452e1a72a3d9$var$regexExec = Function.call.bind(RegExp.prototype.exec);
    $dcae452e1a72a3d9$var$isRegexMarker = {};
    var $dcae452e1a72a3d9$var$throwRegexMarker = function() {
        throw $dcae452e1a72a3d9$var$isRegexMarker;
    };
    $dcae452e1a72a3d9$var$badStringifier = {
        toString: $dcae452e1a72a3d9$var$throwRegexMarker,
        valueOf: $dcae452e1a72a3d9$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") $dcae452e1a72a3d9$var$badStringifier[Symbol.toPrimitive] = $dcae452e1a72a3d9$var$throwRegexMarker;
}
var $dcae452e1a72a3d9$var$toStr = Object.prototype.toString;
var $dcae452e1a72a3d9$var$gOPD = Object.getOwnPropertyDescriptor;
var $dcae452e1a72a3d9$var$regexClass = "[object RegExp]";
$dcae452e1a72a3d9$exports = $dcae452e1a72a3d9$var$hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = $dcae452e1a72a3d9$var$gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && $dcae452e1a72a3d9$var$hasOwnProperty(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $dcae452e1a72a3d9$var$regexExec(value, $dcae452e1a72a3d9$var$badStringifier);
    } catch (e) {
        return e === $dcae452e1a72a3d9$var$isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $dcae452e1a72a3d9$var$toStr.call(value) === $dcae452e1a72a3d9$var$regexClass;
};


var $525ee9aa37c8fd97$exports = {};
"use strict";


var $2N8yi = parcelRequire("2N8yi");
var $5a5a3960baddb511$exports = {};
"use strict";
var $5a5a3960baddb511$var$$Object = Object;
var $5a5a3960baddb511$var$$TypeError = TypeError;
$5a5a3960baddb511$exports = function flags() {
    if (this != null && this !== $5a5a3960baddb511$var$$Object(this)) throw new $5a5a3960baddb511$var$$TypeError("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.sticky) result += "y";
    return result;
};


var $c48079b75ccb5983$exports = {};
"use strict";


var $c48079b75ccb5983$require$supportsDescriptors = $73d48da9cdc0d7fb$exports.supportsDescriptors;
var $c48079b75ccb5983$var$$gOPD = Object.getOwnPropertyDescriptor;
var $c48079b75ccb5983$var$$TypeError = TypeError;
$c48079b75ccb5983$exports = function getPolyfill() {
    if (!$c48079b75ccb5983$require$supportsDescriptors) throw new $c48079b75ccb5983$var$$TypeError("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    if (/a/mig.flags === "gim") {
        var descriptor = $c48079b75ccb5983$var$$gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof /a/.dotAll === "boolean") return descriptor.get;
    }
    return $5a5a3960baddb511$exports;
};


var $13ba6b054a95e56d$exports = {};
"use strict";

var $13ba6b054a95e56d$require$supportsDescriptors = $73d48da9cdc0d7fb$exports.supportsDescriptors;

var $13ba6b054a95e56d$var$gOPD = Object.getOwnPropertyDescriptor;
var $13ba6b054a95e56d$var$defineProperty = Object.defineProperty;
var $13ba6b054a95e56d$var$TypeErr = TypeError;
var $13ba6b054a95e56d$var$getProto = Object.getPrototypeOf;
var $13ba6b054a95e56d$var$regex = /a/;
$13ba6b054a95e56d$exports = function shimFlags() {
    if (!$13ba6b054a95e56d$require$supportsDescriptors || !$13ba6b054a95e56d$var$getProto) throw new $13ba6b054a95e56d$var$TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = $c48079b75ccb5983$exports();
    var proto = $13ba6b054a95e56d$var$getProto($13ba6b054a95e56d$var$regex);
    var descriptor = $13ba6b054a95e56d$var$gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) $13ba6b054a95e56d$var$defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};


var $525ee9aa37c8fd97$var$flagsBound = $2N8yi($5a5a3960baddb511$exports);
$73d48da9cdc0d7fb$exports($525ee9aa37c8fd97$var$flagsBound, {
    getPolyfill: $c48079b75ccb5983$exports,
    implementation: $5a5a3960baddb511$exports,
    shim: $13ba6b054a95e56d$exports
});
$525ee9aa37c8fd97$exports = $525ee9aa37c8fd97$var$flagsBound;


var $3c34e99f6a771855$exports = {};
var $3c34e99f6a771855$var$toString = {}.toString;
$3c34e99f6a771855$exports = Array.isArray || function(arr) {
    return $3c34e99f6a771855$var$toString.call(arr) == "[object Array]";
};


var $3ebbedfe4b065edc$exports = {};
"use strict";
var $3ebbedfe4b065edc$var$getDay = Date.prototype.getDay;
var $3ebbedfe4b065edc$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $3ebbedfe4b065edc$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $3ebbedfe4b065edc$var$toStr = Object.prototype.toString;
var $3ebbedfe4b065edc$var$dateClass = "[object Date]";
var $3ebbedfe4b065edc$var$hasToStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
$3ebbedfe4b065edc$exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return $3ebbedfe4b065edc$var$hasToStringTag ? $3ebbedfe4b065edc$var$tryDateObject(value) : $3ebbedfe4b065edc$var$toStr.call(value) === $3ebbedfe4b065edc$var$dateClass;
};


var $702e7c5c40b40607$exports = {};
"use strict";

var $jX9hu = parcelRequire("jX9hu");
var $5c57b97e2ceaa9b1$exports = {};
"use strict";
var $5c57b97e2ceaa9b1$var$numToStr = Number.prototype.toString;
var $5c57b97e2ceaa9b1$var$tryNumberObject = function tryNumberObject(value) {
    try {
        $5c57b97e2ceaa9b1$var$numToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $5c57b97e2ceaa9b1$var$toStr = Object.prototype.toString;
var $5c57b97e2ceaa9b1$var$numClass = "[object Number]";
var $5c57b97e2ceaa9b1$var$hasToStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
$5c57b97e2ceaa9b1$exports = function isNumberObject(value) {
    if (typeof value === "number") return true;
    if (typeof value !== "object") return false;
    return $5c57b97e2ceaa9b1$var$hasToStringTag ? $5c57b97e2ceaa9b1$var$tryNumberObject(value) : $5c57b97e2ceaa9b1$var$toStr.call(value) === $5c57b97e2ceaa9b1$var$numClass;
};


var $40920e35598d7267$exports = {};
"use strict";

var $ghOdW = parcelRequire("ghOdW");
var $40920e35598d7267$var$$boolToStr = $ghOdW("Boolean.prototype.toString");
var $40920e35598d7267$var$$toString = $ghOdW("Object.prototype.toString");
var $40920e35598d7267$var$tryBooleanObject = function booleanBrandCheck(value) {
    try {
        $40920e35598d7267$var$$boolToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $40920e35598d7267$var$boolClass = "[object Boolean]";
var $40920e35598d7267$var$hasToStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
$40920e35598d7267$exports = function isBoolean(value) {
    if (typeof value === "boolean") return true;
    if (value === null || typeof value !== "object") return false;
    return $40920e35598d7267$var$hasToStringTag && Symbol.toStringTag in value ? $40920e35598d7267$var$tryBooleanObject(value) : $40920e35598d7267$var$$toString(value) === $40920e35598d7267$var$boolClass;
};


var $7b43222c328938ef$exports = {};
"use strict";
var $7b43222c328938ef$var$toStr = Object.prototype.toString;

var $7b43222c328938ef$var$hasSymbols = (parcelRequire("3MbC0"))();
if ($7b43222c328938ef$var$hasSymbols) {
    var $7b43222c328938ef$var$symToStr = Symbol.prototype.toString;
    var $7b43222c328938ef$var$symStringRegex = /^Symbol\(.*\)$/;
    var $7b43222c328938ef$var$isSymbolObject = function isRealSymbolObject(value) {
        if (typeof value.valueOf() !== "symbol") return false;
        return $7b43222c328938ef$var$symStringRegex.test($7b43222c328938ef$var$symToStr.call(value));
    };
    $7b43222c328938ef$exports = function isSymbol(value) {
        if (typeof value === "symbol") return true;
        if ($7b43222c328938ef$var$toStr.call(value) !== "[object Symbol]") return false;
        try {
            return $7b43222c328938ef$var$isSymbolObject(value);
        } catch (e) {
            return false;
        }
    };
} else $7b43222c328938ef$exports = function isSymbol(value) {
    // this environment does not support Symbols.
    return false;
};


var $caa61515bd9086f1$exports = {};
"use strict";
if (typeof BigInt === "function") {
    var $caa61515bd9086f1$var$bigIntValueOf = BigInt.prototype.valueOf;
    var $caa61515bd9086f1$var$tryBigInt = function tryBigIntObject(value) {
        try {
            $caa61515bd9086f1$var$bigIntValueOf.call(value);
            return true;
        } catch (e) {}
        return false;
    };
    $caa61515bd9086f1$exports = function isBigInt(value) {
        if (value === null || typeof value === "undefined" || typeof value === "boolean" || typeof value === "string" || typeof value === "number" || typeof value === "symbol" || typeof value === "function") return false;
        if (typeof value === "bigint") return true;
        return $caa61515bd9086f1$var$tryBigInt(value);
    };
} else $caa61515bd9086f1$exports = function isBigInt(value) {
    return false;
};


// eslint-disable-next-line consistent-return
$702e7c5c40b40607$exports = function whichBoxedPrimitive(value) {
    // eslint-disable-next-line eqeqeq
    if (value == null || typeof value !== "object" && typeof value !== "function") return null;
    if ($jX9hu(value)) return "String";
    if ($5c57b97e2ceaa9b1$exports(value)) return "Number";
    if ($40920e35598d7267$exports(value)) return "Boolean";
    if ($7b43222c328938ef$exports(value)) return "Symbol";
    if ($caa61515bd9086f1$exports(value)) return "BigInt";
};



var $e0BBw = parcelRequire("e0BBw");

var $ghOdW = parcelRequire("ghOdW");
var $ac6c564be0ebc4a2$exports = {};
"use strict";

var $85iSE = parcelRequire("85iSE");

var $5BCLe = parcelRequire("5BCLe");
var $a5ed96ae4297b3f3$exports = {};
"use strict";
var $a5ed96ae4297b3f3$var$$WeakMap = typeof WeakMap === "function" && WeakMap.prototype ? WeakMap : null;
var $a5ed96ae4297b3f3$var$$WeakSet = typeof WeakSet === "function" && WeakSet.prototype ? WeakSet : null;
var $a5ed96ae4297b3f3$var$exported;
if (!$a5ed96ae4297b3f3$var$$WeakMap) // eslint-disable-next-line no-unused-vars
$a5ed96ae4297b3f3$var$exported = function isWeakMap(x) {
    // `WeakMap` is not present in this environment.
    return false;
};
var $a5ed96ae4297b3f3$var$$mapHas = $a5ed96ae4297b3f3$var$$WeakMap ? $a5ed96ae4297b3f3$var$$WeakMap.prototype.has : null;
var $a5ed96ae4297b3f3$var$$setHas = $a5ed96ae4297b3f3$var$$WeakSet ? $a5ed96ae4297b3f3$var$$WeakSet.prototype.has : null;
if (!$a5ed96ae4297b3f3$var$exported && !$a5ed96ae4297b3f3$var$$mapHas) // eslint-disable-next-line no-unused-vars
$a5ed96ae4297b3f3$var$exported = function isWeakMap(x) {
    // `WeakMap` does not have a `has` method
    return false;
};
$a5ed96ae4297b3f3$exports = $a5ed96ae4297b3f3$var$exported || function isWeakMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $a5ed96ae4297b3f3$var$$mapHas.call(x, $a5ed96ae4297b3f3$var$$mapHas);
        if ($a5ed96ae4297b3f3$var$$setHas) try {
            $a5ed96ae4297b3f3$var$$setHas.call(x, $a5ed96ae4297b3f3$var$$setHas);
        } catch (e) {
            return true;
        }
        return x instanceof $a5ed96ae4297b3f3$var$$WeakMap; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
};


var $077c17875a97f11f$exports = {};
"use strict";
var $077c17875a97f11f$var$$WeakMap = typeof WeakMap === "function" && WeakMap.prototype ? WeakMap : null;
var $077c17875a97f11f$var$$WeakSet = typeof WeakSet === "function" && WeakSet.prototype ? WeakSet : null;
var $077c17875a97f11f$var$exported;
if (!$077c17875a97f11f$var$$WeakMap) // eslint-disable-next-line no-unused-vars
$077c17875a97f11f$var$exported = function isWeakSet(x) {
    // `WeakSet` is not present in this environment.
    return false;
};
var $077c17875a97f11f$var$$mapHas = $077c17875a97f11f$var$$WeakMap ? $077c17875a97f11f$var$$WeakMap.prototype.has : null;
var $077c17875a97f11f$var$$setHas = $077c17875a97f11f$var$$WeakSet ? $077c17875a97f11f$var$$WeakSet.prototype.has : null;
if (!$077c17875a97f11f$var$exported && !$077c17875a97f11f$var$$setHas) // eslint-disable-next-line no-unused-vars
$077c17875a97f11f$exports = function isWeakSet(x) {
    // `WeakSet` does not have a `has` method
    return false;
};
$077c17875a97f11f$exports = $077c17875a97f11f$var$exported || function isWeakSet(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $077c17875a97f11f$var$$setHas.call(x, $077c17875a97f11f$var$$setHas);
        if ($077c17875a97f11f$var$$mapHas) try {
            $077c17875a97f11f$var$$mapHas.call(x, $077c17875a97f11f$var$$mapHas);
        } catch (e) {
            return true;
        }
        return x instanceof $077c17875a97f11f$var$$WeakSet; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
};


$ac6c564be0ebc4a2$exports = function whichCollection(value) {
    if (value && typeof value === "object") {
        if ($85iSE(value)) return "Map";
        if ($5BCLe(value)) return "Set";
        if ($a5ed96ae4297b3f3$exports(value)) return "WeakMap";
        if ($077c17875a97f11f$exports(value)) return "WeakSet";
    }
    return false;
};


var $fe231cb32462bd68$exports = {};

var $iQDV7 = parcelRequire("iQDV7");
"use strict";

var $j1gF0 = parcelRequire("j1gF0");








if ((parcelRequire("3MbC0"))() || (parcelRequire("9WrZJ"))()) {
    var $fe231cb32462bd68$var$$iterator = Symbol.iterator;
    // Symbol is available natively or shammed
    // natively:
    //  - Chrome >= 38
    //  - Edge 12-14?, Edge >= 15 for sure
    //  - FF >= 36
    //  - Safari >= 9
    //  - node >= 0.12
    $fe231cb32462bd68$exports = function getIterator(iterable) {
        // alternatively, `iterable[$iterator]?.()`
        if (iterable != null && typeof iterable[$fe231cb32462bd68$var$$iterator] !== "undefined") return iterable[$fe231cb32462bd68$var$$iterator]();
        if ($j1gF0(iterable)) // arguments objects lack Symbol.iterator
        // - node 0.12
        return Array.prototype[$fe231cb32462bd68$var$$iterator].call(iterable);
    };
} else {
    // Symbol is not available, native or shammed
    var $fe231cb32462bd68$var$isArray = (parcelRequire("jdvcJ"));
    var $fe231cb32462bd68$var$isString = (parcelRequire("jX9hu"));
    var $fe231cb32462bd68$var$GetIntrinsic = (parcelRequire("e0BBw"));
    var $fe231cb32462bd68$var$$Map = $fe231cb32462bd68$var$GetIntrinsic("%Map%", true);
    var $fe231cb32462bd68$var$$Set = $fe231cb32462bd68$var$GetIntrinsic("%Set%", true);
    var $fe231cb32462bd68$var$callBound = (parcelRequire("ghOdW"));
    var $fe231cb32462bd68$var$$arrayPush = $fe231cb32462bd68$var$callBound("Array.prototype.push");
    var $fe231cb32462bd68$var$$charCodeAt = $fe231cb32462bd68$var$callBound("String.prototype.charCodeAt");
    var $fe231cb32462bd68$var$$stringSlice = $fe231cb32462bd68$var$callBound("String.prototype.slice");
    var $fe231cb32462bd68$var$advanceStringIndex = function advanceStringIndex(S, index) {
        var length = S.length;
        if (index + 1 >= length) return index + 1;
        var first = $fe231cb32462bd68$var$$charCodeAt(S, index);
        if (first < 0xD800 || first > 0xDBFF) return index + 1;
        var second = $fe231cb32462bd68$var$$charCodeAt(S, index + 1);
        if (second < 0xDC00 || second > 0xDFFF) return index + 1;
        return index + 2;
    };
    var $fe231cb32462bd68$var$getArrayIterator = function getArrayIterator(arraylike) {
        var i = 0;
        return {
            next: function next() {
                var done = i >= arraylike.length;
                var value;
                if (!done) {
                    value = arraylike[i];
                    i += 1;
                }
                return {
                    done: done,
                    value: value
                };
            }
        };
    };
    var $fe231cb32462bd68$var$getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
        if ($fe231cb32462bd68$var$isArray(iterable) || $j1gF0(iterable)) return $fe231cb32462bd68$var$getArrayIterator(iterable);
        if ($fe231cb32462bd68$var$isString(iterable)) {
            var i = 0;
            return {
                next: function next() {
                    var nextIndex = $fe231cb32462bd68$var$advanceStringIndex(iterable, i);
                    var value = $fe231cb32462bd68$var$$stringSlice(iterable, i, nextIndex);
                    i = nextIndex;
                    return {
                        done: nextIndex > iterable.length,
                        value: value
                    };
                }
            };
        }
        // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
        if (noPrimordialCollections && typeof iterable["_es6-shim iterator_"] !== "undefined") return iterable["_es6-shim iterator_"]();
    };
    if (!$fe231cb32462bd68$var$$Map && !$fe231cb32462bd68$var$$Set) // the only language iterables are Array, String, arguments
    // - Safari <= 6.0
    // - Chrome < 38
    // - node < 0.12
    // - FF < 13
    // - IE < 11
    // - Edge < 11
    $fe231cb32462bd68$exports = function getIterator(iterable) {
        if (iterable != null) return $fe231cb32462bd68$var$getNonCollectionIterator(iterable, true);
    };
    else {
        // either Map or Set are available, but Symbol is not
        // - es6-shim on an ES5 browser
        // - Safari 6.2 (maybe 6.1?)
        // - FF v[13, 36)
        // - IE 11
        // - Edge 11
        // - Safari v[6, 9)
        var $fe231cb32462bd68$var$isMap = (parcelRequire("85iSE"));
        var $fe231cb32462bd68$var$isSet = (parcelRequire("5BCLe"));
        // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
        var $fe231cb32462bd68$var$$mapForEach = $fe231cb32462bd68$var$callBound("Map.prototype.forEach", true);
        var $fe231cb32462bd68$var$$setForEach = $fe231cb32462bd68$var$callBound("Set.prototype.forEach", true);
        if (typeof $iQDV7 === "undefined" || !$iQDV7.versions || !$iQDV7.versions.node) {
            // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
            // returns a value, or throws a StopIteration object. These browsers
            // do not have any other mechanism for iteration.
            var $fe231cb32462bd68$var$$mapIterator = $fe231cb32462bd68$var$callBound("Map.prototype.iterator", true);
            var $fe231cb32462bd68$var$$setIterator = $fe231cb32462bd68$var$callBound("Set.prototype.iterator", true);
            var $fe231cb32462bd68$var$getStopIterationIterator = function(iterator) {
                var done = false;
                return {
                    next: function next() {
                        try {
                            return {
                                done: done,
                                value: done ? undefined : iterator.next()
                            };
                        } catch (e) {
                            done = true;
                            return {
                                done: true,
                                value: undefined
                            };
                        }
                    }
                };
            };
        }
        // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
        // this returns a proper iterator object, so we should use it instead of forEach.
        // newer es6-shim versions use a string "_es6-shim iterator_" property.
        var $fe231cb32462bd68$var$$mapAtAtIterator = $fe231cb32462bd68$var$callBound("Map.prototype.@@iterator", true) || $fe231cb32462bd68$var$callBound("Map.prototype._es6-shim iterator_", true);
        var $fe231cb32462bd68$var$$setAtAtIterator = $fe231cb32462bd68$var$callBound("Set.prototype.@@iterator", true) || $fe231cb32462bd68$var$callBound("Set.prototype._es6-shim iterator_", true);
        var $fe231cb32462bd68$var$getCollectionIterator = function getCollectionIterator(iterable) {
            if ($fe231cb32462bd68$var$isMap(iterable)) {
                if ($fe231cb32462bd68$var$$mapIterator) return $fe231cb32462bd68$var$getStopIterationIterator($fe231cb32462bd68$var$$mapIterator(iterable));
                if ($fe231cb32462bd68$var$$mapAtAtIterator) return $fe231cb32462bd68$var$$mapAtAtIterator(iterable);
                if ($fe231cb32462bd68$var$$mapForEach) {
                    var entries = [];
                    $fe231cb32462bd68$var$$mapForEach(iterable, function(v, k) {
                        $fe231cb32462bd68$var$$arrayPush(entries, [
                            k,
                            v
                        ]);
                    });
                    return $fe231cb32462bd68$var$getArrayIterator(entries);
                }
            }
            if ($fe231cb32462bd68$var$isSet(iterable)) {
                if ($fe231cb32462bd68$var$$setIterator) return $fe231cb32462bd68$var$getStopIterationIterator($fe231cb32462bd68$var$$setIterator(iterable));
                if ($fe231cb32462bd68$var$$setAtAtIterator) return $fe231cb32462bd68$var$$setAtAtIterator(iterable);
                if ($fe231cb32462bd68$var$$setForEach) {
                    var values = [];
                    $fe231cb32462bd68$var$$setForEach(iterable, function(v) {
                        $fe231cb32462bd68$var$$arrayPush(values, v);
                    });
                    return $fe231cb32462bd68$var$getArrayIterator(values);
                }
            }
        };
        $fe231cb32462bd68$exports = function getIterator(iterable) {
            return $fe231cb32462bd68$var$getCollectionIterator(iterable) || $fe231cb32462bd68$var$getNonCollectionIterator(iterable);
        };
    }
}


var $c026c6fe03bd6c23$exports = {};
"use strict";
var $c45ca12aa3fcdbcc$exports = {};
"use strict";
/* globals
	AggregateError,
	Atomics,
	FinalizationRegistry,
	SharedArrayBuffer,
	WeakRef,
*/ var $c45ca12aa3fcdbcc$var$undefined1;
var $c45ca12aa3fcdbcc$var$$SyntaxError = SyntaxError;
var $c45ca12aa3fcdbcc$var$$Function = Function;
var $c45ca12aa3fcdbcc$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $c45ca12aa3fcdbcc$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        // eslint-disable-next-line no-new-func
        return Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $c45ca12aa3fcdbcc$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($c45ca12aa3fcdbcc$var$$gOPD) try {
    $c45ca12aa3fcdbcc$var$$gOPD({}, "");
} catch (e) {
    $c45ca12aa3fcdbcc$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $c45ca12aa3fcdbcc$var$throwTypeError = function() {
    throw new $c45ca12aa3fcdbcc$var$$TypeError();
};
var $c45ca12aa3fcdbcc$var$ThrowTypeError = $c45ca12aa3fcdbcc$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c45ca12aa3fcdbcc$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $c45ca12aa3fcdbcc$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $c45ca12aa3fcdbcc$var$throwTypeError;
        }
    }
}() : $c45ca12aa3fcdbcc$var$throwTypeError;

var $c45ca12aa3fcdbcc$var$hasSymbols = (parcelRequire("3MbC0"))();
var $c45ca12aa3fcdbcc$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $c45ca12aa3fcdbcc$var$asyncGenFunction = $c45ca12aa3fcdbcc$var$getEvalledConstructor("async function* () {}");
var $c45ca12aa3fcdbcc$var$asyncGenFunctionPrototype = $c45ca12aa3fcdbcc$var$asyncGenFunction ? $c45ca12aa3fcdbcc$var$asyncGenFunction.prototype : undefined;
var $c45ca12aa3fcdbcc$var$asyncGenPrototype = $c45ca12aa3fcdbcc$var$asyncGenFunctionPrototype ? $c45ca12aa3fcdbcc$var$asyncGenFunctionPrototype.prototype : undefined;
var $c45ca12aa3fcdbcc$var$TypedArray = typeof Uint8Array === "undefined" ? undefined : $c45ca12aa3fcdbcc$var$getProto(Uint8Array);
var $c45ca12aa3fcdbcc$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $c45ca12aa3fcdbcc$var$hasSymbols ? $c45ca12aa3fcdbcc$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $c45ca12aa3fcdbcc$var$getEvalledConstructor("async function () {}"),
    "%AsyncGenerator%": $c45ca12aa3fcdbcc$var$asyncGenFunctionPrototype,
    "%AsyncGeneratorFunction%": $c45ca12aa3fcdbcc$var$asyncGenFunction,
    "%AsyncIteratorPrototype%": $c45ca12aa3fcdbcc$var$asyncGenPrototype ? $c45ca12aa3fcdbcc$var$getProto($c45ca12aa3fcdbcc$var$asyncGenPrototype) : undefined,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $c45ca12aa3fcdbcc$var$$Function,
    "%GeneratorFunction%": $c45ca12aa3fcdbcc$var$getEvalledConstructor("function* () {}"),
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $c45ca12aa3fcdbcc$var$hasSymbols ? $c45ca12aa3fcdbcc$var$getProto($c45ca12aa3fcdbcc$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$c45ca12aa3fcdbcc$var$hasSymbols ? undefined : $c45ca12aa3fcdbcc$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$c45ca12aa3fcdbcc$var$hasSymbols ? undefined : $c45ca12aa3fcdbcc$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $c45ca12aa3fcdbcc$var$hasSymbols ? $c45ca12aa3fcdbcc$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $c45ca12aa3fcdbcc$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $c45ca12aa3fcdbcc$var$$SyntaxError,
    "%ThrowTypeError%": $c45ca12aa3fcdbcc$var$ThrowTypeError,
    "%TypedArray%": $c45ca12aa3fcdbcc$var$TypedArray,
    "%TypeError%": $c45ca12aa3fcdbcc$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
var $c45ca12aa3fcdbcc$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $dcAqh = parcelRequire("dcAqh");

var $aaOJF = parcelRequire("aaOJF");
var $c45ca12aa3fcdbcc$var$$concat = $dcAqh.call(Function.call, Array.prototype.concat);
var $c45ca12aa3fcdbcc$var$$spliceApply = $dcAqh.call(Function.apply, Array.prototype.splice);
var $c45ca12aa3fcdbcc$var$$replace = $dcAqh.call(Function.call, String.prototype.replace);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c45ca12aa3fcdbcc$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c45ca12aa3fcdbcc$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c45ca12aa3fcdbcc$var$stringToPath = function stringToPath(string) {
    var result = [];
    $c45ca12aa3fcdbcc$var$$replace(string, $c45ca12aa3fcdbcc$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c45ca12aa3fcdbcc$var$$replace(subString, $c45ca12aa3fcdbcc$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $c45ca12aa3fcdbcc$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($aaOJF($c45ca12aa3fcdbcc$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c45ca12aa3fcdbcc$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($aaOJF($c45ca12aa3fcdbcc$var$INTRINSICS, intrinsicName)) {
        var value = $c45ca12aa3fcdbcc$var$INTRINSICS[intrinsicName];
        if (typeof value === "undefined" && !allowMissing) throw new $c45ca12aa3fcdbcc$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $c45ca12aa3fcdbcc$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
$c45ca12aa3fcdbcc$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $c45ca12aa3fcdbcc$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $c45ca12aa3fcdbcc$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $c45ca12aa3fcdbcc$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $c45ca12aa3fcdbcc$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c45ca12aa3fcdbcc$var$$spliceApply(parts, $c45ca12aa3fcdbcc$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($aaOJF($c45ca12aa3fcdbcc$var$INTRINSICS, intrinsicRealName)) value = $c45ca12aa3fcdbcc$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if ($c45ca12aa3fcdbcc$var$$gOPD && i + 1 >= parts.length) {
                var desc = $c45ca12aa3fcdbcc$var$$gOPD(value, part);
                isOwn = !!desc;
                if (!allowMissing && !(part in value)) throw new $c45ca12aa3fcdbcc$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $aaOJF(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c45ca12aa3fcdbcc$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $420de44dd94ec21d$exports = {};
"use strict";

var $9d5eebcea12ce5bd$exports = {};
"use strict";

var $dcAqh = parcelRequire("dcAqh");

var $9d5eebcea12ce5bd$var$$apply = $c45ca12aa3fcdbcc$exports("%Function.prototype.apply%");
var $9d5eebcea12ce5bd$var$$call = $c45ca12aa3fcdbcc$exports("%Function.prototype.call%");
var $9d5eebcea12ce5bd$var$$reflectApply = $c45ca12aa3fcdbcc$exports("%Reflect.apply%", true) || $dcAqh.call($9d5eebcea12ce5bd$var$$call, $9d5eebcea12ce5bd$var$$apply);
var $9d5eebcea12ce5bd$var$$defineProperty = $c45ca12aa3fcdbcc$exports("%Object.defineProperty%", true);
if ($9d5eebcea12ce5bd$var$$defineProperty) try {
    $9d5eebcea12ce5bd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9d5eebcea12ce5bd$var$$defineProperty = null;
}
$9d5eebcea12ce5bd$exports = function callBind() {
    return $9d5eebcea12ce5bd$var$$reflectApply($dcAqh, $9d5eebcea12ce5bd$var$$call, arguments);
};
var $9d5eebcea12ce5bd$var$applyBind = function applyBind() {
    return $9d5eebcea12ce5bd$var$$reflectApply($dcAqh, $9d5eebcea12ce5bd$var$$apply, arguments);
};
if ($9d5eebcea12ce5bd$var$$defineProperty) $9d5eebcea12ce5bd$var$$defineProperty($9d5eebcea12ce5bd$exports, "apply", {
    value: $9d5eebcea12ce5bd$var$applyBind
});
else $9d5eebcea12ce5bd$exports.apply = $9d5eebcea12ce5bd$var$applyBind;


var $420de44dd94ec21d$var$$indexOf = $9d5eebcea12ce5bd$exports($c45ca12aa3fcdbcc$exports("String.prototype.indexOf"));
$420de44dd94ec21d$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $c45ca12aa3fcdbcc$exports(name, !!allowMissing);
    if (typeof intrinsic === "function" && $420de44dd94ec21d$var$$indexOf(name, ".prototype.")) return $9d5eebcea12ce5bd$exports(intrinsic);
    return intrinsic;
};


var $16bb30f43bc4efef$exports = {};
var $16bb30f43bc4efef$var$hasMap = typeof Map === "function" && Map.prototype;
var $16bb30f43bc4efef$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $16bb30f43bc4efef$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $16bb30f43bc4efef$var$mapSize = $16bb30f43bc4efef$var$hasMap && $16bb30f43bc4efef$var$mapSizeDescriptor && typeof $16bb30f43bc4efef$var$mapSizeDescriptor.get === "function" ? $16bb30f43bc4efef$var$mapSizeDescriptor.get : null;
var $16bb30f43bc4efef$var$mapForEach = $16bb30f43bc4efef$var$hasMap && Map.prototype.forEach;
var $16bb30f43bc4efef$var$hasSet = typeof Set === "function" && Set.prototype;
var $16bb30f43bc4efef$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $16bb30f43bc4efef$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $16bb30f43bc4efef$var$setSize = $16bb30f43bc4efef$var$hasSet && $16bb30f43bc4efef$var$setSizeDescriptor && typeof $16bb30f43bc4efef$var$setSizeDescriptor.get === "function" ? $16bb30f43bc4efef$var$setSizeDescriptor.get : null;
var $16bb30f43bc4efef$var$setForEach = $16bb30f43bc4efef$var$hasSet && Set.prototype.forEach;
var $16bb30f43bc4efef$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $16bb30f43bc4efef$var$weakMapHas = $16bb30f43bc4efef$var$hasWeakMap ? WeakMap.prototype.has : null;
var $16bb30f43bc4efef$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $16bb30f43bc4efef$var$weakSetHas = $16bb30f43bc4efef$var$hasWeakSet ? WeakSet.prototype.has : null;
var $16bb30f43bc4efef$var$booleanValueOf = Boolean.prototype.valueOf;
var $16bb30f43bc4efef$var$objectToString = Object.prototype.toString;
var $16bb30f43bc4efef$var$functionToString = Function.prototype.toString;
var $16bb30f43bc4efef$var$match = String.prototype.match;
var $16bb30f43bc4efef$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;

var $7K7Bf = parcelRequire("7K7Bf");
var $16bb30f43bc4efef$require$inspectCustom = $7K7Bf.custom;
var $16bb30f43bc4efef$var$inspectSymbol = $16bb30f43bc4efef$require$inspectCustom && $16bb30f43bc4efef$var$isSymbol($16bb30f43bc4efef$require$inspectCustom) ? $16bb30f43bc4efef$require$inspectCustom : null;
$16bb30f43bc4efef$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($16bb30f43bc4efef$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($16bb30f43bc4efef$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $16bb30f43bc4efef$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean") throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
    if ($16bb30f43bc4efef$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $16bb30f43bc4efef$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        return String(obj);
    }
    if (typeof obj === "bigint") return String(obj) + "n";
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $16bb30f43bc4efef$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $16bb30f43bc4efef$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($16bb30f43bc4efef$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($16bb30f43bc4efef$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function") {
        var name = $16bb30f43bc4efef$var$nameOf(obj);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]";
    }
    if ($16bb30f43bc4efef$var$isSymbol(obj)) {
        var symString = Symbol.prototype.toString.call(obj);
        return typeof obj === "object" ? $16bb30f43bc4efef$var$markBoxed(symString) : symString;
    }
    if ($16bb30f43bc4efef$var$isElement(obj)) {
        var s = "<" + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $16bb30f43bc4efef$var$wrapQuotes($16bb30f43bc4efef$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + String(obj.nodeName).toLowerCase() + ">";
        return s;
    }
    if ($16bb30f43bc4efef$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $16bb30f43bc4efef$var$arrObjKeys(obj, inspect);
        if (indent && !$16bb30f43bc4efef$var$singleLineValues(xs)) return "[" + $16bb30f43bc4efef$var$indentedJoin(xs, indent) + "]";
        return "[ " + xs.join(", ") + " ]";
    }
    if ($16bb30f43bc4efef$var$isError(obj)) {
        var parts = $16bb30f43bc4efef$var$arrObjKeys(obj, inspect);
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + parts.join(", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($16bb30f43bc4efef$var$inspectSymbol && typeof obj[$16bb30f43bc4efef$var$inspectSymbol] === "function") return obj[$16bb30f43bc4efef$var$inspectSymbol]();
        else if (typeof obj.inspect === "function") return obj.inspect();
    }
    if ($16bb30f43bc4efef$var$isMap(obj)) {
        var mapParts = [];
        $16bb30f43bc4efef$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $16bb30f43bc4efef$var$collectionOf("Map", $16bb30f43bc4efef$var$mapSize.call(obj), mapParts, indent);
    }
    if ($16bb30f43bc4efef$var$isSet(obj)) {
        var setParts = [];
        $16bb30f43bc4efef$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $16bb30f43bc4efef$var$collectionOf("Set", $16bb30f43bc4efef$var$setSize.call(obj), setParts, indent);
    }
    if ($16bb30f43bc4efef$var$isWeakMap(obj)) return $16bb30f43bc4efef$var$weakCollectionOf("WeakMap");
    if ($16bb30f43bc4efef$var$isWeakSet(obj)) return $16bb30f43bc4efef$var$weakCollectionOf("WeakSet");
    if ($16bb30f43bc4efef$var$isNumber(obj)) return $16bb30f43bc4efef$var$markBoxed(inspect(Number(obj)));
    if ($16bb30f43bc4efef$var$isBigInt(obj)) return $16bb30f43bc4efef$var$markBoxed(inspect($16bb30f43bc4efef$var$bigIntValueOf.call(obj)));
    if ($16bb30f43bc4efef$var$isBoolean(obj)) return $16bb30f43bc4efef$var$markBoxed($16bb30f43bc4efef$var$booleanValueOf.call(obj));
    if ($16bb30f43bc4efef$var$isString(obj)) return $16bb30f43bc4efef$var$markBoxed(inspect(String(obj)));
    if (!$16bb30f43bc4efef$var$isDate(obj) && !$16bb30f43bc4efef$var$isRegExp(obj)) {
        var ys = $16bb30f43bc4efef$var$arrObjKeys(obj, inspect);
        if (ys.length === 0) return "{}";
        if (indent) return "{" + $16bb30f43bc4efef$var$indentedJoin(ys, indent) + "}";
        return "{ " + ys.join(", ") + " }";
    }
    return String(obj);
};
function $16bb30f43bc4efef$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $16bb30f43bc4efef$var$quote(s) {
    return String(s).replace(/"/g, "&quot;");
}
function $16bb30f43bc4efef$var$isArray(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object Array]";
}
function $16bb30f43bc4efef$var$isDate(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object Date]";
}
function $16bb30f43bc4efef$var$isRegExp(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object RegExp]";
}
function $16bb30f43bc4efef$var$isError(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object Error]";
}
function $16bb30f43bc4efef$var$isSymbol(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object Symbol]";
}
function $16bb30f43bc4efef$var$isString(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object String]";
}
function $16bb30f43bc4efef$var$isNumber(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object Number]";
}
function $16bb30f43bc4efef$var$isBigInt(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object BigInt]";
}
function $16bb30f43bc4efef$var$isBoolean(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === "[object Boolean]";
}
var $16bb30f43bc4efef$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $16bb30f43bc4efef$var$has(obj, key) {
    return $16bb30f43bc4efef$var$hasOwn.call(obj, key);
}
function $16bb30f43bc4efef$var$toStr(obj) {
    return $16bb30f43bc4efef$var$objectToString.call(obj);
}
function $16bb30f43bc4efef$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $16bb30f43bc4efef$var$match.call($16bb30f43bc4efef$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $16bb30f43bc4efef$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $16bb30f43bc4efef$var$isMap(x) {
    if (!$16bb30f43bc4efef$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $16bb30f43bc4efef$var$mapSize.call(x);
        try {
            $16bb30f43bc4efef$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isWeakMap(x) {
    if (!$16bb30f43bc4efef$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $16bb30f43bc4efef$var$weakMapHas.call(x, $16bb30f43bc4efef$var$weakMapHas);
        try {
            $16bb30f43bc4efef$var$weakSetHas.call(x, $16bb30f43bc4efef$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isSet(x) {
    if (!$16bb30f43bc4efef$var$setSize || !x || typeof x !== "object") return false;
    try {
        $16bb30f43bc4efef$var$setSize.call(x);
        try {
            $16bb30f43bc4efef$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isWeakSet(x) {
    if (!$16bb30f43bc4efef$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $16bb30f43bc4efef$var$weakSetHas.call(x, $16bb30f43bc4efef$var$weakSetHas);
        try {
            $16bb30f43bc4efef$var$weakMapHas.call(x, $16bb30f43bc4efef$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $16bb30f43bc4efef$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $16bb30f43bc4efef$var$inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, $16bb30f43bc4efef$var$lowbyte);
    return $16bb30f43bc4efef$var$wrapQuotes(s, "single", opts);
}
function $16bb30f43bc4efef$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + n.toString(16);
}
function $16bb30f43bc4efef$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $16bb30f43bc4efef$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $16bb30f43bc4efef$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $16bb30f43bc4efef$var$indentedJoin(entries, indent) : entries.join(", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $16bb30f43bc4efef$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($16bb30f43bc4efef$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $16bb30f43bc4efef$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = Array(opts.indent + 1).join(" ");
    else return null;
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}
function $16bb30f43bc4efef$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + xs.join("," + lineJoiner) + "\n" + indent.prev;
}
function $16bb30f43bc4efef$var$arrObjKeys(obj, inspect) {
    var isArr = $16bb30f43bc4efef$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $16bb30f43bc4efef$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    for(var key in obj){
        if (!$16bb30f43bc4efef$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (/[^\w$]/.test(key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    return xs;
}


var $c026c6fe03bd6c23$var$$TypeError = $c45ca12aa3fcdbcc$exports("%TypeError%");
var $c026c6fe03bd6c23$var$$WeakMap = $c45ca12aa3fcdbcc$exports("%WeakMap%", true);
var $c026c6fe03bd6c23$var$$Map = $c45ca12aa3fcdbcc$exports("%Map%", true);
var $c026c6fe03bd6c23$var$$push = $420de44dd94ec21d$exports("Array.prototype.push");
var $c026c6fe03bd6c23$var$$weakMapGet = $420de44dd94ec21d$exports("WeakMap.prototype.get", true);
var $c026c6fe03bd6c23$var$$weakMapSet = $420de44dd94ec21d$exports("WeakMap.prototype.set", true);
var $c026c6fe03bd6c23$var$$weakMapHas = $420de44dd94ec21d$exports("WeakMap.prototype.has", true);
var $c026c6fe03bd6c23$var$$mapGet = $420de44dd94ec21d$exports("Map.prototype.get", true);
var $c026c6fe03bd6c23$var$$mapSet = $420de44dd94ec21d$exports("Map.prototype.set", true);
var $c026c6fe03bd6c23$var$$mapHas = $420de44dd94ec21d$exports("Map.prototype.has", true);
var $c026c6fe03bd6c23$var$objectGet = function(objects, key) {
    for(var i = 0; i < objects.length; i += 1){
        if (objects[i].key === key) return objects[i].value;
    }
};
var $c026c6fe03bd6c23$var$objectSet = function(objects, key, value) {
    for(var i = 0; i < objects.length; i += 1)if (objects[i].key === key) {
        objects[i].value = value; // eslint-disable-line no-param-reassign
        return;
    }
    $c026c6fe03bd6c23$var$$push(objects, {
        key: key,
        value: value
    });
};
var $c026c6fe03bd6c23$var$objectHas = function(objects, key) {
    for(var i = 0; i < objects.length; i += 1){
        if (objects[i].key === key) return true;
    }
    return false;
};
$c026c6fe03bd6c23$exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $c026c6fe03bd6c23$var$$TypeError("Side channel does not contain " + $16bb30f43bc4efef$exports(key));
        },
        get: function(key) {
            if ($c026c6fe03bd6c23$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $c026c6fe03bd6c23$var$$weakMapGet($wm, key);
            } else if ($c026c6fe03bd6c23$var$$Map) {
                if ($m) return $c026c6fe03bd6c23$var$$mapGet($m, key);
            } else {
                if ($o) return $c026c6fe03bd6c23$var$objectGet($o, key);
            }
        },
        has: function(key) {
            if ($c026c6fe03bd6c23$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $c026c6fe03bd6c23$var$$weakMapHas($wm, key);
            } else if ($c026c6fe03bd6c23$var$$Map) {
                if ($m) return $c026c6fe03bd6c23$var$$mapHas($m, key);
            } else {
                if ($o) return $c026c6fe03bd6c23$var$objectHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($c026c6fe03bd6c23$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $c026c6fe03bd6c23$var$$WeakMap();
                $c026c6fe03bd6c23$var$$weakMapSet($wm, key, value);
            } else if ($c026c6fe03bd6c23$var$$Map) {
                if (!$m) $m = new $c026c6fe03bd6c23$var$$Map();
                $c026c6fe03bd6c23$var$$mapSet($m, key, value);
            } else {
                if (!$o) $o = [];
                $c026c6fe03bd6c23$var$objectSet($o, key, value);
            }
        }
    };
    return channel;
};



var $hnCdG = parcelRequire("hnCdG");
var $1c0eb63673b7256d$exports = {};
"use strict";


var $b8j4z = parcelRequire("b8j4z");
var $b8c4454db49826fb$exports = {};
"use strict";

var $b8c4454db49826fb$var$canBeObject = function(obj) {
    return typeof obj !== "undefined" && obj !== null;
};

var $b8c4454db49826fb$var$hasSymbols = (parcelRequire("9WrZJ"))();

var $ghOdW = parcelRequire("ghOdW");
var $b8c4454db49826fb$var$toObject = Object;
var $b8c4454db49826fb$var$$push = $ghOdW("Array.prototype.push");
var $b8c4454db49826fb$var$$propIsEnumerable = $ghOdW("Object.prototype.propertyIsEnumerable");
var $b8c4454db49826fb$var$originalGetSymbols = $b8c4454db49826fb$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
$b8c4454db49826fb$exports = function assign(target, source1) {
    if (!$b8c4454db49826fb$var$canBeObject(target)) throw new TypeError("target must be an object");
    var objTarget = $b8c4454db49826fb$var$toObject(target);
    var s, source, i, props, syms, value, key;
    for(s = 1; s < arguments.length; ++s){
        source = $b8c4454db49826fb$var$toObject(arguments[s]);
        props = $5bfeabec85dbebc9$exports(source);
        var getSymbols = $b8c4454db49826fb$var$hasSymbols && (Object.getOwnPropertySymbols || $b8c4454db49826fb$var$originalGetSymbols);
        if (getSymbols) {
            syms = getSymbols(source);
            for(i = 0; i < syms.length; ++i){
                key = syms[i];
                if ($b8c4454db49826fb$var$$propIsEnumerable(source, key)) $b8c4454db49826fb$var$$push(props, key);
            }
        }
        for(i = 0; i < props.length; ++i){
            key = props[i];
            value = source[key];
            if ($b8c4454db49826fb$var$$propIsEnumerable(source, key)) objTarget[key] = value;
        }
    }
    return objTarget;
};


var $11dc6783bd208094$exports = {};
"use strict";

var $11dc6783bd208094$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $11dc6783bd208094$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
$11dc6783bd208094$exports = function getPolyfill() {
    if (!Object.assign) return $b8c4454db49826fb$exports;
    if ($11dc6783bd208094$var$lacksProperEnumerationOrder()) return $b8c4454db49826fb$exports;
    if ($11dc6783bd208094$var$assignHasPendingExceptions()) return $b8c4454db49826fb$exports;
    return Object.assign;
};


var $5da2cf802b6d3dde$exports = {};
"use strict";


$5da2cf802b6d3dde$exports = function shimAssign() {
    var polyfill = $11dc6783bd208094$exports();
    $73d48da9cdc0d7fb$exports(Object, {
        assign: polyfill
    }, {
        assign: function() {
            return Object.assign !== polyfill;
        }
    });
    return polyfill;
};


var $1c0eb63673b7256d$var$polyfill = $b8j4z.apply($11dc6783bd208094$exports());
// eslint-disable-next-line no-unused-vars
var $1c0eb63673b7256d$var$bound = function assign(target, source1) {
    return $1c0eb63673b7256d$var$polyfill(Object, arguments);
};
$73d48da9cdc0d7fb$exports($1c0eb63673b7256d$var$bound, {
    getPolyfill: $11dc6783bd208094$exports,
    implementation: $b8c4454db49826fb$exports,
    shim: $5da2cf802b6d3dde$exports
});
$1c0eb63673b7256d$exports = $1c0eb63673b7256d$var$bound;


var $a92a3f667b0d0758$var$$getTime = $ghOdW("Date.prototype.getTime");
var $a92a3f667b0d0758$var$gPO = Object.getPrototypeOf;
var $a92a3f667b0d0758$var$$objToString = $ghOdW("Object.prototype.toString");
var $a92a3f667b0d0758$var$$Set = $e0BBw("%Set%", true);
var $a92a3f667b0d0758$var$$mapHas = $ghOdW("Map.prototype.has", true);
var $a92a3f667b0d0758$var$$mapGet = $ghOdW("Map.prototype.get", true);
var $a92a3f667b0d0758$var$$mapSize = $ghOdW("Map.prototype.size", true);
var $a92a3f667b0d0758$var$$setAdd = $ghOdW("Set.prototype.add", true);
var $a92a3f667b0d0758$var$$setDelete = $ghOdW("Set.prototype.delete", true);
var $a92a3f667b0d0758$var$$setHas = $ghOdW("Set.prototype.has", true);
var $a92a3f667b0d0758$var$$setSize = $ghOdW("Set.prototype.size", true);
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function $a92a3f667b0d0758$var$setHasEqualElement(set, val1, opts, channel) {
    var i = $fe231cb32462bd68$exports(set);
    var result;
    while((result = i.next()) && !result.done)if ($a92a3f667b0d0758$var$internalDeepEqual(val1, result.value, opts, channel)) {
        // Remove the matching element to make sure we do not check that again.
        $a92a3f667b0d0758$var$$setDelete(set, result.value);
        return true;
    }
    return false;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function $a92a3f667b0d0758$var$findLooseMatchingPrimitives(prim) {
    if (typeof prim === "undefined") return null;
    if (typeof prim === "object") return void 0;
    if (typeof prim === "symbol") return false;
    if (typeof prim === "string" || typeof prim === "number") // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
    return true;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function $a92a3f667b0d0758$var$mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
    var altValue = $a92a3f667b0d0758$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = $a92a3f667b0d0758$var$$mapGet(b, altValue);
    var looseOpts = $1c0eb63673b7256d$exports({}, opts, {
        strict: false
    });
    if (typeof curB === "undefined" && !$a92a3f667b0d0758$var$$mapHas(b, altValue) || !$a92a3f667b0d0758$var$internalDeepEqual(item, curB, looseOpts, channel)) return false;
    // eslint-disable-next-line no-use-before-define
    return !$a92a3f667b0d0758$var$$mapHas(a, altValue) && $a92a3f667b0d0758$var$internalDeepEqual(item, curB, looseOpts, channel);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function $a92a3f667b0d0758$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $a92a3f667b0d0758$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return $a92a3f667b0d0758$var$$setHas(b, altValue) && !$a92a3f667b0d0758$var$$setHas(a, altValue);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function $a92a3f667b0d0758$var$mapHasEqualEntry(set, map, key1, item1, opts, channel) {
    var i = $fe231cb32462bd68$exports(set);
    var result;
    var key2;
    while((result = i.next()) && !result.done){
        key2 = result.value;
        if (// eslint-disable-next-line no-use-before-define
        $a92a3f667b0d0758$var$internalDeepEqual(key1, key2, opts, channel) && $a92a3f667b0d0758$var$internalDeepEqual(item1, $a92a3f667b0d0758$var$$mapGet(map, key2), opts, channel)) {
            $a92a3f667b0d0758$var$$setDelete(set, key2);
            return true;
        }
    }
    return false;
}
function $a92a3f667b0d0758$var$internalDeepEqual(actual, expected, options, channel) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $980f11be4ac6cf03$exports(actual, expected) : actual === expected) return true;
    var actualBoxed = $702e7c5c40b40607$exports(actual);
    var expectedBoxed = $702e7c5c40b40607$exports(expected);
    if (actualBoxed !== expectedBoxed) return false;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? $980f11be4ac6cf03$exports(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration
    var hasActual = channel.has(actual);
    var hasExpected = channel.has(expected);
    var sentinel;
    if (hasActual && hasExpected) {
        if (channel.get(actual) === channel.get(expected)) return true;
    } else sentinel = {};
    if (!hasActual) channel.set(actual, sentinel);
    if (!hasExpected) channel.set(expected, sentinel);
    // eslint-disable-next-line no-use-before-define
    return $a92a3f667b0d0758$var$objEquiv(actual, expected, opts, channel);
}
function $a92a3f667b0d0758$var$isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}
function $a92a3f667b0d0758$var$setEquiv(a, b, opts, channel) {
    if ($a92a3f667b0d0758$var$$setSize(a) !== $a92a3f667b0d0758$var$$setSize(b)) return false;
    var iA = $fe231cb32462bd68$exports(a);
    var iB = $fe231cb32462bd68$exports(b);
    var resultA;
    var resultB;
    var set;
    while((resultA = iA.next()) && !resultA.done){
        if (resultA.value && typeof resultA.value === "object") {
            if (!set) set = new $a92a3f667b0d0758$var$$Set();
            $a92a3f667b0d0758$var$$setAdd(set, resultA.value);
        } else if (!$a92a3f667b0d0758$var$$setHas(b, resultA.value)) {
            if (opts.strict) return false;
            if (!$a92a3f667b0d0758$var$setMightHaveLoosePrim(a, b, resultA.value)) return false;
            if (!set) set = new $a92a3f667b0d0758$var$$Set();
            $a92a3f667b0d0758$var$$setAdd(set, resultA.value);
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
            if (resultB.value && typeof resultB.value === "object") {
                if (!$a92a3f667b0d0758$var$setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
            } else if (!opts.strict && !$a92a3f667b0d0758$var$$setHas(a, resultB.value) && !$a92a3f667b0d0758$var$setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
        }
        return $a92a3f667b0d0758$var$$setSize(set) === 0;
    }
    return true;
}
function $a92a3f667b0d0758$var$mapEquiv(a, b, opts, channel) {
    if ($a92a3f667b0d0758$var$$mapSize(a) !== $a92a3f667b0d0758$var$$mapSize(b)) return false;
    var iA = $fe231cb32462bd68$exports(a);
    var iB = $fe231cb32462bd68$exports(b);
    var resultA;
    var resultB;
    var set;
    var key;
    var item1;
    var item2;
    while((resultA = iA.next()) && !resultA.done){
        key = resultA.value[0];
        item1 = resultA.value[1];
        if (key && typeof key === "object") {
            if (!set) set = new $a92a3f667b0d0758$var$$Set();
            $a92a3f667b0d0758$var$$setAdd(set, key);
        } else {
            item2 = $a92a3f667b0d0758$var$$mapGet(b, key);
            if (typeof item2 === "undefined" && !$a92a3f667b0d0758$var$$mapHas(b, key) || !$a92a3f667b0d0758$var$internalDeepEqual(item1, item2, opts, channel)) {
                if (opts.strict) return false;
                if (!$a92a3f667b0d0758$var$mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) return false;
                if (!set) set = new $a92a3f667b0d0758$var$$Set();
                $a92a3f667b0d0758$var$$setAdd(set, key);
            }
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            key = resultB.value[0];
            item2 = resultB.value[1];
            if (key && typeof key === "object") {
                if (!$a92a3f667b0d0758$var$mapHasEqualEntry(set, a, key, item2, opts, channel)) return false;
            } else if (!opts.strict && (!a.has(key) || !$a92a3f667b0d0758$var$internalDeepEqual($a92a3f667b0d0758$var$$mapGet(a, key), item2, opts, channel)) && !$a92a3f667b0d0758$var$mapHasEqualEntry(set, a, key, item2, $1c0eb63673b7256d$exports({}, opts, {
                strict: false
            }), channel)) return false;
        }
        return $a92a3f667b0d0758$var$$setSize(set) === 0;
    }
    return true;
}
function $a92a3f667b0d0758$var$objEquiv(a, b, opts, channel) {
    /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5] */ var i, key;
    if (typeof a !== typeof b) return false;
    if (a == null || b == null) return false;
    if ($a92a3f667b0d0758$var$$objToString(a) !== $a92a3f667b0d0758$var$$objToString(b)) return false;
    if ($j1gF0(a) !== $j1gF0(b)) return false;
    var aIsArray = $3c34e99f6a771855$exports(a);
    var bIsArray = $3c34e99f6a771855$exports(b);
    if (aIsArray !== bIsArray) return false;
    // TODO: replace when a cross-realm brand check is available
    var aIsError = a instanceof Error;
    var bIsError = b instanceof Error;
    if (aIsError !== bIsError) return false;
    if (aIsError || bIsError) {
        if (a.name !== b.name || a.message !== b.message) return false;
    }
    var aIsRegex = $dcae452e1a72a3d9$exports(a);
    var bIsRegex = $dcae452e1a72a3d9$exports(b);
    if (aIsRegex !== bIsRegex) return false;
    if ((aIsRegex || bIsRegex) && (a.source !== b.source || $525ee9aa37c8fd97$exports(a) !== $525ee9aa37c8fd97$exports(b))) return false;
    var aIsDate = $3ebbedfe4b065edc$exports(a);
    var bIsDate = $3ebbedfe4b065edc$exports(b);
    if (aIsDate !== bIsDate) return false;
    if (aIsDate || bIsDate) {
        if ($a92a3f667b0d0758$var$$getTime(a) !== $a92a3f667b0d0758$var$$getTime(b)) return false;
    }
    if (opts.strict && $a92a3f667b0d0758$var$gPO && $a92a3f667b0d0758$var$gPO(a) !== $a92a3f667b0d0758$var$gPO(b)) return false;
    if ($hnCdG(a) !== $hnCdG(b)) return false;
    var aIsBuffer = $a92a3f667b0d0758$var$isBuffer(a);
    var bIsBuffer = $a92a3f667b0d0758$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    var ka = $5bfeabec85dbebc9$exports(a);
    var kb = $5bfeabec85dbebc9$exports(b);
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
         // eslint-disable-line eqeqeq
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$a92a3f667b0d0758$var$internalDeepEqual(a[key], b[key], opts, channel)) return false;
    }
    var aCollection = $ac6c564be0ebc4a2$exports(a);
    var bCollection = $ac6c564be0ebc4a2$exports(b);
    if (aCollection !== bCollection) return false;
    if (aCollection === "Set" || bCollection === "Set") return $a92a3f667b0d0758$var$setEquiv(a, b, opts, channel);
    if (aCollection === "Map") return $a92a3f667b0d0758$var$mapEquiv(a, b, opts, channel);
    return true;
}
$a92a3f667b0d0758$exports = function deepEqual(a, b, opts) {
    return $a92a3f667b0d0758$var$internalDeepEqual(a, b, opts, $c026c6fe03bd6c23$exports());
};


function $fe61017513e91a25$var$defaultEqual(a, b) {
    // TODO: provide custom comparator to deepEqual
    if (typeof a === "number" && typeof b === "number") return Math.abs(a - b) < 0.00000001;
    else return (0, (/*@__PURE__*/$parcel$interopDefault($a92a3f667b0d0758$exports)))(a, b);
}
function $fe61017513e91a25$export$761dc5898ad6113c({ initialValues: initialValues, equal: equal = $fe61017513e91a25$var$defaultEqual, tests: tests }) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a92a3f667b0d0758$exports)))(initialValues(), initialValues())) throw new Error("initialValue() must return random values!");
    if (!tests.length) throw new Error("Define at least one test function");
    for (const test of tests){
        if (typeof test !== "function") throw new Error(`All tests must be functions!`);
        if (!test.name) throw new Error("All test functions must have names");
        const seed = initialValues();
        if (!equal(test(seed[test.name]), test(seed[test.name]))) throw new Error(`${test.name}() must depend only on its input (seems that it returns random results...)`);
        if (equal(test(initialValues()[test.name]), test(initialValues()[test.name]))) throw new Error(`${test.name}() must depend on its input (seems that it returns the same result regardless of that...)`);
    }
    const seed = initialValues();
    const result0 = tests[0](seed[tests[0].name]);
    for (const test of tests.slice(1)){
        const result = test(seed[test.name]);
        if (!equal(result, result0)) throw new Error(`The output of ${test.name}() must be the same as of ${tests[0].name}()`);
    }
}
const $fe61017513e91a25$var$microsecondsPerSample = 100000;
async function $fe61017513e91a25$var$quicklyDetermineRoughAverageExecutionTime(test, theInitialValue) {
    let numCycles = 32;
    let input = theInitialValue;
    while(true){
        let t0 = performance.now();
        input = theInitialValue;
        for(let i = 0; i < numCycles; i++)input = test(input);
        // Increase numCycles two-fold until execution time is more than 50ms
        const execTimeMs = performance.now() - t0;
        if (execTimeMs > 50) return execTimeMs * 1000 / numCycles // to µs
        ;
        numCycles *= 2;
        $fe61017513e91a25$var$produceSideEffect(input);
        await $fe61017513e91a25$var$sleep(1);
    }
}
async function $fe61017513e91a25$export$a88fa7c873ae4c30(input, onProgress = (status, progress)=>{}) {
    $fe61017513e91a25$export$761dc5898ad6113c(input);
    const warmupRuns = 3;
    const warmupSamples = 5;
    const measureSamples = 50;
    const totalNumSamples = input.tests.length * (warmupSamples * warmupRuns + measureSamples);
    let samplesCollected = 0;
    const cyclesPerSample = {};
    const initialValues = input.initialValues();
    for (const test of input.tests){
        onProgress(`Preparing ${test.name}()...`, 0);
        const avgTime = await $fe61017513e91a25$var$quicklyDetermineRoughAverageExecutionTime(test, initialValues[test.name]) // µs
        ;
        cyclesPerSample[test.name] = Math.ceil($fe61017513e91a25$var$microsecondsPerSample / avgTime);
    }
    for(let i = 0; i < warmupRuns; i++){
        const results = await $fe61017513e91a25$var$runSampling(input.tests, warmupSamples, cyclesPerSample, initialValues, (name, i)=>{
            onProgress(`Warming up ${name}(), sample #${i}...`, ++samplesCollected / totalNumSamples);
        });
        for (const result of results)cyclesPerSample[result.name] = $fe61017513e91a25$var$microsecondsPerSample / result.minExecutionTime;
    }
    return $fe61017513e91a25$var$runSampling(input.tests, measureSamples, cyclesPerSample, initialValues, (name, i)=>{
        onProgress(`Measuring ${name}(), sample #${i}...`, ++samplesCollected / totalNumSamples);
    });
}
async function $fe61017513e91a25$var$runSampling(tests, numSamples, cyclesPerSample, initialValues, onProgress = (name, sample)=>{}) {
    let samplesCollected = 0;
    let input = null;
    const results = [];
    for (const test of tests){
        const numCycles = cyclesPerSample[test.name];
        const executionTimes = [];
        const outputs = [];
        input = initialValues[test.name];
        for(let i = 0; i < numSamples; i++){
            let t0 = performance.now();
            for(let j = 0; j < numCycles; j++)input = test(input);
            onProgress(test.name, i);
            executionTimes.push((performance.now() - t0) * 1000 / numCycles);
            outputs.push(input);
            await $fe61017513e91a25$var$sleep(50);
        }
        results.push({
            name: test.name,
            minExecutionTime: Math.min(...executionTimes),
            executionTimes: executionTimes,
            outputs: outputs
        });
    }
    return results.sort((a, b)=>a.minExecutionTime - b.minExecutionTime);
}
function $fe61017513e91a25$var$produceSideEffect(value) {
    // @ts-ignore
    const array = globalThis.__benchmarkSideEffect || (globalThis.__benchmarkSideEffect = []);
    array.push(value);
}
function $fe61017513e91a25$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}




const $29f66100d54b5464$var$defaultTitle = "What Code Is Faster?";
let $29f66100d54b5464$var$defaultCode = `benchmark('${$29f66100d54b5464$var$defaultTitle}', function initialValue() {
  return Math.random()
}, {
  hypot(prev) {
    const a = (prev + 1) % 1
    const b = (prev - 1) % 1
    return Math.hypot(a, b);
  },
  sqrt(prev) {
    const a = (prev + 1) % 1
    const b = (prev - 1) % 1
    return Math.sqrt(a*a + b*b);
  }
})
`;
function $29f66100d54b5464$var$bytesToStr(bytes) {
    return bytes.reduce((s, n)=>s + String.fromCharCode(n), "");
}
function $29f66100d54b5464$var$compress(str) {
    const bytes = (0, $5cd34eeeac41a6e5$export$2e2bcd8739ae039).deflate(str, {
        level: 9
    });
    return btoa($29f66100d54b5464$var$bytesToStr(bytes));
}
function $29f66100d54b5464$var$decompress(base64) {
    const arr = new Uint8Array([
        ...atob(base64)
    ].map((c)=>c.charCodeAt(0)));
    return $29f66100d54b5464$var$bytesToStr((0, $5cd34eeeac41a6e5$export$2e2bcd8739ae039).inflate(arr));
}
const $29f66100d54b5464$var$codeParam = new URL(document.location.toString()).searchParams.get("code");
if ($29f66100d54b5464$var$codeParam) try {
    $29f66100d54b5464$var$defaultCode = $29f66100d54b5464$var$decompress($29f66100d54b5464$var$codeParam) || $29f66100d54b5464$var$defaultCode;
} catch (e) {
    $29f66100d54b5464$var$defaultCode = `// Failed to decode URL: ${e.toString()}`;
}
function $29f66100d54b5464$export$86fbec116b87613f() {
    const [error, setError] = (0, $jSIPP.useState)();
    const [state, setState] = (0, $jSIPP.useState)({
        title: $29f66100d54b5464$var$defaultTitle,
        benchmarkInput: null
    });
    const [progress, setProgress] = (0, $jSIPP.useState)();
    const [results, setResults] = (0, $jSIPP.useState)();
    function updateWithCode(code) {
        try {
            const urlParam = `?code=${encodeURIComponent($29f66100d54b5464$var$compress(code))}`;
            const url = window.location.href.replace(/\?code=.*$/, "");
            if ((url + urlParam).length > 2048) setError(new Error("Code is too long, won't be able to save it in the URL"));
            else history.replaceState({}, "", urlParam);
            const fn = new Function("benchmark", code);
            fn(function benchmark(name, opts, tests) {
                document.title = name;
                if (typeof opts === "function") {
                    const initialValue = opts;
                    opts = {
                        initialValues () {
                            const result = {};
                            const seed = initialValue();
                            for (const name of Object.keys(tests))result[name] = seed;
                            return result;
                        }
                    };
                }
                setState({
                    title: name,
                    benchmarkInput: (0, $7e9b970aebca32bd$export$581ff339ea0ba762)({
                        tests: Object.values(tests)
                    }, opts)
                });
            });
            setError(undefined);
        } catch (e) {
            console.error(e);
            setError(e);
        }
    }
    const handleEditorDidMount = (getCode, editor)=>{
        editor.onDidChangeModelContent(()=>{
            updateWithCode(getCode());
        });
    };
    (0, $jSIPP.useEffect)(()=>{
        updateWithCode($29f66100d54b5464$var$defaultCode);
    }, []);
    async function run() {
        try {
            if (state.benchmarkInput) {
                setResults(await (0, $fe61017513e91a25$export$a88fa7c873ae4c30)(state.benchmarkInput, (text, time)=>{
                    setProgress({
                        text: text,
                        time: time
                    });
                }));
                setProgress(undefined);
            }
        } catch (e) {
            setError(e);
        }
    }
    (0, $jSIPP.useEffect)(()=>{
        results === null || results === void 0 ? void 0 : results.forEach((r)=>console.log(r.name + " outputs:", r.outputs));
    }, [
        results
    ]);
    const longestMinExecutionTime = (0, $jSIPP.useMemo)(()=>{
        return results ? Math.max(...results.map((x)=>x.minExecutionTime)) : 0;
    }, [
        results
    ]);
    return /*#__PURE__*/ (0, $3442482cdebda331$exports.jsxs)("div", {
        className: "app",
        children: [
            /*#__PURE__*/ (0, $3442482cdebda331$exports.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("h1", {
                        children: state.title
                    }),
                    /*#__PURE__*/ (0, $3442482cdebda331$exports.jsxs)("div", {
                        className: "menu",
                        children: [
                            /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("a", {
                                href: "https://github.com/xpl/what-code-is-faster#how-does-it-work",
                                children: "README.md"
                            }),
                            /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("a", {
                                href: "https://github.com/xpl/what-code-is-faster#examples",
                                children: "Examples"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c029b53b9555391a$exports))), {
                        namespace: "xpl",
                        repo: "what-code-is-faster",
                        size: "large",
                        type: "stargazers"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("div", {
                className: "editor",
                children: /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iOWL4))), {
                    language: "javascript",
                    editorDidMount: handleEditorDidMount,
                    options: {
                        automaticLayout: true,
                        minimap: {
                            enabled: false
                        }
                    },
                    value: $29f66100d54b5464$var$defaultCode
                })
            }),
            progress && progress.time > 0 && /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("div", {
                className: "progress",
                style: {
                    "--length": progress.time
                }
            }),
            error && /*#__PURE__*/ (0, $3442482cdebda331$exports.jsxs)("div", {
                className: "error",
                children: [
                    error.constructor.name,
                    ": ",
                    error.message
                ]
            }),
            results && /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("table", {
                className: "results",
                children: /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("tbody", {
                    children: results.map((result, i)=>/*#__PURE__*/ (0, $3442482cdebda331$exports.jsxs)("tr", {
                            className: "result",
                            children: [
                                /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("td", {
                                    className: "name",
                                    children: result.name
                                }),
                                /*#__PURE__*/ (0, $3442482cdebda331$exports.jsxs)("td", {
                                    className: "time",
                                    children: [
                                        result.minExecutionTime.toFixed(4),
                                        " \xb5s"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("td", {
                                    className: "bar",
                                    style: {
                                        "--color": i / (results.length - 1),
                                        "--length": result.minExecutionTime / longestMinExecutionTime
                                    }
                                })
                            ]
                        }))
                })
            }),
            /*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)("button", {
                className: "run-me",
                disabled: Boolean(progress || error),
                onClick: run,
                children: progress ? progress.text : "Let's find out!"
            })
        ]
    });
}


(0, $3ab9800416b64e29$exports.render)(/*#__PURE__*/ (0, $3442482cdebda331$exports.jsx)((0, $29f66100d54b5464$export$86fbec116b87613f), {}), document.getElementById("root"));


//# sourceMappingURL=index.58841d4b.js.map
